"use strict";

function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
// data/scenarios.js

// --- MATH HELPERS (Ensure availability if generators.js didn't load first) ---
if (typeof window.getRandomInt !== 'function') {
  window.getRandomInt = function (min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  };
}
window.RAW_SCENARIOS = [{
  id: 'AM001',
  title: 'Acute STEMI',
  category: 'Medical',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(45, 75);
  },
  patientProfileTemplate: "A {age}-year-old {sex}. Crushing chest pain > 1 hr.",
  presentingComplaint: 'Chest Pain',
  instructorBrief: {
    progression: "Classic STEMI. Risk of VF.",
    interventions: ["PPCI", "Aspirin", "Ticagrelor/Clopidogrel", "Heparin"],
    learningObjectives: ["Identify STEMI", "Manage ACS"]
  },
  vitalsMod: {
    hr: 95,
    bpSys: 145,
    spO2: 96
  },
  deterioration: {
    active: true,
    rate: 0.05,
    type: 'cardiac'
  },
  ecg: {
    type: "STEMI",
    findings: "Anterior ST Elevation"
  },
  recommendedActions: ['Obs', 'IV Access', 'Aspirin', 'Clopidogrel', 'GTN', 'Analgesia', 'Oxygen']
}, {
  id: 'AM002',
  title: 'Severe Sepsis (Pneumonia)',
  category: 'Medical',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(60, 90);
  },
  patientProfileTemplate: "A {age}-year-old. Productive cough, confusion, fever.",
  presentingComplaint: 'Confusion & Fever',
  instructorBrief: {
    progression: "Septic shock. Needs Sepsis 6.",
    interventions: ["Oxygen", "Fluids", "Antibiotics"],
    learningObjectives: ["Sepsis 6", "Fluid Resus"]
  },
  vitalsMod: {
    hr: 125,
    bpSys: 85,
    spO2: 88,
    temp: 39.2
  },
  deterioration: {
    active: true,
    rate: 0.1,
    type: 'shock'
  },
  ecg: {
    type: "Sinus Tachy",
    findings: "Sinus Tachycardia"
  },
  recommendedActions: ['Obs', 'IV Access', 'Oxygen', 'Fluids', 'Antibiotics']
}, {
  id: 'AM003',
  title: 'Acute Severe Asthma',
  category: 'Medical',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(18, 40);
  },
  patientProfileTemplate: "A {age}-year-old asthmatic. Short of breath.",
  presentingComplaint: 'Dyspnoea',
  instructorBrief: {
    progression: "Life threatening. Silent chest.",
    interventions: ["Nebs", "Magnesium", "Steroids"],
    learningObjectives: ["Asthma Management"]
  },
  vitalsMod: {
    hr: 130,
    bpSys: 110,
    spO2: 88,
    rr: 35
  },
  deterioration: {
    active: true,
    rate: 0.08,
    type: 'respiratory'
  },
  stabilisers: ['Nebs', 'Magnesium'],
  ecg: {
    type: "Sinus Tachy",
    findings: "Sinus Tachycardia"
  },
  recommendedActions: ['Obs', 'IV Access', 'Oxygen', 'Nebs', 'Dexamethasone', 'MagSulph']
}, {
  id: 'AM004',
  title: 'Hyperkalaemia (Renal)',
  category: 'Medical',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(50, 80);
  },
  patientProfileTemplate: "A {age}-year-old dialysis patient. Missed dialysis.",
  presentingComplaint: 'Weakness',
  instructorBrief: {
    progression: "Broad complex bradycardia. Risk of arrest.",
    interventions: ["Calcium Gluconate", "Insulin/Dextrose"],
    learningObjectives: ["Hyperkalaemia treatment"]
  },
  vitalsMod: {
    hr: 40,
    bpSys: 90,
    spO2: 95
  },
  deterioration: {
    active: true,
    rate: 0.1,
    type: 'cardiac'
  },
  ecg: {
    type: "Hyperkalaemia",
    findings: "Broad complex, Tented T waves"
  },
  vbgClinicalState: "hyperkalemia",
  recommendedActions: ['Obs', 'IV Access', 'Calcium', 'InsulinDextrose', 'Nebs']
}, {
  id: 'AM011',
  title: 'Acute Pulmonary Oedema',
  category: 'Medical',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(65, 85);
  },
  patientProfileTemplate: "A {age}-year-old with heart failure history. Sudden onset severe breathlessness.",
  presentingComplaint: 'Severe Dyspnoea',
  instructorBrief: {
    progression: "Flash pulmonary oedema. Severe respiratory distress.",
    interventions: ["GTN (SL/IV)", "Furosemide", "CPAP"],
    learningObjectives: ["Manage acute heart failure", "CPAP Indications"]
  },
  vitalsMod: {
    hr: 110,
    bpSys: 180,
    spO2: 85,
    rr: 32
  },
  deterioration: {
    active: true,
    rate: 0.1,
    type: 'respiratory'
  },
  stabilisers: ['GTN', 'GTNInfusion', 'CPAP', 'Furosemide'],
  ecg: {
    type: "Sinus Tachy",
    findings: "Sinus Tachy, LVH"
  },
  recommendedActions: ['Obs', 'IV Access', 'Oxygen', 'CPAP', 'GTN', 'Furosemide']
}, {
  id: 'AM012',
  title: 'COPD Exacerbation (Infective)',
  category: 'Medical',
  ageRange: 'Adult',
  acuity: 'Majors',
  ageGenerator: function ageGenerator() {
    return getRandomInt(55, 80);
  },
  patientProfileTemplate: "A {age}-year-old smoker. 3 days productive cough and increasing wheeze.",
  presentingComplaint: 'Wheeze & DIB',
  instructorBrief: {
    progression: "Type 2 Respiratory Failure. CO2 retainer.",
    interventions: ["Nebs (Air)", "Steroids", "Antibiotics", "Consider NIV"],
    learningObjectives: ["Oxygen targets in COPD", "NIV indications"]
  },
  vitalsMod: {
    hr: 100,
    bpSys: 130,
    spO2: 84,
    rr: 28
  },
  deterioration: {
    active: true,
    rate: 0.05,
    type: 'respiratory'
  },
  stabilisers: ['Nebs', 'Dexamethasone', 'NIV'],
  vbgClinicalState: "copd_retainer",
  recommendedActions: ['Obs', 'IV Access', 'Nebs', 'Dexamethasone', 'Antibiotics', 'NIV']
}, {
  id: 'AM013',
  title: 'Diabetic Ketoacidosis (DKA)',
  category: 'Medical',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(18, 35);
  },
  patientProfileTemplate: "A {age}-year-old Type 1 Diabetic. Vomiting and abdo pain for 24hrs.",
  presentingComplaint: 'Vomiting & Abdo Pain',
  instructorBrief: {
    progression: "Severe metabolic acidosis. Dehydration.",
    interventions: ["Fluids (0.9% Saline)", "Fixed Rate Insulin", "Potassium Replacement"],
    learningObjectives: ["DKA Protocol", "Fluid management"]
  },
  vitalsMod: {
    hr: 115,
    bpSys: 100,
    spO2: 97,
    rr: 28,
    bm: 26
  },
  deterioration: {
    active: true,
    rate: 0.05,
    type: 'shock'
  },
  stabilisers: ['Fluids'],
  vbgClinicalState: "dka_severe",
  recommendedActions: ['Obs', 'IV Access', 'Fluids', 'InsulinInfusion']
}, {
  id: 'AM014',
  title: 'HHS',
  category: 'Medical',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(60, 85);
  },
  patientProfileTemplate: "A {age}-year-old Type 2 Diabetic. Confused and lethargic over 1 week.",
  presentingComplaint: 'Confusion',
  instructorBrief: {
    progression: "Severe dehydration and hyperosmolality.",
    interventions: ["Aggressive Fluids", "Conservative Insulin", "LMWH"],
    learningObjectives: ["HHS vs DKA", "Osmolality"]
  },
  vitalsMod: {
    hr: 110,
    bpSys: 95,
    spO2: 94,
    rr: 20,
    gcs: 12,
    bm: 48
  },
  deterioration: {
    active: true,
    rate: 0.05,
    type: 'shock'
  },
  stabilisers: ['Fluids'],
  vbgClinicalState: "hhs",
  recommendedActions: ['Obs', 'IV Access', 'Fluids', 'InsulinInfusion', 'Heparin']
}, {
  id: 'AM015',
  title: 'Massive Pulmonary Embolism',
  category: 'Medical',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(30, 65);
  },
  patientProfileTemplate: "A {age}-year-old. Recent long haul flight. Sudden collapse and chest pain.",
  presentingComplaint: 'Collapse & SOB',
  instructorBrief: {
    progression: "Obstructive shock. Peri-arrest.",
    interventions: ["Thrombolysis", "Oxygen", "Fluid (Cautious)"],
    learningObjectives: ["Massive PE recognition", "Thrombolysis indications"]
  },
  vitalsMod: {
    hr: 135,
    bpSys: 80,
    spO2: 82,
    rr: 30
  },
  deterioration: {
    active: true,
    rate: 0.15,
    type: 'shock'
  },
  stabilisers: ['Oxygen'],
  ecg: {
    type: "Sinus Tachy",
    findings: "Sinus Tachy, S1Q3T3, RBBB"
  },
  recommendedActions: ['Obs', 'IV Access', 'Oxygen', 'Fluids', 'Thrombolysis']
}, {
  id: 'AM016',
  title: 'Upper GI Bleed (Variceal)',
  category: 'Medical',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(40, 65);
  },
  patientProfileTemplate: "A {age}-year-old with chronic liver disease. Vomiting large amounts of fresh blood.",
  presentingComplaint: 'Haematemesis',
  instructorBrief: {
    progression: "Haemorrhagic shock. Airway risk.",
    interventions: ["Blood Protocol", "Terlipressin", "Antibiotics", "Intubation"],
    learningObjectives: ["Major Haemorrhage Protocol", "Variceal bleed management"]
  },
  vitalsMod: {
    hr: 125,
    bpSys: 85,
    spO2: 95,
    rr: 22
  },
  deterioration: {
    active: true,
    rate: 0.15,
    type: 'shock'
  },
  stabilisers: ['Blood'],
  vbgClinicalState: "gi_bleed",
  recommendedActions: ['Obs', 'IV Access', 'Blood', 'Antibiotics', 'Terlipressin', 'RSI']
}, {
  id: 'AM017',
  title: 'Bacterial Meningitis',
  category: 'Medical',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(18, 30);
  },
  patientProfileTemplate: "A {age}-year-old student. Severe headache, photophobia, and non-blanching rash.",
  presentingComplaint: 'Headache & Rash',
  instructorBrief: {
    progression: "Septic shock and raised ICP.",
    interventions: ["IV Ceftriaxone", "Dexamethasone", "Fluids"],
    learningObjectives: ["Meningitis recognition", "Lumbar Puncture contraindications", "Give antibiotics within 1 hour"]
  },
  vitalsMod: {
    hr: 120,
    bpSys: 100,
    spO2: 98,
    temp: 39.5,
    gcs: 13
  },
  deterioration: {
    active: true,
    rate: 0.1,
    type: 'neuro'
  },
  stabilisers: ['Ceftriaxone', 'Dexamethasone', 'Fluids'],
  recommendedActions: ['Obs', 'IV Access', 'Oxygen', 'Ceftriaxone', 'Dexamethasone', 'Fluids']
}, {
  id: 'AM018',
  title: 'Addisonian Crisis',
  category: 'Medical',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(30, 60);
  },
  patientProfileTemplate: "A {age}-year-old. Known Addison's. Vomiting for 2 days. Stopped steroids.",
  presentingComplaint: 'Collapse',
  instructorBrief: {
    progression: "Distributive shock. Hypoglycaemia risk.",
    interventions: ["IV Hydrocortisone", "Fluids (Saline)", "Dextrose"],
    learningObjectives: ["Adrenal crisis management", "Steroid sick days"]
  },
  vitalsMod: {
    hr: 115,
    bpSys: 80,
    spO2: 96,
    bm: 3.2
  },
  deterioration: {
    active: true,
    rate: 0.1,
    type: 'shock'
  },
  stabilisers: ['Fluids'],
  vbgClinicalState: "hyponatremia",
  recommendedActions: ['Obs', 'IV Access', 'Fluids', 'Hydrocortisone', 'Dextrose']
}, {
  id: 'AM019',
  title: 'Thyrotoxic Storm',
  category: 'Medical',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(20, 50);
  },
  patientProfileTemplate: "A {age}-year-old. Agitated, sweating profusely, palpitations.",
  presentingComplaint: 'Palpitations & Confusion',
  instructorBrief: {
    progression: "High output cardiac failure. Hyperthermia.",
    interventions: ["Beta-blockers", "Fluids", "Cooling", "Carbimazole"],
    learningObjectives: ["Thyroid storm recognition", "Burch-Wartofsky score"]
  },
  vitalsMod: {
    hr: 150,
    bpSys: 160,
    spO2: 96,
    temp: 39.8
  },
  deterioration: {
    active: true,
    rate: 0.1,
    type: 'cardiac'
  },
  ecg: {
    type: "AF",
    findings: "Fast AF"
  },
  recommendedActions: ['Obs', 'IV Access', 'Fluids', 'Labetalol', 'Hydrocortisone', 'Cooling']
}, {
  id: 'AM020',
  title: 'Subarachnoid Haemorrhage',
  category: 'Medical',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(40, 60);
  },
  patientProfileTemplate: "A {age}-year-old. Sudden onset occipital headache 'like being hit with a bat'.",
  presentingComplaint: 'Thunderclap Headache',
  instructorBrief: {
    progression: "Risk of re-bleed and hydrocephalus. Cushing's response.",
    interventions: ["CT Head", "Nimodipine", "BP Control", "Neuro Obs"],
    learningObjectives: ["SAH presentation", "Cushing's Triad"]
  },
  vitalsMod: {
    hr: 55,
    bpSys: 170,
    spO2: 98,
    gcs: 14
  },
  deterioration: {
    active: true,
    rate: 0.05,
    type: 'neuro'
  },
  stabilisers: ['Analgesia'],
  recommendedActions: ['Obs', 'IV Access', 'Analgesia', 'Labetalol', 'Nimodipine']
}, {
  id: 'AM021',
  title: 'Acute Ischaemic Stroke',
  category: 'Medical',
  ageRange: 'Adult',
  acuity: 'Majors',
  ageGenerator: function ageGenerator() {
    return getRandomInt(55, 80);
  },
  patientProfileTemplate: "A {age}-year-old. Sudden onset right sided weakness and slurred speech 1 hour ago.",
  presentingComplaint: 'Stroke Symptoms',
  instructorBrief: {
    progression: "Time critical. Thrombolysis candidate.",
    interventions: ["CT Head", "Thrombolysis (if bleed excluded)", "BP Control"],
    learningObjectives: ["FAST positive", "Thrombolysis window"]
  },
  vitalsMod: {
    hr: 80,
    bpSys: 165,
    spO2: 96,
    gcs: 13
  },
  deterioration: {
    active: true,
    rate: 0.05,
    type: 'neuro'
  },
  recommendedActions: ['Obs', 'IV Access', 'CheckGlucose', 'Thrombolysis']
}, {
  id: 'AM022',
  title: 'Status Epilepticus (Adult)',
  category: 'Medical',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(20, 50);
  },
  patientProfileTemplate: "A {age}-year-old. Seizing for 15 minutes.",
  presentingComplaint: 'Seizure',
  instructorBrief: {
    progression: "Exhaustion and hypoxia. Refractory status.",
    interventions: ["Benzodiazepines (Lorazepam)", "Phenytoin/Levetiracetam", "RSI"],
    learningObjectives: ["Status epilepticus algorithm"]
  },
  vitalsMod: {
    hr: 130,
    bpSys: 140,
    spO2: 88,
    rr: 10,
    gcs: 3
  },
  deterioration: {
    active: true,
    rate: 0.1,
    type: 'neuro'
  },
  stabilisers: ['Lorazepam', 'RSI', 'Oxygen'],
  recommendedActions: ['Obs', 'IV Access', 'Oxygen', 'Lorazepam', 'RSI']
}, {
  id: 'AM023',
  title: 'Complete Heart Block',
  category: 'Medical',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(60, 90);
  },
  patientProfileTemplate: "A {age}-year-old. Collapsed. Feeling dizzy.",
  presentingComplaint: 'Syncope',
  instructorBrief: {
    progression: "Unstable bradycardia. Risk of asystole.",
    interventions: ["Atropine (Likely ineffective)", "Pacing (External)", "Isoprenaline"],
    learningObjectives: ["Bradycardia algorithm", "Pacing indications"]
  },
  vitalsMod: {
    hr: 32,
    bpSys: 75,
    spO2: 94
  },
  deterioration: {
    active: true,
    rate: 0.1,
    type: 'cardiac'
  },
  stabilisers: ['Pacing', 'Metaraminol'],
  ecg: {
    type: "Complete Heart Block",
    findings: "3rd Degree AV Block (Dissociation)"
  },
  recommendedActions: ['Obs', 'IV Access', 'Atropine', 'Pacing', 'Metaraminol']
}, {
  id: 'AM024',
  title: 'VT with Pulse',
  category: 'Medical',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(50, 75);
  },
  patientProfileTemplate: "A {age}-year-old. Palpitations and chest tightness.",
  presentingComplaint: 'Palpitations',
  instructorBrief: {
    progression: "Unstable broad complex tachycardia.",
    interventions: ["Synchronised Cardioversion", "Amiodarone"],
    learningObjectives: ["Tachycardia algorithm", "Safe cardioversion"]
  },
  vitalsMod: {
    hr: 170,
    bpSys: 90,
    spO2: 95
  },
  deterioration: {
    active: true,
    rate: 0.1,
    type: 'cardiac'
  },
  stabilisers: ['Amiodarone', 'Cardioversion'],
  ecg: {
    type: "VT",
    findings: "Monomorphic VT"
  },
  recommendedActions: ['Obs', 'IV Access', 'Amiodarone', 'Cardioversion']
}, {
  id: 'AM025',
  title: 'SVT (Adult)',
  category: 'Medical',
  ageRange: 'Adult',
  acuity: 'Majors',
  ageGenerator: function ageGenerator() {
    return getRandomInt(20, 40);
  },
  patientProfileTemplate: "A {age}-year-old. Sudden onset racing heart.",
  presentingComplaint: 'Palpitations',
  instructorBrief: {
    progression: "Narrow complex tachycardia.",
    interventions: ["Vagal Manoeuvres", "Adenosine"],
    learningObjectives: ["Adenosine administration", "ECG recognition"]
  },
  vitalsMod: {
    hr: 190,
    bpSys: 110,
    spO2: 98
  },
  deterioration: {
    active: false,
    rate: 0
  },
  stabilisers: ['Adenosine'],
  ecg: {
    type: "SVT",
    findings: "SVT"
  },
  recommendedActions: ['Obs', 'IV Access', 'VagalManoeuvre', 'Adenosine']
}, {
  id: 'AM026',
  title: 'Anaphylaxis (Adult)',
  category: 'Medical',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(20, 50);
  },
  patientProfileTemplate: "A {age}-year-old. Bee sting. Swollen face and difficulty breathing.",
  presentingComplaint: 'Anaphylaxis',
  instructorBrief: {
    progression: "Airway swelling and shock.",
    interventions: ["IM Adrenaline", "Fluids", "Nebs"],
    learningObjectives: ["Anaphylaxis algorithm"]
  },
  vitalsMod: {
    hr: 130,
    bpSys: 80,
    spO2: 90,
    rr: 30
  },
  deterioration: {
    active: true,
    rate: 0.15,
    type: 'shock'
  },
  stabilisers: ['AdrenalineIM', 'Fluids', 'Nebs'],
  recommendedActions: ['Obs', 'IV Access', 'Oxygen', 'AdrenalineIM', 'Fluids', 'Nebs']
}, {
  id: 'AM027',
  title: 'Aortic Dissection (Type A)',
  category: 'Medical',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(50, 75);
  },
  patientProfileTemplate: "A {age}-year-old. Tearing chest pain radiating to back.",
  presentingComplaint: 'Chest Pain',
  instructorBrief: {
    progression: "Hypertensive emergency. Risk of rupture.",
    interventions: ["BP Control (Labetalol)", "Analgesia", "CT Aorta"],
    learningObjectives: ["Dissection recognition", "BP targets"]
  },
  vitalsMod: {
    hr: 100,
    bpSys: 190,
    spO2: 98
  },
  deterioration: {
    active: true,
    rate: 0.1,
    type: 'shock'
  },
  stabilisers: ['Labetalol', 'Analgesia'],
  ecg: {
    type: "Sinus Rhythm",
    findings: "NSR"
  },
  recommendedActions: ['Obs', 'IV Access', 'Labetalol', 'Analgesia', 'Surgery']
}, {
  id: 'AM028',
  title: 'Severe Hyponatraemia',
  category: 'Medical',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(60, 85);
  },
  patientProfileTemplate: "A {age}-year-old. Confused and vomiting. On diuretics.",
  presentingComplaint: 'Confusion',
  instructorBrief: {
    progression: "Cerebral oedema and seizures.",
    interventions: ["Hypertonic Saline (if seizing)", "Fluid Restriction"],
    learningObjectives: ["Hyponatraemia correction", "Seizure management"]
  },
  vitalsMod: {
    hr: 90,
    bpSys: 130,
    spO2: 96,
    gcs: 11
  },
  deterioration: {
    active: true,
    rate: 0.05,
    type: 'neuro'
  },
  vbgClinicalState: "hyponatremia",
  recommendedActions: ['Obs', 'IV Access', 'HypertonicSaline']
}, {
  id: 'AM029',
  title: 'Ascending Cholangitis',
  category: 'Medical',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(50, 80);
  },
  patientProfileTemplate: "A {age}-year-old. RUQ pain, fever, and rigors.",
  presentingComplaint: 'Abdo Pain & Fever',
  instructorBrief: {
    progression: "Biliary sepsis (Charcot's Triad).",
    interventions: ["Antibiotics", "Fluids", "Surgical/ERCP referral"],
    learningObjectives: ["Sepsis Source", "Charcot's Triad"]
  },
  vitalsMod: {
    hr: 120,
    bpSys: 95,
    spO2: 95,
    temp: 39.0
  },
  deterioration: {
    active: true,
    rate: 0.1,
    type: 'shock'
  },
  stabilisers: ['Antibiotics', 'Fluids'],
  vbgClinicalState: "septic_shock",
  recommendedActions: ['Obs', 'IV Access', 'Antibiotics', 'Fluids', 'Analgesia', 'Surgery']
}, {
  id: 'AM030',
  title: 'Community Acquired Pneumonia',
  category: 'Medical',
  ageRange: 'Adult',
  acuity: 'Majors',
  ageGenerator: function ageGenerator() {
    return getRandomInt(30, 70);
  },
  patientProfileTemplate: "A {age}-year-old. 1 week cough, now breathless.",
  presentingComplaint: 'Cough & DIB',
  instructorBrief: {
    progression: "Type 1 Respiratory failure.",
    interventions: ["Oxygen", "Antibiotics", "Fluids"],
    learningObjectives: ["CURB-65", "Oxygen therapy"]
  },
  vitalsMod: {
    hr: 110,
    bpSys: 115,
    spO2: 88,
    rr: 28,
    temp: 38.5
  },
  deterioration: {
    active: true,
    rate: 0.05,
    type: 'respiratory'
  },
  stabilisers: ['Antibiotics', 'Oxygen'],
  recommendedActions: ['Obs', 'IV Access', 'Antibiotics', 'Oxygen', 'Fluids']
}, {
  id: 'AM031',
  title: 'Tension Pneumothorax',
  category: 'Medical',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(20, 40);
  },
  patientProfileTemplate: "A {age}-year-old. Sudden onset pleuritic pain and severe breathlessness. History of Marfan's.",
  presentingComplaint: 'Severe Dyspnoea',
  instructorBrief: {
    progression: "Obstructive shock. Tracheal deviation.",
    interventions: ["Needle Decompression", "Chest Drain"],
    learningObjectives: ["Needle Thoracocentesis location", "Obstructive Shock signs"]
  },
  vitalsMod: {
    hr: 135,
    bpSys: 75,
    spO2: 82,
    rr: 38
  },
  deterioration: {
    active: true,
    rate: 0.15,
    type: 'shock'
  },
  stabilisers: ['Needle', 'SeldingerDrain', 'FingerThoracostomy'],
  ecg: {
    type: "Sinus Tachy",
    findings: "Sinus Tachycardia"
  },
  recommendedActions: ['Obs', 'IV Access', 'Oxygen', 'Needle', 'FingerThoracostomy', 'SurgicalDrain']
}, {
  id: 'AM032',
  title: 'Myxoedema Coma',
  category: 'Medical',
  sex: 'Female',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(60, 85);
  },
  patientProfileTemplate: "A {age}-year-old female. Found confused and cold. History of hypothyroidism.",
  presentingComplaint: 'Confusion & Hypothermia',
  instructorBrief: {
    progression: "Profound bradycardia and hypothermia.",
    interventions: ["T3/T4 (Liothyronine)", "Steroids", "Passive Warming"],
    learningObjectives: ["Myxoedema recognition", "Warming caution"]
  },
  vitalsMod: {
    hr: 38,
    bpSys: 85,
    spO2: 92,
    temp: 34.2,
    gcs: 10
  },
  deterioration: {
    active: true,
    rate: 0.05,
    type: 'cardiac'
  },
  stabilisers: ['T3T4', 'Hydrocortisone'],
  ecg: {
    type: "Sinus Brady",
    findings: "Sinus Brady, Low Voltage"
  },
  recommendedActions: ['Obs', 'IV Access', 'T3T4', 'Hydrocortisone']
}, {
  id: 'AM033',
  title: 'Severe Hypercalcaemia',
  category: 'Medical',
  ageRange: 'Adult',
  acuity: 'Majors',
  ageGenerator: function ageGenerator() {
    return getRandomInt(50, 80);
  },
  patientProfileTemplate: "A {age}-year-old. 'Bones, stones, groans'. Profound dehydration and confusion.",
  presentingComplaint: 'Confusion',
  instructorBrief: {
    progression: "Renal failure and arrhythmia risk.",
    interventions: ["Aggressive Fluids", "Bisphosphonates"],
    learningObjectives: ["Hypercalcaemia management", "Fluid targets"]
  },
  vitalsMod: {
    hr: 95,
    bpSys: 100,
    spO2: 96,
    gcs: 13
  },
  deterioration: {
    active: true,
    rate: 0.05,
    type: 'neuro'
  },
  stabilisers: ['Fluids', 'Bisphosphonate'],
  vbgClinicalState: "hypercalcemia",
  recommendedActions: ['Obs', 'IV Access', 'Fluids', 'Bisphosphonate']
}, {
  id: 'AM034',
  title: 'Boerhaave\'s Syndrome',
  category: 'Medical',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(40, 60);
  },
  patientProfileTemplate: "A {age}-year-old. Severe vomiting after alcohol binge, then sudden tearing chest pain.",
  presentingComplaint: 'Chest Pain',
  instructorBrief: {
    progression: "Mackler's Triad. Sepsis/Mediastinitis.",
    interventions: ["Antibiotics", "Fluids", "Surgical Referral"],
    learningObjectives: ["Oesophageal rupture signs", "Mackler's Triad"]
  },
  vitalsMod: {
    hr: 120,
    bpSys: 100,
    spO2: 94,
    rr: 28
  },
  deterioration: {
    active: true,
    rate: 0.1,
    type: 'shock'
  },
  stabilisers: ['Antibiotics', 'Fluids', 'Surgery'],
  recommendedActions: ['Obs', 'IV Access', 'Antibiotics', 'Fluids', 'Surgery', 'Analgesia']
}, {
  id: 'AM035',
  title: 'CO Poisoning',
  category: 'Medical',
  ageRange: 'Adult',
  acuity: 'Majors',
  ageGenerator: function ageGenerator() {
    return getRandomInt(20, 80);
  },
  patientProfileTemplate: "A {age}-year-old. Found in garage with car running. Headache and nausea.",
  presentingComplaint: 'Headache',
  instructorBrief: {
    progression: "False SpO2 reading. Neuro toxicity.",
    interventions: ["High Flow Oxygen until COHb is back to normal (1-2%)", "Observe at least 4 hours", "Hyperbaric oxygen: not currently recommended by NPIS"],
    learningObjectives: ["CO half-life", "SpO2 limitations", "Give high-flow oxygen"]
  },
  vitalsMod: {
    hr: 105,
    bpSys: 130,
    spO2: 100,
    rr: 20,
    gcs: 14
  },
  deterioration: {
    active: true,
    rate: 0.05,
    type: 'neuro'
  },
  stabilisers: ['Oxygen'],
  vbgClinicalState: "co_poisoning",
  recommendedActions: ['Obs', 'IV Access', 'Oxygen']
}, {
  id: 'AM036',
  title: 'Serotonin Syndrome',
  category: 'Medical',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(20, 40);
  },
  patientProfileTemplate: "A {age}-year-old. Started new antidepressant. Agitated, hyperthermic, clonus.",
  presentingComplaint: 'Agitation',
  instructorBrief: {
    progression: "Hyperthermia and rhabdomyolysis.",
    interventions: ["Benzodiazepines", "Cooling", "Cyproheptadine"],
    learningObjectives: ["Serotonin toxicity criteria", "Cooling methods"]
  },
  vitalsMod: {
    hr: 140,
    bpSys: 160,
    spO2: 96,
    temp: 39.5,
    gcs: 13
  },
  deterioration: {
    active: true,
    rate: 0.1,
    type: 'neuro'
  },
  stabilisers: ['Midazolam', 'Lorazepam', 'Cooling'],
  recommendedActions: ['Obs', 'IV Access', 'Lorazepam', 'Midazolam', 'Cooling', 'Fluids', 'Cyproheptadine']
}, {
  id: 'AM037',
  title: 'Cholinergic Crisis',
  category: 'Toxicology',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(30, 60);
  },
  patientProfileTemplate: "A {age}-year-old farmer. Found collapsed near pesticides. SLUDGE symptoms.",
  presentingComplaint: 'Collapse & Salivation',
  instructorBrief: {
    progression: "Bradycardia, Bronchorrhoea. Organophosphate poisoning. TOXBASE: atropine about 3 mg IV in a severely poisoned adult (0.6-1 mg if conscious and well), doubled every 5 minutes until atropinised (clear chest, HR above 80, systolic above 80; pupils are not an endpoint), then an infusion of about 20% of the total bolus dose per hour. Pralidoxime 30 mg/kg IV over 30 minutes then 8 mg/kg/h for everyone needing atropine. Avoid suxamethonium. Watch for neck flexion weakness (intermediate syndrome).",
    interventions: ["Atropine (High Dose)", "Pralidoxime"],
    learningObjectives: ["SLUDGE mnemonic", "Atropine dosing"]
  },
  vitalsMod: {
    hr: 45,
    bpSys: 90,
    spO2: 88,
    rr: 28,
    pupils: "Pinpoint"
  },
  deterioration: {
    active: true,
    rate: 0.1,
    type: 'respiratory'
  },
  stabilisers: ['Atropine'],
  recommendedActions: ['Obs', 'IV Access', 'Atropine', 'Suction', 'Oxygen', 'Pralidoxime']
}, {
  id: 'AM038',
  title: 'Guillain-Barré Syndrome',
  category: 'Medical',
  ageRange: 'Adult',
  acuity: 'Majors',
  ageGenerator: function ageGenerator() {
    return getRandomInt(30, 70);
  },
  patientProfileTemplate: "A {age}-year-old. 2 weeks post viral illness. Ascending weakness/paraesthesia.",
  presentingComplaint: 'Weakness',
  instructorBrief: {
    progression: "Respiratory failure due to diaphragm weakness.",
    interventions: ["FVC Monitoring", "Intubation (Early)"],
    learningObjectives: ["GBS recognition", "Respiratory monitoring"]
  },
  vitalsMod: {
    hr: 80,
    bpSys: 130,
    spO2: 95,
    rr: 14
  },
  deterioration: {
    active: true,
    rate: 0.05,
    type: 'respiratory'
  },
  recommendedActions: ['Obs', 'IV Access', 'RSI']
}, {
  id: 'AM005',
  title: 'Tricyclic Overdose',
  category: 'Toxicology',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(20, 50);
  },
  patientProfileTemplate: "A {age}-year-old. Found with empty Amitriptyline packet.",
  presentingComplaint: 'Overdose',
  instructorBrief: {
    progression: "Anticholinergic toxidrome. Na channel blockade. TOXBASE: 50 mmol 8.4% bicarbonate for QRS 120-160 ms, 100 mmol if QRS 160 ms or more, VT or arrest; repeat to pH 7.5-7.55. Benzodiazepines for seizures, avoid phenytoin. In arrest give bicarbonate and continue CPR for at least 1 hour.",
    interventions: ["Sodium Bicarbonate", "Intubation"],
    learningObjectives: ["TCA Toxicity", "ECG changes"]
  },
  vitalsMod: {
    hr: 130,
    bpSys: 90,
    spO2: 96,
    gcs: 10
  },
  deterioration: {
    active: true,
    rate: 0.1,
    type: 'neuro'
  },
  ecg: {
    type: "Sinus Tachy",
    findings: "Wide QRS, Dominant R in aVR"
  },
  recommendedActions: ['Obs', 'IV Access', 'Fluids', 'RSI', 'SodiumBicarb']
}, {
  id: 'AM006',
  title: 'Opioid Overdose',
  category: 'Toxicology',
  ageRange: 'Adult',
  acuity: 'Majors',
  ageGenerator: function ageGenerator() {
    return getRandomInt(20, 50);
  },
  patientProfileTemplate: "A {age}-year-old. Found unresponsive. Pinpoint pupils.",
  presentingComplaint: 'Unresponsive',
  instructorBrief: {
    progression: "Respiratory depression.",
    interventions: ["Naloxone", "Ventilatory Support"],
    learningObjectives: ["Opioid Toxidrome", "Naloxone dosing"]
  },
  vitalsMod: {
    hr: 60,
    bpSys: 100,
    spO2: 85,
    rr: 4,
    gcs: 6
  },
  deterioration: {
    active: true,
    rate: 0.05,
    type: 'respiratory'
  },
  stabilisers: ['Naloxone', 'Bagging'],
  ecg: {
    type: "Sinus Rhythm",
    findings: "NSR"
  },
  recommendedActions: ['Obs', 'IV Access', 'Naloxone', 'Bagging', 'Oxygen']
}, {
  id: 'AM007',
  title: 'Paracetamol Overdose',
  category: 'Toxicology',
  ageRange: 'Adult',
  acuity: 'Majors',
  ageGenerator: function ageGenerator() {
    return getRandomInt(18, 40);
  },
  patientProfileTemplate: "A {age}-year-old. Took 30g Paracetamol 4 hours ago.",
  presentingComplaint: 'Overdose',
  instructorBrief: {
    progression: "Asymptomatic phase but high risk.",
    interventions: ["NAC", "Blood Levels"],
    learningObjectives: ["Paracetamol nomogram", "NAC indications"]
  },
  vitalsMod: {
    hr: 80,
    bpSys: 120,
    spO2: 98,
    gcs: 15
  },
  deterioration: {
    active: false,
    rate: 0
  },
  ecg: {
    type: "Sinus Rhythm",
    findings: "NSR"
  },
  recommendedActions: ['Obs', 'IV Access', 'Fluids', 'Acetylcysteine']
}, {
  id: 'AM008',
  title: 'Acute Alcohol Withdrawal',
  category: 'Psychiatric',
  ageRange: 'Adult',
  acuity: 'Majors',
  ageGenerator: function ageGenerator() {
    return getRandomInt(30, 60);
  },
  patientProfileTemplate: "A {age}-year-old alcoholic. Stopped drinking 2 days ago.",
  presentingComplaint: 'Tremors & Hallucinations',
  instructorBrief: {
    progression: "Delirium Tremens. Seizure risk.",
    interventions: ["Benzodiazepines", "Pabrinex"],
    learningObjectives: ["CIWA scoring", "Safe sedation"]
  },
  vitalsMod: {
    hr: 130,
    bpSys: 160,
    spO2: 96,
    temp: 38.0
  },
  deterioration: {
    active: true,
    rate: 0.05,
    type: 'neuro'
  },
  ecg: {
    type: "Sinus Tachy",
    findings: "Sinus Tachycardia"
  },
  recommendedActions: ['Obs', 'IV Access', 'Lorazepam', 'Pabrinex', 'Fluids']
}, {
  id: 'AM009',
  title: 'Psychiatric Emergency (Manic)',
  category: 'Psychiatric',
  ageRange: 'Adult',
  acuity: 'Majors',
  ageGenerator: function ageGenerator() {
    return getRandomInt(20, 40);
  },
  patientProfileTemplate: "A {age}-year-old. Aggressive, flight of ideas.",
  presentingComplaint: 'Aggression',
  instructorBrief: {
    progression: "Risk of violence. Rapid Tranquillisation required.",
    interventions: ["De-escalation", "Lorazepam/Haloperidol"],
    learningObjectives: ["Rapid Tranq guidelines", "Mental Capacity Act"]
  },
  vitalsMod: {
    hr: 110,
    bpSys: 140,
    spO2: 99
  },
  deterioration: {
    active: false,
    rate: 0
  },
  ecg: {
    type: "Sinus Tachy",
    findings: "Sinus tachycardia"
  },
  recommendedActions: ['Obs', 'IV Access', 'Lorazepam', 'Midazolam']
}, {
  id: 'AT001',
  title: 'Major Trauma (RTC)',
  category: 'Trauma',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(20, 50);
  },
  patientProfileTemplate: "A {age}-year-old driver. High speed RTC. Trapped 30 mins.",
  presentingComplaint: 'Polytrauma',
  instructorBrief: {
    progression: "Haemorrhagic shock. Pelvic/Chest injuries.",
    interventions: ["Binder", "TXA", "Blood"],
    learningObjectives: ["Major Trauma Call", "Permissive Hypotension"]
  },
  vitalsMod: {
    hr: 130,
    bpSys: 80,
    spO2: 92,
    rr: 30,
    gcs: 13
  },
  deterioration: {
    active: true,
    rate: 0.15,
    type: 'shock'
  },
  stabilisers: ['Blood', 'PelvicBinder'],
  vbgClinicalState: "haemorrhagic_shock",
  recommendedActions: ['Obs', 'IV Access', 'Oxygen', 'Blood', 'TXA', 'PelvicBinder', 'Splinting']
}, {
  id: 'AT002',
  title: 'Stab Wound Chest',
  category: 'Trauma',
  sex: 'Male',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(18, 35);
  },
  patientProfileTemplate: "A {age}-year-old male. Stabbed in right chest.",
  presentingComplaint: 'Stab Wound',
  instructorBrief: {
    progression: "Tension Pneumothorax.",
    interventions: ["Decompression", "Drain"],
    learningObjectives: ["Chest decompression"]
  },
  vitalsMod: {
    hr: 140,
    bpSys: 70,
    spO2: 80,
    rr: 40
  },
  deterioration: {
    active: true,
    rate: 0.2,
    type: 'arrest'
  },
  stabilisers: ['Needle', 'FingerThoracostomy', 'SurgicalDrain'],
  chestXray: {
    findings: "Tension Pneumothorax"
  },
  recommendedActions: ['Obs', 'IV Access', 'Oxygen', 'Needle', 'FingerThoracostomy', 'SurgicalDrain', 'Blood']
}, {
  id: 'AT003',
  title: 'Isolated Head Injury',
  category: 'Trauma',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(20, 60);
  },
  patientProfileTemplate: "A {age}-year-old. Fell down stairs. GCS dropped.",
  presentingComplaint: 'Head Injury',
  instructorBrief: {
    progression: "Extradural haematoma. Cushing's response.",
    interventions: ["RSI", "Neuroprotective measures", "CT Head"],
    learningObjectives: ["Raised ICP management", "Cushing's Triad"]
  },
  vitalsMod: {
    hr: 50,
    bpSys: 180,
    spO2: 96,
    gcs: 8,
    pupils: 'Fixed/Dilated R'
  },
  deterioration: {
    active: true,
    rate: 0.1,
    type: 'neuro'
  },
  ecg: {
    type: "Sinus Brady",
    findings: "Sinus Bradycardia"
  },
  recommendedActions: ['Obs', 'IV Access', 'Oxygen', 'RSI', 'HypertonicSaline', 'Mannitol', 'TXA', 'Collar']
}, {
  id: 'AT004',
  title: 'Burns (Thermal)',
  category: 'Trauma',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(20, 50);
  },
  patientProfileTemplate: "A {age}-year-old. House fire. 40% TBSA burns.",
  presentingComplaint: 'Burns',
  instructorBrief: {
    progression: "Airway oedema risk. Fluid loss.",
    interventions: ["Intubation (Early)", "Parkland Fluid"],
    learningObjectives: ["Burn airway assessment", "Fluid calculation"]
  },
  vitalsMod: {
    hr: 120,
    bpSys: 100,
    spO2: 90,
    rr: 28,
    gcs: 15
  },
  deterioration: {
    active: true,
    rate: 0.05,
    type: 'respiratory'
  },
  stabilisers: ['Fluids', 'RSI'],
  recommendedActions: ['Obs', 'IV Access', 'Fluids', 'RSI', 'Analgesia', 'Warming', 'Escharotomy']
}, {
  id: 'AT005',
  title: 'Neurogenic Shock',
  category: 'Trauma',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(20, 50);
  },
  patientProfileTemplate: "A {age}-year-old. Rugby tackle injury. Can't move legs. Priapism.",
  presentingComplaint: 'Paralysis',
  instructorBrief: {
    progression: "Hypotension with Bradycardia (autonomic mismatch).",
    interventions: ["Vasopressors", "Spinal Immobilisation", "Fluids"],
    learningObjectives: ["Neurogenic vs Spinal shock", "Vasopressor choice"]
  },
  vitalsMod: {
    hr: 48,
    bpSys: 75,
    spO2: 96,
    gcs: 15,
    temp: 35.8
  },
  deterioration: {
    active: true,
    rate: 0.05,
    type: 'shock'
  },
  stabilisers: ['Metaraminol', 'Noradrenaline', 'AdrenalineInfusion', 'Fluids'],
  ecg: {
    type: "Sinus Brady",
    findings: "Sinus Bradycardia"
  },
  recommendedActions: ['Obs', 'IV Access', 'Metaraminol', 'Noradrenaline', 'Fluids', 'Collar', 'Splinting']
}, {
  id: 'AT006',
  title: 'Flail Chest',
  category: 'Trauma',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(30, 60);
  },
  patientProfileTemplate: "A {age}-year-old. Kicked by horse. Paradoxical chest wall movement.",
  presentingComplaint: 'Chest Pain & DIB',
  instructorBrief: {
    progression: "Respiratory failure due to pain/mechanics.",
    interventions: ["Analgesia (Blocks)", "Oxygen", "NIV?"],
    learningObjectives: ["Flail chest mechanics", "Pain management importance"]
  },
  vitalsMod: {
    hr: 110,
    bpSys: 120,
    spO2: 91,
    rr: 28
  },
  deterioration: {
    active: true,
    rate: 0.05,
    type: 'respiratory'
  },
  stabilisers: ['Analgesia', 'Fentanyl', 'Oxygen'],
  recommendedActions: ['Obs', 'IV Access', 'Oxygen', 'Analgesia', 'Fentanyl', 'NerveBlock']
}, {
  id: 'AT007',
  title: 'Penetrating Neck Injury',
  category: 'Trauma',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(18, 40);
  },
  patientProfileTemplate: "A {age}-year-old. Stabbed in Zone 2 of neck. Expanding haematoma.",
  presentingComplaint: 'Stab Wound',
  instructorBrief: {
    progression: "Airway compromise. Hard signs of vascular injury.",
    interventions: ["Early Intubation", "Direct Pressure", "Surgery"],
    learningObjectives: ["Neck trauma zones", "Hard vs Soft signs"]
  },
  vitalsMod: {
    hr: 125,
    bpSys: 95,
    spO2: 96,
    rr: 24,
    gcs: 14
  },
  deterioration: {
    active: true,
    rate: 0.1,
    type: 'airway'
  },
  stabilisers: ['RSI', 'Surgery', 'Blood'],
  recommendedActions: ['Obs', 'IV Access', 'RSI', 'Blood', 'Surgery', 'FONA']
}, {
  id: 'AT008',
  title: 'Crush Syndrome',
  category: 'Trauma',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(25, 55);
  },
  patientProfileTemplate: "A {age}-year-old worker. Legs trapped under concrete slab for 4 hours.",
  presentingComplaint: 'Trapped Limb',
  instructorBrief: {
    progression: "Reperfusion injury. Hyperkalaemia upon release.",
    interventions: ["Fluid Loading (Pre-release)", "Calcium/Insulin", "Bicarb"],
    learningObjectives: ["Crush syndrome physiology", "Hyperkalaemia management"]
  },
  vitalsMod: {
    hr: 110,
    bpSys: 100,
    spO2: 98
  },
  deterioration: {
    active: true,
    rate: 0.1,
    type: 'cardiac'
  },
  stabilisers: ['Fluids', 'Calcium', 'InsulinDextrose'],
  ecg: {
    type: "Sinus Tachycardia",
    findings: "Sinus tachycardia with peaked T waves"
  },
  vbgClinicalState: "hyperkalemia",
  recommendedActions: ['Obs', 'IV Access', 'Fluids', 'Calcium', 'InsulinDextrose', 'SodiumBicarb']
}, {
  id: 'EL001',
  title: 'NOF Fracture',
  category: 'Trauma',
  ageRange: 'Elderly',
  acuity: 'Majors',
  ageGenerator: function ageGenerator() {
    return getRandomInt(75, 95);
  },
  patientProfileTemplate: "A {age}-year-old. Fall from standing. Shortened/Rotated leg.",
  presentingComplaint: 'Hip Pain',
  instructorBrief: {
    progression: "Pain management critical. Check for medical cause of fall.",
    interventions: ["Fascia Iliaca Block", "Analgesia"],
    learningObjectives: ["NOF management", "Frailty assessment"]
  },
  vitalsMod: {
    hr: 90,
    bpSys: 150,
    spO2: 95
  },
  deterioration: {
    active: false,
    rate: 0
  },
  ecg: {
    type: "Sinus Rhythm",
    findings: "NSR or AF"
  },
  recommendedActions: ['Obs', 'IV Access', 'Analgesia', 'Fentanyl', 'NerveBlock']
}, {
  id: 'EL002',
  title: 'Elderly Sepsis (UTI)',
  category: 'Medical',
  ageRange: 'Elderly',
  acuity: 'Majors',
  ageGenerator: function ageGenerator() {
    return getRandomInt(80, 99);
  },
  patientProfileTemplate: "A {age}-year-old. Confusion and off legs.",
  presentingComplaint: 'Confusion',
  instructorBrief: {
    progression: "Urosepsis. Subtle presentation.",
    interventions: ["Antibiotics", "Fluids (Caution)"],
    learningObjectives: ["Sepsis in elderly", "Delirium"]
  },
  vitalsMod: {
    hr: 105,
    bpSys: 100,
    spO2: 93,
    temp: 35.8,
    gcs: 13
  },
  deterioration: {
    active: true,
    rate: 0.05,
    type: 'shock'
  },
  vbgClinicalState: "septic_shock",
  recommendedActions: ['Obs', 'IV Access', 'Antibiotics', 'Fluids', 'Oxygen']
}, {
  id: 'EL003',
  title: 'Subdural Haemorrhage',
  category: 'Trauma',
  ageRange: 'Elderly',
  acuity: 'Majors',
  ageGenerator: function ageGenerator() {
    return getRandomInt(75, 90);
  },
  patientProfileTemplate: "A {age}-year-old. On warfarin for AF. Minor head bump 2 weeks ago. Now confused.",
  presentingComplaint: 'Confusion',
  instructorBrief: {
    progression: "Chronic Subdural. Slow deterioration.",
    interventions: ["CT Head", "Reverse Anticoagulation"],
    learningObjectives: ["Head injury in elderly", "Anticoagulation reversal"]
  },
  vitalsMod: {
    hr: 70,
    bpSys: 130,
    spO2: 96,
    gcs: 12
  },
  deterioration: {
    active: true,
    rate: 0.05,
    type: 'neuro'
  },
  recommendedActions: ['Obs', 'IV Access', 'VitaminK', 'Octaplex']
}, {
  id: 'EL004',
  title: 'Ruptured AAA',
  category: 'Medical',
  ageRange: 'Elderly',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(70, 90);
  },
  patientProfileTemplate: "A {age}-year-old. Sudden onset severe back pain and collapse.",
  presentingComplaint: 'Back Pain & Syncope',
  instructorBrief: {
    progression: "Catastrophic haemorrhage.",
    interventions: ["Permissive Hypotension", "Massive Transfusion", "Immediate Theatre"],
    learningObjectives: ["AAA presentation", "Hypotension targets"]
  },
  vitalsMod: {
    hr: 110,
    bpSys: 80,
    spO2: 94,
    rr: 24,
    gcs: 14
  },
  deterioration: {
    active: true,
    rate: 0.2,
    type: 'shock'
  },
  stabilisers: ['Blood', 'Surgery'],
  vbgClinicalState: "haemorrhagic_shock",
  recommendedActions: ['Obs', 'IV Access', 'Blood', 'Surgery', 'Analgesia', 'TXA']
}, {
  id: 'EL005',
  title: 'Severe Hypothermia',
  category: 'Medical',
  ageRange: 'Elderly',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(75, 95);
  },
  patientProfileTemplate: "A {age}-year-old. Found on floor after 12 hours. Cold to touch.",
  presentingComplaint: 'Collapse',
  instructorBrief: {
    progression: "Risk of VF with handling. Coagulopathy.",
    interventions: ["Passive/Active Warming", "Gentle Handling"],
    learningObjectives: ["Swiss staging", "Resus modification", "Rewarm actively"]
  },
  vitalsMod: {
    hr: 40,
    bpSys: 85,
    spO2: 90,
    temp: 29.5,
    gcs: 9
  },
  deterioration: {
    active: true,
    rate: 0.05,
    type: 'cardiac'
  },
  stabilisers: ['Warming'],
  ecg: {
    type: "Sinus Brady",
    findings: "Osborn J Waves"
  },
  vbgClinicalState: "hypothermia",
  recommendedActions: ['Obs', 'IV Access', 'Warming', 'Fluids']
}, {
  id: 'PA001',
  title: 'Meningococcal Sepsis',
  category: 'Medical',
  ageRange: 'Paediatric',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(1, 5);
  },
  patientProfileTemplate: "A {age}-year-old. High fever, purpuric rash.",
  presentingComplaint: 'Fever & Rash',
  instructorBrief: {
    progression: "Septic shock. Rapid decline.",
    interventions: ["IM/IV Ceftriaxone", "Fluids", "IO Access"],
    learningObjectives: ["Paeds Sepsis", "IO Access"]
  },
  vitalsMod: {
    hr: 160,
    bpSys: 70,
    spO2: 92,
    temp: 39.5,
    rr: 45
  },
  deterioration: {
    active: true,
    rate: 0.15,
    type: 'shock'
  },
  stabilisers: ['Ceftriaxone', 'Fluids'],
  vbgClinicalState: "septic_shock",
  recommendedActions: ['Obs', 'IV Access', 'Ceftriaxone', 'Fluids', 'Oxygen']
}, {
  id: 'PA002',
  title: 'Severe Croup',
  category: 'Medical',
  ageRange: 'Paediatric',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(1, 3);
  },
  patientProfileTemplate: "A {age}-year-old. Barking cough, stridor.",
  presentingComplaint: 'Stridor',
  instructorBrief: {
    progression: "Upper airway obstruction. Keep calm.",
    interventions: ["Neb Adrenaline", "Dexamethasone"],
    learningObjectives: ["Croup scoring", "Neb Adrenaline indications"]
  },
  vitalsMod: {
    hr: 150,
    bpSys: 95,
    spO2: 93,
    rr: 50
  },
  deterioration: {
    active: true,
    rate: 0.08,
    type: 'respiratory'
  },
  stabilisers: ['NebAdrenaline', 'Dexamethasone'],
  recommendedActions: ['Obs', 'Oxygen', 'NebAdrenaline', 'Dexamethasone']
}, {
  id: 'PA003',
  title: 'Status Epilepticus',
  category: 'Medical',
  ageRange: 'Paediatric',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(2, 10);
  },
  patientProfileTemplate: "A {age}-year-old. Seizing > 10 mins.",
  presentingComplaint: 'Seizure',
  instructorBrief: {
    progression: "Prolonged seizure. Hypoxia risk.",
    interventions: ["Midazolam/Lorazepam", "RSI"],
    learningObjectives: ["APLS Seizure Algorithm"]
  },
  vitalsMod: {
    hr: 140,
    bpSys: 100,
    spO2: 88,
    rr: 10,
    gcs: 3
  },
  deterioration: {
    active: true,
    rate: 0.1,
    type: 'neuro'
  },
  stabilisers: ['Midazolam', 'Lorazepam', 'RSI'],
  recommendedActions: ['Obs', 'IV Access', 'Oxygen', 'Midazolam', 'Lorazepam', 'RSI']
}, {
  id: 'PA004',
  title: 'Anaphylaxis',
  category: 'Medical',
  ageRange: 'Paediatric',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(4, 12);
  },
  patientProfileTemplate: "A {age}-year-old. Nut allergy. Swollen lips, wheeze.",
  presentingComplaint: 'Anaphylaxis',
  instructorBrief: {
    progression: "Airway compromise.",
    interventions: ["IM Adrenaline", "Nebs", "Fluids"],
    learningObjectives: ["Paeds Anaphylaxis"]
  },
  vitalsMod: {
    hr: 155,
    bpSys: 80,
    spO2: 91,
    rr: 35
  },
  deterioration: {
    active: true,
    rate: 0.15,
    type: 'shock'
  },
  stabilisers: ['AdrenalineIM', 'Nebs'],
  recommendedActions: ['Obs', 'IV Access', 'Oxygen', 'AdrenalineIM', 'Nebs', 'Fluids']
}, {
  id: 'PA005',
  title: 'Bronchiolitis',
  category: 'Medical',
  ageRange: 'Paediatric',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return 0.33;
  },
  patientProfileTemplate: "A 4-month-old. 3 days coryza. Breathless.",
  presentingComplaint: 'DIB',
  instructorBrief: {
    progression: "Resp failure. Apnoeas.",
    interventions: ["High Flow/CPAP", "Suction"],
    learningObjectives: ["Bronchiolitis escalation"]
  },
  vitalsMod: {
    hr: 170,
    bpSys: 80,
    spO2: 86,
    rr: 65
  },
  deterioration: {
    active: true,
    rate: 0.05,
    type: 'respiratory'
  },
  stabilisers: ['Oxygen', 'CPAP', 'NIV'],
  recommendedActions: ['Obs', 'IV Access', 'Suction', 'Oxygen', 'CPAP', 'Fluids']
}, {
  id: 'PA006',
  title: 'Paediatric DKA',
  category: 'Medical',
  ageRange: 'Paediatric',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(6, 15);
  },
  patientProfileTemplate: "A {age}-year-old. New onset polyuria/polydipsia. Vomiting.",
  presentingComplaint: 'Vomiting & Lethargy',
  instructorBrief: {
    progression: "Severe Acidosis. Cerebral Oedema risk.",
    interventions: ["Slow Fluids", "Insulin (Delay)"],
    learningObjectives: ["Paeds DKA Fluids", "Cerebral Oedema"]
  },
  vitalsMod: {
    hr: 130,
    bpSys: 95,
    spO2: 98,
    rr: 30,
    bm: 28
  },
  deterioration: {
    active: true,
    rate: 0.05,
    type: 'shock'
  },
  vbgClinicalState: "dka_severe",
  recommendedActions: ['Obs', 'IV Access', 'Fluids', 'InsulinInfusion']
}, {
  id: 'PA007',
  title: 'SVT',
  category: 'Medical',
  ageRange: 'Paediatric',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    var y = getRandomInt(0, 12);
    return y > 0 ? y : Math.round(getRandomInt(1, 11) / 12 * 100) / 100;
  },
  patientProfileTemplate: "A {age}-year-old. Pale, irritable. HR > 220.",
  presentingComplaint: 'Palpitations/Poor Feeding',
  instructorBrief: {
    progression: "Stable vs Unstable SVT.",
    interventions: ["Vagal Manoeuvres", "Adenosine", "Cardioversion"],
    learningObjectives: ["Paeds SVT management"]
  },
  vitalsMod: {
    hr: 240,
    bpSys: 85,
    spO2: 95
  },
  deterioration: {
    active: true,
    rate: 0.05,
    type: 'cardiac'
  },
  ecg: {
    type: "SVT",
    findings: "Narrow Complex Tachycardia > 220bpm"
  },
  recommendedActions: ['Obs', 'IV Access', 'VagalManoeuvre', 'Adenosine', 'Cardioversion']
}, {
  id: 'PA008',
  title: 'Intussusception',
  category: 'Medical',
  ageRange: 'Paediatric',
  acuity: 'Majors',
  ageGenerator: function ageGenerator() {
    return Math.round(getRandomInt(3, 24) / 12 * 100) / 100;
  },
  patientProfileTemplate: "A {age}-year-old. Episodic crying, drawing up legs. 'Redcurrant jelly' stool.",
  presentingComplaint: 'Abdo Pain',
  instructorBrief: {
    progression: "Fluid depletion and shock. Bowel ischaemia.",
    interventions: ["Fluids", "Air Enema (Radiology)", "Surgery"],
    learningObjectives: ["Intussusception diagnosis", "Fluid resus"]
  },
  vitalsMod: {
    hr: 160,
    bpSys: 85,
    spO2: 98,
    rr: 35
  },
  deterioration: {
    active: true,
    rate: 0.05,
    type: 'shock'
  },
  stabilisers: ['Fluids', 'AirEnema', 'Surgery'],
  recommendedActions: ['Obs', 'IV Access', 'Fluids', 'AirEnema', 'Analgesia', 'Surgery']
}, {
  id: 'PA009',
  title: 'Button Battery Ingestion',
  category: 'Medical',
  ageRange: 'Paediatric',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(1, 4);
  },
  patientProfileTemplate: "A {age}-year-old. Off food, coughing and drooling on and off for about a week; parent now thinks a remote-control battery went missing then. Sudden haematemesis today.",
  presentingComplaint: 'Haematemesis',
  instructorBrief: {
    progression: "Unwitnessed button battery ingestion, about a week ago, with the battery lodged in the oesophagus. A small herald bleed is followed by catastrophic haemorrhage from an aorto-oesophageal fistula. Fistula bleeding usually comes days later, not within hours (TOXBASE reports it up to 18 days after removal); burns and ulceration start within 2 to 4 hours of lodging. Teaching points: X-ray chest and abdomen for any child with unexplained symptoms and possible battery access; a battery in the oesophagus is removed immediately even without symptoms.",
    interventions: ["Massive Haemorrhage Protocol", "Theatre"],
    learningObjectives: ["Button battery time-criticality", "Fistula risk"]
  },
  vitalsMod: {
    hr: 150,
    bpSys: 80,
    spO2: 94,
    rr: 30
  },
  deterioration: {
    active: true,
    rate: 0.2,
    type: 'shock'
  },
  stabilisers: ['Blood', 'TXA', 'Surgery'],
  recommendedActions: ['Obs', 'IV Access', 'Blood', 'TXA', 'Surgery']
}, {
  id: 'PA010',
  title: 'Duct Dependent Collapse',
  category: 'Medical',
  ageRange: 'Paediatric',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return 0;
  },
  patientProfileTemplate: "A 5-day-old neonate. Sudden collapse at home. Pale and mottled.",
  presentingComplaint: 'Collapse',
  instructorBrief: {
    progression: "Closing ductus arteriosus. Cardiac failure.",
    interventions: ["Prostaglandin (Dinoprostone)", "Intubation", "Fluids"],
    learningObjectives: ["Neonatal collapse diff dx", "Prostin use"]
  },
  vitalsMod: {
    hr: 180,
    bpSys: 55,
    spO2: 80,
    rr: 60,
    bm: 3.5
  },
  deterioration: {
    active: true,
    rate: 0.15,
    type: 'cardiac'
  },
  stabilisers: ['Prostin', 'Fluids', 'RSI'],
  ecg: {
    type: "Sinus Tachy",
    findings: "Sinus Tachy"
  },
  recommendedActions: ['Obs', 'IV Access', 'Prostin', 'Fluids', 'RSI', 'Antibiotics']
}, {
  id: 'PT001',
  title: 'NAI (Non-Accidental)',
  category: 'Trauma',
  ageRange: 'Paediatric',
  acuity: 'Majors',
  ageGenerator: function ageGenerator() {
    return Math.round(getRandomInt(2, 24) / 12 * 100) / 100;
  },
  patientProfileTemplate: "A {age}-year-old. 'Fell off sofa'. Bruising to ears/neck.",
  presentingComplaint: 'Injury',
  instructorBrief: {
    progression: "Safeguarding concern. Thorough survey needed.",
    interventions: ["Skeletal Survey", "Social Services"],
    learningObjectives: ["Recognising NAI", "Safeguarding"]
  },
  vitalsMod: {
    hr: 110,
    bpSys: 90,
    spO2: 99
  },
  deterioration: {
    active: false,
    rate: 0
  },
  recommendedActions: ['Obs', 'Analgesia']
}, {
  id: 'PT002',
  title: 'Paediatric Head Injury',
  category: 'Trauma',
  ageRange: 'Paediatric',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(2, 8);
  },
  patientProfileTemplate: "A {age}-year-old. Fall 2m onto concrete. Vomiting.",
  presentingComplaint: 'Head Injury',
  instructorBrief: {
    progression: "Intracranial bleed.",
    interventions: ["CT Head", "Neuroobs", "RSI"],
    learningObjectives: ["Apply the NICE head injury rules for children", "Paeds Head Injury"]
  },
  vitalsMod: {
    hr: 90,
    bpSys: 110,
    spO2: 98,
    gcs: 13
  },
  deterioration: {
    active: true,
    rate: 0.1,
    type: 'neuro'
  },
  recommendedActions: ['Obs', 'IV Access', 'RSI', 'TXA', 'Oxygen']
}, {
  id: 'CA001',
  title: 'Adult VF Arrest',
  category: 'Cardiac Arrest',
  sex: 'Male',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(50, 80);
  },
  patientProfileTemplate: "Adult Male. Collapsed. Witnessed.",
  presentingComplaint: 'Cardiac Arrest',
  instructorBrief: {
    progression: "VF Arrest.",
    interventions: ["CPR", "Shock", "Adrenaline", "Amiodarone"],
    learningObjectives: ["ALS Algorithm"]
  },
  vitalsMod: {
    hr: 0,
    bpSys: 0,
    spO2: 0,
    gcs: 3
  },
  deterioration: {
    active: false,
    rate: 0
  },
  ecg: {
    type: "VF",
    findings: "VF"
  },
  recommendedActions: ['Obs', 'CPR', 'Defib', 'AdrenalineIV', 'Amiodarone']
}, {
  id: 'CA002',
  title: 'Paediatric PEA Arrest',
  category: 'Cardiac Arrest',
  ageRange: 'Paediatric',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(1, 8);
  },
  patientProfileTemplate: "Child. Found unresponsive in bed.",
  presentingComplaint: 'Cardiac Arrest',
  instructorBrief: {
    progression: "PEA Arrest. Hypoxia likely cause.",
    interventions: ["CPR", "Airway", "Adrenaline"],
    learningObjectives: ["APLS Arrest", "4Hs 4Ts"]
  },
  vitalsMod: {
    hr: 40,
    bpSys: 0,
    spO2: 0,
    gcs: 3
  },
  deterioration: {
    active: false,
    rate: 0
  },
  ecg: {
    type: "PEA",
    findings: "Slow electrical activity, no pulse"
  },
  recommendedActions: ['Obs', 'CPR', 'AdrenalineIV', 'Bagging', 'Fluids']
}, {
  id: 'OB001',
  title: 'Cord Prolapse',
  category: 'Obstetrics & Gynae',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(18, 40);
  },
  patientProfileTemplate: "38 weeks pregnant. Waters broke. Loop of cord visible.",
  presentingComplaint: 'Cord Prolapse',
  instructorBrief: {
    progression: "Fetal hypoxia. Obstetric emergency.",
    interventions: ["Elevate presenting part", "Emergency C-Section"],
    learningObjectives: ["Cord prolapse management"]
  },
  vitalsMod: {
    hr: 100,
    bpSys: 120,
    spO2: 99
  },
  deterioration: {
    active: false,
    rate: 0
  },
  recommendedActions: ['Obs', 'IV Access', 'Delivery', 'ObstetricManoeuvres', 'Oxygen', 'Fluids', 'Surgery']
}, {
  id: 'OB002',
  title: 'Shoulder Dystocia',
  category: 'Obstetrics & Gynae',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(18, 40);
  },
  patientProfileTemplate: "In labour. Head delivered, body stuck.",
  presentingComplaint: 'Stuck Baby',
  instructorBrief: {
    progression: "Turtle sign. Fetal compromise.",
    interventions: ["McRoberts", "Suprapubic Pressure"],
    learningObjectives: ["HELPERR Mnemonic"]
  },
  vitalsMod: {
    hr: 110,
    bpSys: 130,
    spO2: 98
  },
  deterioration: {
    active: false,
    rate: 0
  },
  recommendedActions: ['Obs', 'IV Access', 'ObstetricManoeuvres', 'Delivery', 'Oxytocin', 'Analgesia']
}, {
  id: 'OB003',
  title: 'Ruptured Ectopic',
  category: 'Obstetrics & Gynae',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(18, 35);
  },
  patientProfileTemplate: "A {age}-year-old female, about 7 weeks since her last period. Severe RIF pain and syncope. Positive pregnancy test.",
  presentingComplaint: 'Abdo Pain & Collapse',
  instructorBrief: {
    progression: "Intra-abdominal haemorrhage. Shock.",
    interventions: ["Blood", "Surgery", "No anti-D needed at this gestation (NICE NG126 2026: not needed up to 11+6 weeks; offer at least 250 IU from 12+0 to 12+6 weeks with surgery if RhD-negative)"],
    learningObjectives: ["Ectopic recognition", "Haemorrhage management"]
  },
  vitalsMod: {
    hr: 130,
    bpSys: 85,
    spO2: 98,
    rr: 24,
    gcs: 14
  },
  deterioration: {
    active: true,
    rate: 0.1,
    type: 'shock'
  },
  stabilisers: ['Blood', 'Surgery', 'Fluids'],
  vbgClinicalState: "haemorrhagic_shock",
  recommendedActions: ['Obs', 'IV Access', 'Blood', 'Surgery', 'Fluids', 'Analgesia']
}, {
  id: 'OB004',
  title: 'Eclampsia',
  category: 'Obstetrics & Gynae',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(18, 40);
  },
  patientProfileTemplate: "36 weeks pregnant. Brought in seizing.",
  presentingComplaint: 'Seizure',
  instructorBrief: {
    progression: "Eclamptic seizure. Airway risk.",
    interventions: ["Magnesium Sulphate", "BP Control", "Delivery"],
    learningObjectives: ["Eclampsia management", "Mag Sulph dosing"]
  },
  vitalsMod: {
    hr: 120,
    bpSys: 170,
    spO2: 92,
    rr: 10,
    gcs: 3
  },
  deterioration: {
    active: true,
    rate: 0.1,
    type: 'neuro'
  },
  stabilisers: ['MagSulph', 'Labetalol', 'RSI'],
  recommendedActions: ['Obs', 'IV Access', 'Oxygen', 'MagSulph', 'Labetalol', 'Delivery', 'RSI']
}, {
  id: 'OB005',
  title: 'Amniotic Fluid Embolism',
  category: 'Obstetrics & Gynae',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(18, 40);
  },
  patientProfileTemplate: "In active labour. Sudden collapse and cyanosis.",
  presentingComplaint: 'Collapse',
  instructorBrief: {
    progression: "Cardiovascular collapse and coagulopathy (DIC).",
    interventions: ["CPR (if arrest)", "Massive Transfusion", "Perimortem C-Section?"],
    learningObjectives: ["AFE recognition", "Maternal arrest modification"]
  },
  vitalsMod: {
    hr: 150,
    bpSys: 60,
    spO2: 75,
    rr: 35,
    gcs: 8
  },
  deterioration: {
    active: true,
    rate: 0.2,
    type: 'shock'
  },
  stabilisers: ['Blood', 'TXA', 'Delivery'],
  recommendedActions: ['Obs', 'IV Access', 'Blood', 'TXA', 'Delivery', 'CPR', 'Hysterotomy']
}, {
  id: 'AM039',
  title: 'Pericardial Tamponade',
  category: 'Medical',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(30, 60);
  },
  patientProfileTemplate: "A {age}-year-old. 2 weeks post-viral illness. Severe dyspnoea and chest heaviness.",
  presentingComplaint: 'Dyspnoea & Syncope',
  instructorBrief: {
    progression: "Beck's Triad. Obstructive Shock.",
    interventions: ["Fluids (Temporising)", "Pericardiocentesis", "Surgery"],
    learningObjectives: ["Beck's Triad", "Electrical Alternans"]
  },
  vitalsMod: {
    hr: 130,
    bpSys: 85,
    spO2: 92,
    rr: 30
  },
  deterioration: {
    active: true,
    rate: 0.15,
    type: 'shock'
  },
  stabilisers: ['Pericardiocentesis', 'Surgery'],
  ecg: {
    type: "Sinus Tachy",
    findings: "Small voltages, Electrical Alternans"
  },
  recommendedActions: ['Obs', 'IV Access', 'Pericardiocentesis', 'Fluids', 'Surgery']
}, {
  id: 'AM040',
  title: 'Wellens Syndrome',
  category: 'Medical',
  ageRange: 'Adult',
  acuity: 'Majors',
  ageGenerator: function ageGenerator() {
    return getRandomInt(45, 65);
  },
  patientProfileTemplate: "A {age}-year-old. Had chest pain earlier, now pain free.",
  presentingComplaint: 'Resolved Chest Pain',
  instructorBrief: {
    progression: "Critical LAD stenosis. Risk of massive anterior MI if stressed.",
    interventions: ["Aspirin", "PPCI Referral (Urgent)", "Avoid Stress Test"],
    learningObjectives: ["Wellens ECG signs", "Do not exercise test"]
  },
  vitalsMod: {
    hr: 70,
    bpSys: 130,
    spO2: 98
  },
  deterioration: {
    active: false,
    rate: 0
  },
  ecg: {
    type: "Sinus Rhythm",
    findings: "Deeply inverted T waves V2-V3 (Type B)"
  },
  recommendedActions: ['Obs', 'IV Access', 'Aspirin', 'Clopidogrel']
}, {
  id: 'AM041',
  title: 'Massive Haemoptysis',
  category: 'Medical',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(50, 75);
  },
  patientProfileTemplate: "A {age}-year-old smoker. Coughing up cup-fulls of bright red blood.",
  presentingComplaint: 'Haemoptysis',
  instructorBrief: {
    progression: "Airway obstruction and hypovolaemia.",
    interventions: ["Intubation (Large tube)", "Lay on affected side", "TXA"],
    learningObjectives: ["Bronchial artery anatomy", "Positioning"]
  },
  vitalsMod: {
    hr: 125,
    bpSys: 100,
    spO2: 88,
    rr: 28
  },
  deterioration: {
    active: true,
    rate: 0.15,
    type: 'airway'
  },
  stabilisers: ['RSI', 'TXA'],
  recommendedActions: ['Obs', 'IV Access', 'RSI', 'TXA', 'Blood', 'Suction', 'Oxygen']
}, {
  id: 'AM042',
  title: 'Brugada Syndrome',
  category: 'Medical',
  ageRange: 'Adult',
  acuity: 'Majors',
  ageGenerator: function ageGenerator() {
    return getRandomInt(25, 45);
  },
  patientProfileTemplate: "A {age}-year-old. Syncope while resting/sleeping. Family history of sudden death.",
  presentingComplaint: 'Syncope',
  instructorBrief: {
    progression: "Risk of polymorphic VT/VF.",
    interventions: ["Avoid fever/certain drugs", "Cardiology Referral", "ICD consideration"],
    learningObjectives: ["Brugada ECG types", "Sodium channel blockers"]
  },
  vitalsMod: {
    hr: 75,
    bpSys: 120,
    spO2: 99
  },
  deterioration: {
    active: false,
    rate: 0
  },
  ecg: {
    type: "Sinus Rhythm",
    findings: "Coved ST elevation V1-V2 (Type 1)"
  },
  recommendedActions: ['Obs', 'IV Access']
}, {
  id: 'AM043',
  title: 'Myasthenia Gravis Crisis',
  category: 'Medical',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(30, 60);
  },
  patientProfileTemplate: "A {age}-year-old with Myasthenia Gravis. Increasing shortness of breath and swallowing difficulty.",
  presentingComplaint: 'Dyspnoea & Weakness',
  instructorBrief: {
    progression: "Type 2 Respiratory Failure (Neuromuscular).",
    interventions: ["NIV", "Intubation", "IVIG/Plasma Exchange"],
    learningObjectives: ["FVC monitoring", "Cholinergic vs Myasthenic"]
  },
  vitalsMod: {
    hr: 110,
    bpSys: 140,
    spO2: 92,
    rr: 30
  },
  deterioration: {
    active: true,
    rate: 0.1,
    type: 'respiratory'
  },
  stabilisers: ['NIV', 'RSI'],
  recommendedActions: ['Obs', 'IV Access', 'NIV', 'RSI']
}, {
  id: 'AM044',
  title: 'Vertebral Artery Dissection',
  category: 'Medical',
  ageRange: 'Adult',
  acuity: 'Majors',
  ageGenerator: function ageGenerator() {
    return getRandomInt(25, 45);
  },
  patientProfileTemplate: "A {age}-year-old. Neck pain after yoga/chiropractor. Vertigo and ataxia.",
  presentingComplaint: 'Neck Pain & Dizziness',
  instructorBrief: {
    progression: "Posterior circulation stroke.",
    interventions: ["CT Angiogram", "Antiplatelets/Anticoagulation"],
    learningObjectives: ["Dissection risk factors", "Cerebellar signs"]
  },
  vitalsMod: {
    hr: 80,
    bpSys: 145,
    spO2: 98,
    gcs: 14
  },
  deterioration: {
    active: true,
    rate: 0.05,
    type: 'neuro'
  },
  recommendedActions: ['Obs', 'IV Access', 'Aspirin', 'Analgesia']
}, {
  id: 'AM045',
  title: 'Phaeochromocytoma Crisis',
  category: 'Medical',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(30, 60);
  },
  patientProfileTemplate: "A {age}-year-old. Sudden thunderclap headache, palpitations, profuse sweating.",
  presentingComplaint: 'Headache',
  instructorBrief: {
    progression: "Hypertensive crisis. End organ damage.",
    interventions: ["Alpha Blockers (Phentolamine)", "Beta Blockers (AFTER Alpha)"],
    learningObjectives: ["Alpha before Beta rule", "Catecholamine surge"]
  },
  vitalsMod: {
    hr: 160,
    bpSys: 240,
    bpDia: 130,
    spO2: 96
  },
  deterioration: {
    active: true,
    rate: 0.1,
    type: 'cardiac'
  },
  stabilisers: ['Phentolamine', 'MagSulph'],
  recommendedActions: ['Obs', 'IV Access', 'Phentolamine', 'MagSulph', 'Labetalol']
}, {
  id: 'AM046',
  title: 'Pituitary Apoplexy',
  category: 'Medical',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(30, 60);
  },
  patientProfileTemplate: "A {age}-year-old. Sudden severe headache and visual loss (bitemporal).",
  presentingComplaint: 'Headache & Blindness',
  instructorBrief: {
    progression: "Adrenal insufficiency and mass effect.",
    interventions: ["Hydrocortisone", "Urgent Neurosurgery"],
    learningObjectives: ["Pituitary anatomy", "Steroid replacement"]
  },
  vitalsMod: {
    hr: 110,
    bpSys: 90,
    spO2: 98,
    gcs: 14
  },
  deterioration: {
    active: true,
    rate: 0.05,
    type: 'neuro'
  },
  stabilisers: ['Hydrocortisone', 'Surgery'],
  recommendedActions: ['Obs', 'IV Access', 'Hydrocortisone', 'Surgery', 'Fluids']
}, {
  id: 'AM047',
  title: 'Ludwig\'s Angina',
  category: 'Medical',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(20, 50);
  },
  patientProfileTemplate: "A {age}-year-old. Dental abscess. 'Hot potato' voice, woody neck swelling.",
  presentingComplaint: 'Sore Throat & Swelling',
  instructorBrief: {
    progression: "Airway obstruction.",
    interventions: ["Antibiotics", "Awake Fibreoptic Intubation", "Surgical Airway"],
    learningObjectives: ["Airway assessment", "FONA anticipation"]
  },
  vitalsMod: {
    hr: 120,
    bpSys: 130,
    spO2: 94,
    rr: 26,
    temp: 39.0
  },
  deterioration: {
    active: true,
    rate: 0.15,
    type: 'airway'
  },
  stabilisers: ['Antibiotics', 'RSI'],
  recommendedActions: ['Obs', 'IV Access', 'Antibiotics', 'NebAdrenaline', 'Dexamethasone', 'RSI', 'FONA']
}, {
  id: 'AM048',
  title: 'Severe Malaria',
  category: 'Medical',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(20, 60);
  },
  patientProfileTemplate: "A {age}-year-old. Returned from Kenya 1 week ago. Flu-like symptoms, now confused.",
  presentingComplaint: 'Fever & Confusion',
  instructorBrief: {
    progression: "Cerebral Malaria. Haemolysis.",
    interventions: ["Artesunate/Quinine", "Fluids", "Glucose"],
    learningObjectives: ["Travel history", "Parasitaemia", "Give IV artesunate"]
  },
  vitalsMod: {
    hr: 130,
    bpSys: 90,
    spO2: 92,
    temp: 40.2,
    gcs: 11
  },
  deterioration: {
    active: true,
    rate: 0.1,
    type: 'shock'
  },
  stabilisers: ['Artesunate', 'Fluids'],
  vbgClinicalState: "metabolic_acidosis_severe",
  recommendedActions: ['Obs', 'IV Access', 'Artesunate', 'Fluids', 'Dextrose']
}, {
  id: 'AM049',
  title: 'Necrotising Fasciitis',
  category: 'Medical',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(40, 70);
  },
  patientProfileTemplate: "A {age}-year-old. Minor scratch on leg. Now severe pain out of proportion to exam.",
  presentingComplaint: 'Leg Pain',
  instructorBrief: {
    progression: "Rapid spread. Septic shock.",
    interventions: ["Immediate Surgery (Debridement)", "Broad Spectrum Abx"],
    learningObjectives: ["LRINEC Score", "Pain out of proportion"]
  },
  vitalsMod: {
    hr: 140,
    bpSys: 85,
    spO2: 94,
    temp: 39.5
  },
  deterioration: {
    active: true,
    rate: 0.2,
    type: 'shock'
  },
  stabilisers: ['Surgery', 'Antibiotics'],
  vbgClinicalState: "septic_shock",
  recommendedActions: ['Obs', 'IV Access', 'Surgery', 'Antibiotics', 'Fluids', 'Analgesia']
}, {
  id: 'TX001',
  title: 'Beta-Blocker Overdose',
  category: 'Toxicology',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(20, 50);
  },
  patientProfileTemplate: "A {age}-year-old. Took 2 months supply of Bisoprolol.",
  presentingComplaint: 'Overdose',
  instructorBrief: {
    progression: "Profound bradycardia and shock.",
    interventions: ["Atropine for symptomatic bradycardia", "IV glucagon bolus (5-10 mg)", "High Dose Insulin", "Pacing", "Lipid emulsion only if life-threatening or in arrest (weak evidence)"],
    learningObjectives: ["HDI protocol", "Glucagon dosing"]
  },
  vitalsMod: {
    hr: 35,
    bpSys: 65,
    spO2: 94,
    gcs: 12,
    bm: 3.5
  },
  deterioration: {
    active: true,
    rate: 0.1,
    type: 'cardiac'
  },
  stabilisers: ['GlucagonIV', 'HIET', 'Pacing'],
  ecg: {
    type: "Sinus Brady",
    findings: "Severe Bradycardia, 1st deg block"
  },
  recommendedActions: ['Obs', 'IV Access', 'Atropine', 'GlucagonIV', 'HIET', 'Pacing']
}, {
  id: 'TX002',
  title: 'Digoxin Toxicity',
  category: 'Toxicology',
  ageRange: 'Elderly',
  acuity: 'Majors',
  ageGenerator: function ageGenerator() {
    return getRandomInt(70, 90);
  },
  patientProfileTemplate: "A {age}-year-old. Confused, vomiting, seeing yellow halos.",
  presentingComplaint: 'Confusion & Vomiting',
  instructorBrief: {
    progression: "Arrhythmias (Bidirectional VT). TOXBASE: antibody fragments for severe bradyarrhythmia, life-threatening ventricular arrhythmia or severe hyperkalaemia (e.g. above 6.5) resistant to standard treatment. Atropine 1.2 mg if fragments not immediately available. Calcium is now considered safe for hyperkalaemia. Digoxin levels are falsely high after fragments.",
    interventions: ["Digibind (Fab fragments)", "Magnesium", "Atropine"],
    learningObjectives: ["Digoxin ECG effects", "Know the indications for digoxin-specific antibody fragments"]
  },
  vitalsMod: {
    hr: 45,
    bpSys: 100,
    spO2: 96
  },
  deterioration: {
    active: true,
    rate: 0.05,
    type: 'cardiac'
  },
  ecg: {
    type: "Sinus Brady",
    findings: "Reverse tick appearance, frequent VEs"
  },
  recommendedActions: ['Obs', 'IV Access', 'Atropine', 'MagSulph', 'Digibind']
}, {
  id: 'TX003',
  title: 'Iron Overdose',
  category: 'Toxicology',
  ageRange: 'Paediatric',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(2, 6);
  },
  patientProfileTemplate: "A {age}-year-old. Ate 'red sweets' (Ferrous Sulphate) 4 hours ago. Vomiting blood.",
  presentingComplaint: 'Haematemesis',
  instructorBrief: {
    progression: "Corrosive GI injury. Severe metabolic acidosis.",
    interventions: ["IV desferrioxamine 15 mg/kg/hour now: severe features, so don't wait for the iron level", "Fluids", "Charcoal does not bind iron", "Whole bowel irrigation only for a large modified-release overdose (discuss with NPIS)", "Surgical review if signs of bowel necrosis or perforation"],
    learningObjectives: ["Iron toxicity stages", "Opaque pills on X-ray"]
  },
  vitalsMod: {
    hr: 150,
    bpSys: 80,
    spO2: 95,
    rr: 40
  },
  deterioration: {
    active: true,
    rate: 0.1,
    type: 'shock'
  },
  vbgClinicalState: "metabolic_acidosis_severe",
  stabilisers: ['Desferrioxamine', 'Fluids'],
  recommendedActions: ['Obs', 'IV Access', 'Fluids', 'Desferrioxamine', 'SodiumBicarb']
}, {
  id: 'TX004',
  title: 'Local Anaesthetic Toxicity',
  category: 'Toxicology',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(30, 60);
  },
  patientProfileTemplate: "A {age}-year-old. Had nerve block. Now ringing in ears and perioral numbness.",
  presentingComplaint: 'Tinnitus & Numbness',
  instructorBrief: {
    progression: "Seizures then Cardiac Arrest (LAST).",
    interventions: ["Intralipid 20%", "Stop injection"],
    learningObjectives: ["LAST protocol", "Lipid dosing"]
  },
  vitalsMod: {
    hr: 110,
    bpSys: 140,
    spO2: 99
  },
  deterioration: {
    active: true,
    rate: 0.15,
    type: 'neuro'
  },
  stabilisers: ['Lipid', 'Midazolam'],
  recommendedActions: ['Obs', 'IV Access', 'Lipid', 'Midazolam', 'Oxygen']
}, {
  id: 'TX005',
  title: 'Ethylene Glycol',
  category: 'Toxicology',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(30, 60);
  },
  patientProfileTemplate: "A {age}-year-old. Drank antifreeze. Appears drunk but breath smells sweet.",
  presentingComplaint: 'Intoxication',
  instructorBrief: {
    progression: "High anion gap acidosis. Renal failure. TOXBASE: start fomepizole (preferred; ethanol if delayed) without waiting for levels; bicarbonate for acidosis; haemodialysis for severe acidosis, renal failure, coma or seizures. Do not routinely correct hypocalcaemia (only if QTc above 500 ms or persistent seizures). Charcoal does not help.",
    interventions: ["Fomepizole/Ethanol", "Dialysis"],
    learningObjectives: ["Osmolar gap", "Give fomepizole and arrange haemodialysis"]
  },
  vitalsMod: {
    hr: 100,
    bpSys: 130,
    spO2: 96,
    rr: 28
  },
  deterioration: {
    active: true,
    rate: 0.05,
    type: 'shock'
  },
  vbgClinicalState: "metabolic_acidosis_severe",
  recommendedActions: ['Obs', 'IV Access', 'Fluids', 'Fomepizole']
}, {
  id: 'AT009',
  title: 'Traumatic Amputation',
  category: 'Trauma',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(20, 50);
  },
  patientProfileTemplate: "A {age}-year-old. Industrial accident. Hand amputated at wrist.",
  presentingComplaint: 'Amputation',
  instructorBrief: {
    progression: "Exsanguination.",
    interventions: ["Tourniquet", "Direct Pressure", "Stump retrieval"],
    learningObjectives: ["Tourniquet application", "Amputated part care"]
  },
  vitalsMod: {
    hr: 130,
    bpSys: 90,
    spO2: 98
  },
  deterioration: {
    active: true,
    rate: 0.15,
    type: 'shock'
  },
  stabilisers: ['Blood', 'TXA', 'Surgery'],
  recommendedActions: ['Obs', 'IV Access', 'Blood', 'TXA', 'Surgery', 'Analgesia', 'Tourniquet']
}, {
  id: 'AT010',
  title: 'Compartment Syndrome',
  category: 'Trauma',
  ageRange: 'Adult',
  acuity: 'Majors',
  ageGenerator: function ageGenerator() {
    return getRandomInt(20, 40);
  },
  patientProfileTemplate: "A {age}-year-old. Tib/Fib fracture 4 hours ago (casted). Increasing severe pain.",
  presentingComplaint: 'Leg Pain',
  instructorBrief: {
    progression: "Ischaemia and necrosis.",
    interventions: ["Split Cast/Dressings", "Fasciotomy"],
    learningObjectives: ["Recognise compartment syndrome clinically (pain out of proportion)", "Pain on passive stretch"]
  },
  vitalsMod: {
    hr: 110,
    bpSys: 140,
    spO2: 99
  },
  deterioration: {
    active: false,
    rate: 0
  },
  stabilisers: ['Surgery', 'Analgesia'],
  recommendedActions: ['Obs', 'IV Access', 'Surgery', 'Analgesia']
}, {
  id: 'AT011',
  title: 'Electrical Injury',
  category: 'Trauma',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(20, 50);
  },
  patientProfileTemplate: "A {age}-year-old electrician. Thrown across room by high voltage.",
  presentingComplaint: 'Electrocution',
  instructorBrief: {
    progression: "Rhabdomyolysis and arrhythmias.",
    interventions: ["ECG Monitoring", "Fluid (high target)", "CK check"],
    learningObjectives: ["AC vs DC injury", "Fluid targets in burns"]
  },
  vitalsMod: {
    hr: 120,
    bpSys: 130,
    spO2: 98
  },
  deterioration: {
    active: true,
    rate: 0.05,
    type: 'cardiac'
  },
  ecg: {
    type: "AF",
    findings: "Irregular with burns evident"
  },
  recommendedActions: ['Obs', 'IV Access', 'Fluids', 'Analgesia']
}, {
  id: 'AT012',
  title: 'Suspension Trauma',
  category: 'Trauma',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(25, 55);
  },
  patientProfileTemplate: "A {age}-year-old climber. Stuck in harness for 2 hours. Conscious.",
  presentingComplaint: 'Leg Numbness',
  instructorBrief: {
    progression: "Reflow syndrome/Cardiac arrest upon lying flat.",
    interventions: ["Sit up/crouch", "Gradual recline", "Fluids"],
    learningObjectives: ["Suspension syncope", "Rescue death"]
  },
  vitalsMod: {
    hr: 115,
    bpSys: 90,
    spO2: 96
  },
  deterioration: {
    active: true,
    rate: 0.1,
    type: 'shock'
  },
  recommendedActions: ['Obs', 'IV Access', 'Fluids']
}, {
  id: 'AT013',
  title: 'Open Chest Wound',
  category: 'Trauma',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(20, 50);
  },
  patientProfileTemplate: "A {age}-year-old. Stabbed chest. Bubbling wound.",
  presentingComplaint: 'Stab Wound',
  instructorBrief: {
    progression: "Sucking chest wound. Pneumothorax.",
    interventions: ["3-sided dressing", "Chest Drain"],
    learningObjectives: ["Occlusive dressing logic", "Drain insertion"]
  },
  vitalsMod: {
    hr: 130,
    bpSys: 95,
    spO2: 88,
    rr: 32
  },
  deterioration: {
    active: true,
    rate: 0.15,
    type: 'respiratory'
  },
  stabilisers: ['SeldingerDrain', 'SurgicalDrain'],
  recommendedActions: ['Obs', 'IV Access', 'SurgicalDrain', 'Oxygen', 'Analgesia', 'SeldingerDrain']
}, {
  id: 'PA011',
  title: 'Kawasaki Disease',
  category: 'Medical',
  ageRange: 'Paediatric',
  acuity: 'Majors',
  ageGenerator: function ageGenerator() {
    return getRandomInt(2, 5);
  },
  patientProfileTemplate: "A {age}-year-old. Fever > 5 days. Strawberry tongue, peeling fingers.",
  presentingComplaint: 'Fever & Rash',
  instructorBrief: {
    progression: "Coronary artery aneurysms.",
    interventions: ["IVIG", "Aspirin (High dose)", "Echo"],
    learningObjectives: ["CRASH and Burn criteria", "Aspirin in paeds"]
  },
  vitalsMod: {
    hr: 140,
    bpSys: 95,
    spO2: 98,
    temp: 39.5
  },
  deterioration: {
    active: false,
    rate: 0
  },
  stabilisers: ['IVIG', 'Aspirin'],
  recommendedActions: ['Obs', 'IV Access', 'IVIG', 'Aspirin', 'Fluids', 'Analgesia']
}, {
  id: 'PA012',
  title: 'Sickle Cell Crisis',
  category: 'Medical',
  ageRange: 'Paediatric',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(5, 12);
  },
  patientProfileTemplate: "A {age}-year-old. Known Sickle Cell. Severe chest pain and hypoxia.",
  presentingComplaint: 'Chest Pain',
  instructorBrief: {
    progression: "Acute Chest Syndrome.",
    interventions: ["Oxygen", "Opioids", "Antibiotics", "Exchange Transfusion"],
    learningObjectives: ["Acute Chest recognition", "Analgesia ladder"]
  },
  vitalsMod: {
    hr: 150,
    bpSys: 100,
    spO2: 85,
    rr: 40
  },
  deterioration: {
    active: true,
    rate: 0.1,
    type: 'respiratory'
  },
  stabilisers: ['Oxygen', 'Analgesia', 'Antibiotics'],
  recommendedActions: ['Obs', 'IV Access', 'Oxygen', 'Analgesia', 'Antibiotics', 'Fluids']
}, {
  id: 'PA013',
  title: 'Foreign Body Aspiration',
  category: 'Medical',
  ageRange: 'Paediatric',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(2, 4);
  },
  patientProfileTemplate: "A {age}-year-old. Playing with lego. Sudden onset cough/stridor.",
  presentingComplaint: 'Choking',
  instructorBrief: {
    progression: "Total obstruction. Arrest.",
    interventions: ["Back blows", "Magill's forceps", "RSI (Push tube)"],
    learningObjectives: ["Choking algorithm", "Unilateral wheeze"]
  },
  vitalsMod: {
    hr: 160,
    bpSys: 90,
    spO2: 88,
    rr: 45
  },
  deterioration: {
    active: true,
    rate: 0.2,
    type: 'airway'
  },
  stabilisers: ['Manoeuvres'],
  recommendedActions: ['Obs', 'Oxygen', 'Manoeuvres', 'RSI', 'Magills']
}, {
  id: 'PA014',
  title: 'Testicular Torsion',
  category: 'Medical',
  sex: 'Male',
  ageRange: 'Paediatric',
  acuity: 'Majors',
  ageGenerator: function ageGenerator() {
    return getRandomInt(10, 15);
  },
  patientProfileTemplate: "A {age}-year-old. Sudden severe groin pain and vomiting.",
  presentingComplaint: 'Testicular Pain',
  instructorBrief: {
    progression: "Ischaemia/Loss of testis.",
    interventions: ["Urgent Urology/Surgery", "Analgesia"],
    learningObjectives: ["Time to theatre (<6hrs)", "Do not wait for Ultrasound"]
  },
  vitalsMod: {
    hr: 110,
    bpSys: 120,
    spO2: 99
  },
  deterioration: {
    active: false,
    rate: 0
  },
  stabilisers: ['Surgery', 'Analgesia'],
  recommendedActions: ['Obs', 'IV Access', 'Surgery', 'Analgesia']
}, {
  id: 'PA015',
  title: 'Septic Arthritis',
  category: 'Medical',
  ageRange: 'Paediatric',
  acuity: 'Majors',
  ageGenerator: function ageGenerator() {
    return getRandomInt(3, 8);
  },
  patientProfileTemplate: "A {age}-year-old. High fever. Refusing to walk on right leg.",
  presentingComplaint: 'Limp & Fever',
  instructorBrief: {
    progression: "Joint destruction. Sepsis.",
    interventions: ["IV Antibiotics", "Orthopaedic Washout", "Kocher's Criteria"],
    learningObjectives: ["Kocher's Criteria", "Transient synovitis diff dx"]
  },
  vitalsMod: {
    hr: 130,
    bpSys: 100,
    spO2: 98,
    temp: 39.2
  },
  deterioration: {
    active: true,
    rate: 0.05,
    type: 'shock'
  },
  stabilisers: ['Antibiotics', 'Surgery'],
  recommendedActions: ['Obs', 'IV Access', 'Antibiotics', 'Surgery', 'Analgesia']
}, {
  id: 'OB006',
  title: 'Postpartum Haemorrhage',
  category: 'Obstetrics & Gynae',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(18, 40);
  },
  patientProfileTemplate: "A {age}-year-old. Just delivered baby. Continuous heavy bleeding.",
  presentingComplaint: 'Haemorrhage',
  instructorBrief: {
    progression: "Major Haemorrhage (4 Ts).",
    interventions: ["Uterine Massage", "Oxytocin/Ergometrine", "TXA", "MTP"],
    learningObjectives: ["4 Ts of PPH", "Bimanual compression", "Give uterotonics and tranexamic acid"]
  },
  vitalsMod: {
    hr: 140,
    bpSys: 70,
    spO2: 94,
    rr: 28
  },
  deterioration: {
    active: true,
    rate: 0.2,
    type: 'shock'
  },
  stabilisers: ['Oxytocin', 'Ergometrine', 'Blood', 'TXA'],
  vbgClinicalState: "haemorrhagic_shock",
  recommendedActions: ['Obs', 'IV Access', 'Oxytocin', 'Ergometrine', 'Blood', 'TXA', 'Carboprost']
}, {
  id: 'OB007',
  title: 'Ovarian Torsion',
  category: 'Obstetrics & Gynae',
  ageRange: 'Adult',
  acuity: 'Majors',
  ageGenerator: function ageGenerator() {
    return getRandomInt(18, 35);
  },
  patientProfileTemplate: "A {age}-year-old. Sudden onset severe unilateral iliac fossa pain. Vomiting.",
  presentingComplaint: 'Abdo Pain',
  instructorBrief: {
    progression: "Ovarian ischaemia.",
    interventions: ["Analgesia", "Gynae Referral (Laparoscopy)"],
    learningObjectives: ["Ultrasound utility", "Torsion risk factors"]
  },
  vitalsMod: {
    hr: 115,
    bpSys: 130,
    spO2: 98
  },
  deterioration: {
    active: false,
    rate: 0
  },
  stabilisers: ['Surgery', 'Analgesia'],
  recommendedActions: ['Obs', 'IV Access', 'Surgery', 'Analgesia']
}, {
  id: 'OB008',
  title: 'Peripartum Cardiomyopathy',
  category: 'Obstetrics & Gynae',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(18, 40);
  },
  patientProfileTemplate: "A {age}-year-old. 1 week post-partum. Severe orthopnoea and pedal oedema.",
  presentingComplaint: 'Heart Failure',
  instructorBrief: {
    progression: "Acute Pulmonary Oedema/Cardiogenic Shock.",
    interventions: ["Diuretics", "GTN", "Echo"],
    learningObjectives: ["PPCM diagnosis", "Fluid management in failure"]
  },
  vitalsMod: {
    hr: 125,
    bpSys: 140,
    spO2: 88,
    rr: 30
  },
  deterioration: {
    active: true,
    rate: 0.1,
    type: 'cardiac'
  },
  stabilisers: ['Furosemide', 'GTN', 'CPAP'],
  ecg: {
    type: "Sinus Tachy",
    findings: "Global T wave inversion"
  },
  recommendedActions: ['Obs', 'IV Access', 'Furosemide', 'GTN', 'CPAP', 'Oxygen']
}, {
  id: 'EL006',
  title: 'Acute Mesenteric Ischaemia',
  category: 'Medical',
  ageRange: 'Elderly',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(75, 90);
  },
  patientProfileTemplate: "A {age}-year-old with AF. Generalised abdo pain. Lactate 6.0.",
  presentingComplaint: 'Severe Abdo Pain',
  instructorBrief: {
    progression: "Bowel necrosis and perforation.",
    interventions: ["Surgery/IR", "Antibiotics", "Heparin"],
    learningObjectives: ["Pain out of proportion", "Lactate significance"]
  },
  vitalsMod: {
    hr: 120,
    bpSys: 100,
    spO2: 94,
    rr: 26
  },
  deterioration: {
    active: true,
    rate: 0.15,
    type: 'shock'
  },
  stabilisers: ['Surgery', 'Antibiotics'],
  vbgClinicalState: "metabolic_acidosis_severe",
  recommendedActions: ['Obs', 'IV Access', 'Surgery', 'Antibiotics', 'Fluids', 'Analgesia', 'Heparin']
}, {
  id: 'EL007',
  title: 'Temporal Arteritis',
  category: 'Medical',
  ageRange: 'Elderly',
  acuity: 'Majors',
  ageGenerator: function ageGenerator() {
    return getRandomInt(70, 85);
  },
  patientProfileTemplate: "A {age}-year-old. Severe temporal headache and jaw claudication.",
  presentingComplaint: 'Headache',
  instructorBrief: {
    progression: "Permanent blindness (Ischaemic optic neuropathy).",
    interventions: ["High Dose Steroids (Prednisolone)", "Ophthalmology/Rheum"],
    learningObjectives: ["GCA symptoms", "Steroid urgency"]
  },
  vitalsMod: {
    hr: 80,
    bpSys: 140,
    spO2: 98
  },
  deterioration: {
    active: false,
    rate: 0
  },
  stabilisers: ['Dexamethasone', 'Hydrocortisone'],
  recommendedActions: ['Obs', 'IV Access', 'Dexamethasone', 'Analgesia']
}, {
  id: 'AM050',
  title: 'Severe Acute Pancreatitis',
  category: 'Medical',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(30, 60);
  },
  patientProfileTemplate: "A {age}-year-old. Severe epigastric pain radiating to back. Alcohol history.",
  presentingComplaint: 'Epigastric Pain',
  instructorBrief: {
    progression: "SIRS response. Hypocalcaemia. ARDS risk.",
    interventions: ["Aggressive Fluids", "Analgesia", "Calcium (if low)"],
    learningObjectives: ["Glasgow Score for Pancreatitis", "Fluid sequestration"]
  },
  vitalsMod: {
    hr: 125,
    bpSys: 100,
    spO2: 94,
    rr: 24,
    temp: 38.2
  },
  deterioration: {
    active: true,
    rate: 0.1,
    type: 'shock'
  },
  stabilisers: ['Fluids', 'Analgesia'],
  vbgClinicalState: "metabolic_acidosis_severe",
  recommendedActions: ['Obs', 'IV Access', 'Fluids', 'Analgesia', 'Calcium']
}, {
  id: 'AM051',
  title: 'Hepatic Encephalopathy',
  category: 'Medical',
  ageRange: 'Adult',
  acuity: 'Majors',
  ageGenerator: function ageGenerator() {
    return getRandomInt(45, 70);
  },
  patientProfileTemplate: "A {age}-year-old with cirrhosis. Found confused and flapping tremor.",
  presentingComplaint: 'Confusion',
  instructorBrief: {
    progression: "Risk of airway compromise and cerebral oedema.",
    interventions: ["Lactulose (Enema)", "Rifaximin", "Treat precipitant"],
    learningObjectives: ["Ammonia levels", "West Haven Criteria"]
  },
  vitalsMod: {
    hr: 90,
    bpSys: 110,
    spO2: 96,
    gcs: 12
  },
  deterioration: {
    active: true,
    rate: 0.05,
    type: 'neuro'
  },
  stabilisers: ['Lactulose'],
  recommendedActions: ['Obs', 'IV Access', 'Lactulose', 'Fluids', 'Rifaximin']
}, {
  id: 'AM052',
  title: 'Spontaneous Bacterial Peritonitis',
  category: 'Medical',
  ageRange: 'Adult',
  acuity: 'Majors',
  ageGenerator: function ageGenerator() {
    return getRandomInt(40, 65);
  },
  patientProfileTemplate: "A {age}-year-old with ascites. Abdominal pain and fever.",
  presentingComplaint: 'Abdo Pain & Fever',
  instructorBrief: {
    progression: "Septic shock.",
    interventions: ["Ascitic Tap (Urgent)", "IV Albumin", "Antibiotics"],
    learningObjectives: ["SBP diagnosis (Neutrophils >250)", "Albumin indications"]
  },
  vitalsMod: {
    hr: 115,
    bpSys: 95,
    spO2: 95,
    temp: 38.5
  },
  deterioration: {
    active: true,
    rate: 0.1,
    type: 'shock'
  },
  stabilisers: ['Antibiotics', 'Fluids'],
  vbgClinicalState: "septic_shock",
  recommendedActions: ['Obs', 'IV Access', 'Antibiotics', 'Fluids', 'Analgesia']
}, {
  id: 'AM053',
  title: 'Infective Endocarditis',
  category: 'Medical',
  ageRange: 'Adult',
  acuity: 'Majors',
  ageGenerator: function ageGenerator() {
    return getRandomInt(25, 60);
  },
  patientProfileTemplate: "A {age}-year-old IVDU. 3 weeks fever, new murmur, malaise.",
  presentingComplaint: 'Fever & SOB',
  instructorBrief: {
    progression: "Valve failure and heart failure. Embolic events.",
    interventions: ["Blood Cultures x3", "Antibiotics", "Echo"],
    learningObjectives: ["Duke Criteria", "Embolic phenomena"]
  },
  vitalsMod: {
    hr: 110,
    bpSys: 110,
    spO2: 93,
    temp: 39.0
  },
  deterioration: {
    active: true,
    rate: 0.05,
    type: 'cardiac'
  },
  stabilisers: ['Antibiotics', 'Oxygen'],
  recommendedActions: ['Obs', 'IV Access', 'Antibiotics', 'Oxygen', 'Fluids']
}, {
  id: 'AM054',
  title: 'Severe Aortic Stenosis',
  category: 'Medical',
  ageRange: 'Elderly',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(75, 90);
  },
  patientProfileTemplate: "A {age}-year-old. Collapsed on exertion. Systolic murmur.",
  presentingComplaint: 'Syncope',
  instructorBrief: {
    progression: "Cardiogenic shock. Pre-load dependent.",
    interventions: ["Cautious Fluids", "Treat Arrhythmia", "Avoid GTN"],
    learningObjectives: ["Fixed output state", "Medications to avoid"]
  },
  vitalsMod: {
    hr: 90,
    bpSys: 95,
    spO2: 94
  },
  deterioration: {
    active: true,
    rate: 0.1,
    type: 'shock'
  },
  ecg: {
    type: "Sinus Rhythm",
    findings: "LVH with Strain"
  },
  recommendedActions: ['Obs', 'IV Access', 'Fluids']
}, {
  id: 'AM055',
  title: 'HOCM Arrest',
  category: 'Cardiac Arrest',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(18, 30);
  },
  patientProfileTemplate: "A {age}-year-old athlete. Collapsed mid-game.",
  presentingComplaint: 'Cardiac Arrest',
  instructorBrief: {
    progression: "VF Arrest. Post-ROSC care critical.",
    interventions: ["Defibrillation", "Amiodarone", "Cooling"],
    learningObjectives: ["Hypertrophic Cardiomyopathy", "Screening family", "Manage a shockable arrest"]
  },
  vitalsMod: {
    hr: 0,
    bpSys: 0,
    spO2: 0,
    gcs: 3
  },
  deterioration: {
    active: false,
    rate: 0
  },
  ecg: {
    type: "VF",
    findings: "VF -> Deep Q waves post ROSC"
  },
  recommendedActions: ['Obs', 'CPR', 'Defib', 'AdrenalineIV', 'Amiodarone']
}, {
  id: 'AM056',
  title: 'Pre-excited AF (WPW)',
  category: 'Medical',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(20, 40);
  },
  patientProfileTemplate: "A {age}-year-old. Palpitations. Known WPW.",
  presentingComplaint: 'Palpitations',
  instructorBrief: {
    progression: "Irregular Broad Complex Tachycardia. Risk of VF.",
    interventions: ["DC Cardioversion", "Procainamide/Flecainide", "AVOID Adenosine/Blockers"],
    learningObjectives: ["FBI (Fast Broad Irregular)", "Contraindicated drugs"]
  },
  vitalsMod: {
    hr: 180,
    bpSys: 90,
    spO2: 96
  },
  deterioration: {
    active: true,
    rate: 0.2,
    type: 'cardiac'
  },
  ecg: {
    type: "AF",
    findings: "Irregular Broad Complex Tachycardia"
  },
  stabilisers: ['Cardioversion'],
  recommendedActions: ['Obs', 'IV Access', 'Cardioversion']
}, {
  id: 'AM057',
  title: 'Acute Angle Closure Glaucoma',
  category: 'Medical',
  ageRange: 'Adult',
  acuity: 'Majors',
  ageGenerator: function ageGenerator() {
    return getRandomInt(50, 80);
  },
  patientProfileTemplate: "A {age}-year-old. Severe eye pain, vomiting, halos around lights.",
  presentingComplaint: 'Eye Pain & Vomiting',
  instructorBrief: {
    progression: "Permanent vision loss.",
    interventions: ["Acetazolamide", "Timolol/Pilocarpine", "Ophthalmology"],
    learningObjectives: ["Fixed mid-dilated pupil", "IOP reduction"]
  },
  vitalsMod: {
    hr: 90,
    bpSys: 140,
    spO2: 98,
    pupils: "Fixed Mid-dilated R"
  },
  deterioration: {
    active: false,
    rate: 0
  },
  stabilisers: ['Analgesia'],
  recommendedActions: ['Obs', 'IV Access', 'Analgesia', 'Antiemetic', 'Acetazolamide', 'TopicalEyeDrops']
}, {
  id: 'AM058',
  title: 'Central Retinal Artery Occlusion',
  category: 'Medical',
  ageRange: 'Elderly',
  acuity: 'Majors',
  ageGenerator: function ageGenerator() {
    return getRandomInt(65, 85);
  },
  patientProfileTemplate: "A {age}-year-old. Sudden painless loss of vision in one eye.",
  presentingComplaint: 'Vision Loss',
  instructorBrief: {
    progression: "Retinal infarction. Stroke workup needed.",
    interventions: ["Ocular Massage", "Timolol/Acetazolamide", "Stroke Team"],
    learningObjectives: ["Cherry red spot", "Embolic source"]
  },
  vitalsMod: {
    hr: 75,
    bpSys: 150,
    spO2: 98
  },
  deterioration: {
    active: false,
    rate: 0
  },
  recommendedActions: ['Obs', 'IV Access', 'TopicalEyeDrops', 'Acetazolamide']
}, {
  id: 'AM059',
  title: 'Adult Epiglottitis',
  category: 'Medical',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(30, 60);
  },
  patientProfileTemplate: "A {age}-year-old. Severe sore throat, drooling, leaning forward.",
  presentingComplaint: 'Stridor & Drooling',
  instructorBrief: {
    progression: "Complete airway obstruction.",
    interventions: ["Neb Adrenaline", "Dexamethasone", "Awake Fibreoptic"],
    learningObjectives: ["Never examine throat", "Airway strategy"]
  },
  vitalsMod: {
    hr: 120,
    bpSys: 130,
    spO2: 94,
    rr: 28,
    temp: 38.8
  },
  deterioration: {
    active: true,
    rate: 0.2,
    type: 'airway'
  },
  stabilisers: ['NebAdrenaline', 'Dexamethasone', 'RSI'],
  recommendedActions: ['Obs', 'IV Access', 'Oxygen', 'NebAdrenaline', 'Dexamethasone', 'Ceftriaxone', 'RSI', 'FONA']
}, {
  id: 'AM060',
  title: 'Quinsy',
  category: 'Medical',
  ageRange: 'Adult',
  acuity: 'Majors',
  ageGenerator: function ageGenerator() {
    return getRandomInt(18, 35);
  },
  patientProfileTemplate: "A {age}-year-old. Severe unilateral sore throat, trismus, uvula deviation.",
  presentingComplaint: 'Sore Throat',
  instructorBrief: {
    progression: "Airway compromise.",
    interventions: ["Needle Aspiration", "Antibiotics", "Dexamethasone"],
    learningObjectives: ["Quinsy vs Tonsillitis", "Drainage technique"]
  },
  vitalsMod: {
    hr: 100,
    bpSys: 120,
    spO2: 98,
    temp: 38.5
  },
  deterioration: {
    active: false,
    rate: 0
  },
  stabilisers: ['Antibiotics', 'Dexamethasone'],
  recommendedActions: ['Obs', 'IV Access', 'Antibiotics', 'Dexamethasone', 'Analgesia']
}, {
  id: 'AM061',
  title: 'PJP Pneumonia (HIV)',
  category: 'Medical',
  ageRange: 'Adult',
  acuity: 'Majors',
  ageGenerator: function ageGenerator() {
    return getRandomInt(25, 50);
  },
  patientProfileTemplate: "A {age}-year-old. Dry cough and exertional dyspnoea. HIV positive (non-compliant).",
  presentingComplaint: 'Dyspnoea',
  instructorBrief: {
    progression: "Hypoxia worsens significantly on exertion.",
    interventions: ["High Dose Co-trimoxazole", "Steroids (if hypoxic)"],
    learningObjectives: ["PJP presentation", "Exercise desaturation"]
  },
  vitalsMod: {
    hr: 110,
    bpSys: 115,
    spO2: 92,
    rr: 24
  },
  deterioration: {
    active: true,
    rate: 0.1,
    type: 'respiratory'
  },
  stabilisers: ['Antibiotics', 'Oxygen'],
  recommendedActions: ['Obs', 'IV Access', 'Antibiotics', 'Oxygen', 'Dexamethasone']
}, {
  id: 'AM062',
  title: 'Tumour Lysis Syndrome',
  category: 'Medical',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(20, 70);
  },
  patientProfileTemplate: "A {age}-year-old. Started chemo yesterday for Leukaemia. Lethargic.",
  presentingComplaint: 'Lethargy',
  instructorBrief: {
    progression: "Hyperkalaemia, Hyperphosphataemia, Renal Failure.",
    interventions: ["Aggressive Hydration", "Rasburicase", "Calcium (if symptomatic)"],
    learningObjectives: ["Electrolyte disturbances", "Rasburicase indications"]
  },
  vitalsMod: {
    hr: 90,
    bpSys: 100,
    spO2: 96
  },
  deterioration: {
    active: true,
    rate: 0.1,
    type: 'cardiac'
  },
  vbgClinicalState: "hyperkalemia",
  recommendedActions: ['Obs', 'IV Access', 'Fluids', 'Calcium', 'InsulinDextrose', 'Rasburicase']
}, {
  id: 'AM063',
  title: 'Exertional Rhabdomyolysis',
  category: 'Medical',
  ageRange: 'Adult',
  acuity: 'Majors',
  ageGenerator: function ageGenerator() {
    return getRandomInt(20, 35);
  },
  patientProfileTemplate: "A {age}-year-old. First crossfit session yesterday. Severe muscle pain and dark urine.",
  presentingComplaint: 'Muscle Pain',
  instructorBrief: {
    progression: "AKI and Hyperkalaemia.",
    interventions: ["Aggressive IV Fluids (300ml/hr+)", "Monitor K+"],
    learningObjectives: ["CK levels", "Myoglobinuria"]
  },
  vitalsMod: {
    hr: 100,
    bpSys: 125,
    spO2: 98
  },
  deterioration: {
    active: false,
    rate: 0
  },
  stabilisers: ['Fluids'],
  recommendedActions: ['Obs', 'IV Access', 'Fluids', 'Analgesia']
}, {
  id: 'AM064',
  title: 'Hypertensive Emergency',
  category: 'Medical',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(40, 60);
  },
  patientProfileTemplate: "A {age}-year-old. Headache, confusion, visual disturbance. BP 240/130.",
  presentingComplaint: 'Confusion',
  instructorBrief: {
    progression: "PRES or Intracranial Bleed.",
    interventions: ["Labetalol Infusion", "GTN Infusion", "CT Head"],
    learningObjectives: ["Rate of BP reduction (Max 25% first hour)"]
  },
  vitalsMod: {
    hr: 90,
    bpSys: 240,
    bpDia: 130,
    spO2: 96,
    gcs: 13
  },
  deterioration: {
    active: true,
    rate: 0.1,
    type: 'neuro'
  },
  stabilisers: ['Labetalol', 'GTNInfusion'],
  recommendedActions: ['Obs', 'IV Access', 'Labetalol', 'GTNInfusion']
}, {
  id: 'AT014',
  title: 'Blast Injury',
  category: 'Trauma',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(20, 50);
  },
  patientProfileTemplate: "A {age}-year-old. Explosion in closed space.",
  presentingComplaint: 'Polytrauma',
  instructorBrief: {
    progression: "Blast lung, tympanic rupture, bowel injury.",
    interventions: ["Airway support", "Chest Drain", "Trauma CT"],
    learningObjectives: ["Blast wave physics", "Blast lung management"]
  },
  vitalsMod: {
    hr: 120,
    bpSys: 100,
    spO2: 88,
    rr: 30
  },
  deterioration: {
    active: true,
    rate: 0.1,
    type: 'respiratory'
  },
  stabilisers: ['Oxygen', 'SurgicalDrain'],
  recommendedActions: ['Obs', 'IV Access', 'Oxygen', 'SurgicalDrain', 'Fluids', 'Analgesia']
}, {
  id: 'AT015',
  title: 'Traumatic Aortic Rupture',
  category: 'Trauma',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(20, 50);
  },
  patientProfileTemplate: "A {age}-year-old. High speed deceleration (RTC). Chest pain.",
  presentingComplaint: 'Chest Pain',
  instructorBrief: {
    progression: "Exsanguination.",
    interventions: ["Permissive Hypotension (strictly)", "Surgery/Stent"],
    learningObjectives: ["Widened mediastinum", "BP targets"]
  },
  vitalsMod: {
    hr: 110,
    bpSys: 90,
    spO2: 94
  },
  deterioration: {
    active: true,
    rate: 0.15,
    type: 'shock'
  },
  stabilisers: ['Surgery'],
  recommendedActions: ['Obs', 'IV Access', 'Surgery', 'Blood', 'Analgesia']
}, {
  id: 'AT016',
  title: 'Diaphragmatic Rupture',
  category: 'Trauma',
  ageRange: 'Adult',
  acuity: 'Majors',
  ageGenerator: function ageGenerator() {
    return getRandomInt(20, 50);
  },
  patientProfileTemplate: "A {age}-year-old. Crush injury to abdomen. Bowel sounds in chest.",
  presentingComplaint: 'Dyspnoea',
  instructorBrief: {
    progression: "Respiratory compromise and bowel strangulation.",
    interventions: ["NG Tube (Caution)", "Surgery"],
    learningObjectives: ["CXR interpretation", "NGT path"]
  },
  vitalsMod: {
    hr: 100,
    bpSys: 110,
    spO2: 92,
    rr: 26
  },
  deterioration: {
    active: true,
    rate: 0.05,
    type: 'respiratory'
  },
  chestXray: {
    findings: "NG tube coiling in chest, bowel loops visible"
  },
  recommendedActions: ['Obs', 'IV Access', 'Surgery', 'Analgesia']
}, {
  id: 'AT017',
  title: 'Retrobulbar Haematoma',
  category: 'Trauma',
  ageRange: 'Adult',
  acuity: 'Majors',
  ageGenerator: function ageGenerator() {
    return getRandomInt(20, 60);
  },
  patientProfileTemplate: "A {age}-year-old. Punch to eye. Proptosis and loss of vision.",
  presentingComplaint: 'Eye Trauma',
  instructorBrief: {
    progression: "Permanent blindness < 2 hours.",
    interventions: ["Lateral Canthotomy (Immediate)", "Do not wait for CT"],
    learningObjectives: ["Canthotomy technique", "Orbital compartment syndrome"]
  },
  vitalsMod: {
    hr: 90,
    bpSys: 140,
    spO2: 98
  },
  deterioration: {
    active: false,
    rate: 0
  },
  stabilisers: ['Canthotomy'],
  recommendedActions: ['Obs', 'IV Access', 'Canthotomy', 'Analgesia']
}, {
  id: 'AT018',
  title: 'Knee Dislocation',
  category: 'Trauma',
  ageRange: 'Adult',
  acuity: 'Majors',
  ageGenerator: function ageGenerator() {
    return getRandomInt(20, 40);
  },
  patientProfileTemplate: "A {age}-year-old. Rugby tackle. Deformity of knee. Foot cold.",
  presentingComplaint: 'Leg Injury',
  instructorBrief: {
    progression: "Popliteal artery injury.",
    interventions: ["Reduction (Immediate)", "Vascular Surgery"],
    learningObjectives: ["Vascular check pre/post reduction", "Hard signs of ischaemia"]
  },
  vitalsMod: {
    hr: 110,
    bpSys: 130,
    spO2: 99
  },
  deterioration: {
    active: false,
    rate: 0
  },
  stabilisers: ['Reduction'],
  recommendedActions: ['Obs', 'IV Access', 'Reduction', 'Surgery', 'Analgesia']
}, {
  id: 'AT019',
  title: 'Ankle Fracture-Dislocation',
  category: 'Trauma',
  ageRange: 'Adult',
  acuity: 'Majors',
  ageGenerator: function ageGenerator() {
    return getRandomInt(20, 60);
  },
  patientProfileTemplate: "A {age}-year-old. Fall. Ankle severely deformed, skin tenting/blanching.",
  presentingComplaint: 'Ankle Injury',
  instructorBrief: {
    progression: "Skin necrosis and open fracture.",
    interventions: ["Immediate Reduction", "Backslab"],
    learningObjectives: ["Skin threat urgency", "Sedation reduction"]
  },
  vitalsMod: {
    hr: 100,
    bpSys: 140,
    spO2: 98
  },
  deterioration: {
    active: false,
    rate: 0
  },
  stabilisers: ['Reduction', 'Plaster'],
  recommendedActions: ['Obs', 'IV Access', 'Reduction', 'Plaster', 'Analgesia']
}, {
  id: 'AT020',
  title: 'Straddle Injury',
  category: 'Trauma',
  ageRange: 'Adult',
  acuity: 'Majors',
  ageGenerator: function ageGenerator() {
    return getRandomInt(18, 30);
  },
  patientProfileTemplate: "A {age}-year-old. Fell onto bike crossbar. Blood at meatus.",
  presentingComplaint: 'Groin Pain',
  instructorBrief: {
    progression: "Urethral tear.",
    interventions: ["Do NOT catheterise", "Urology urgency", "Suprapubic Catheter"],
    learningObjectives: ["Urethral injury signs", "Retrograde urethrogram"]
  },
  vitalsMod: {
    hr: 90,
    bpSys: 120,
    spO2: 99
  },
  deterioration: {
    active: false,
    rate: 0
  },
  recommendedActions: ['Obs', 'Analgesia']
}, {
  id: 'AT021',
  title: 'Chemical Eye Burn',
  category: 'Trauma',
  ageRange: 'Adult',
  acuity: 'Majors',
  ageGenerator: function ageGenerator() {
    return getRandomInt(20, 50);
  },
  patientProfileTemplate: "A {age}-year-old. Splashed industrial cleaner (Alkali) in eye.",
  presentingComplaint: 'Eye Pain',
  instructorBrief: {
    progression: "Corneal melting.",
    interventions: ["Irrigation (Litres!)", "Check pH"],
    learningObjectives: ["Alkali vs Acid", "Morgan lens"]
  },
  vitalsMod: {
    hr: 100,
    bpSys: 130,
    spO2: 98
  },
  deterioration: {
    active: false,
    rate: 0
  },
  stabilisers: ['Irrigation'],
  recommendedActions: ['Obs', 'Irrigation', 'Analgesia']
}, {
  id: 'AT022',
  title: 'Severe Maxillofacial Trauma',
  category: 'Trauma',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(20, 50);
  },
  patientProfileTemplate: "A {age}-year-old. Dashboard injury. Mid-face floating.",
  presentingComplaint: 'Facial Trauma',
  instructorBrief: {
    progression: "Airway obstruction (Blood/Teeth).",
    interventions: ["Sit up (if C-spine cleared)", "Suction", "Intubation (Difficult)"],
    learningObjectives: ["Le Fort fractures", "Airway adjuncts"]
  },
  vitalsMod: {
    hr: 120,
    bpSys: 110,
    spO2: 92,
    rr: 28
  },
  deterioration: {
    active: true,
    rate: 0.1,
    type: 'airway'
  },
  stabilisers: ['RSI', 'Suction'],
  recommendedActions: ['Obs', 'IV Access', 'Suction', 'RSI', 'Analgesia', 'Oxygen', 'FONA']
}, {
  id: 'AT023',
  title: 'Impaled Object',
  category: 'Trauma',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(20, 50);
  },
  patientProfileTemplate: "A {age}-year-old. Impaled on fence railing (Abdomen).",
  presentingComplaint: 'Impaled Object',
  instructorBrief: {
    progression: "Haemorrhage if removed.",
    interventions: ["Do NOT remove", "Stabilise object", "Theatre"],
    learningObjectives: ["Impaled object management"]
  },
  vitalsMod: {
    hr: 115,
    bpSys: 105,
    spO2: 96
  },
  deterioration: {
    active: false,
    rate: 0
  },
  stabilisers: ['Surgery'],
  recommendedActions: ['Obs', 'IV Access', 'Surgery', 'Blood', 'Analgesia']
}, {
  id: 'PA016',
  title: 'Pyloric Stenosis',
  category: 'Medical',
  ageRange: 'Paediatric',
  acuity: 'Majors',
  ageGenerator: function ageGenerator() {
    return 0.1;
  },
  patientProfileTemplate: "A 5-week-old. Projectile vomiting after feeds. Hungry.",
  presentingComplaint: 'Vomiting',
  instructorBrief: {
    progression: "Dehydration and Hypochloraemic Metabolic Alkalosis.",
    interventions: ["Fluid Resus", "Correction of Alkalosis", "Surgery"],
    learningObjectives: ["VBG interpretation", "Olive mass"]
  },
  vitalsMod: {
    hr: 160,
    bpSys: 75,
    spO2: 98,
    rr: 40,
    bm: 3.8
  },
  deterioration: {
    active: true,
    rate: 0.05,
    type: 'shock'
  },
  vbgClinicalState: "metabolic_alkalosis",
  recommendedActions: ['Obs', 'IV Access', 'Fluids', 'Surgery']
}, {
  id: 'PA017',
  title: 'Malrotation & Volvulus',
  category: 'Medical',
  ageRange: 'Paediatric',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return 0;
  },
  patientProfileTemplate: "A 3-day-old. Bilious vomiting and distended abdomen.",
  presentingComplaint: 'Bilious Vomiting',
  instructorBrief: {
    progression: "Gut ischaemia and necrosis.",
    interventions: ["NG Tube", "Fluid Resus", "Urgent Surgery"],
    learningObjectives: ["Bilious vomiting is red flag", "Upper GI Contrast"]
  },
  vitalsMod: {
    hr: 180,
    bpSys: 60,
    spO2: 90,
    rr: 60
  },
  deterioration: {
    active: true,
    rate: 0.15,
    type: 'shock'
  },
  stabilisers: ['Surgery', 'Fluids'],
  recommendedActions: ['Obs', 'IV Access', 'Surgery', 'Fluids', 'Analgesia']
}, {
  id: 'PA018',
  title: 'Congenital Adrenal Hyperplasia',
  category: 'Medical',
  ageRange: 'Paediatric',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return 0.04;
  },
  patientProfileTemplate: "A 2-week-old. Vomiting, weight loss. Ambiguous genitalia.",
  presentingComplaint: 'Failure to Thrive',
  instructorBrief: {
    progression: "Salt-wasting crisis (Low Na, High K). Shock.",
    interventions: ["Hydrocortisone", "Saline Bolus", "Glucose"],
    learningObjectives: ["CAH pathophysiology", "Hyperkalaemia in neonate"]
  },
  vitalsMod: {
    hr: 170,
    bpSys: 55,
    spO2: 94,
    bm: 2.5
  },
  deterioration: {
    active: true,
    rate: 0.1,
    type: 'shock'
  },
  vbgClinicalState: "hyperkalemia",
  recommendedActions: ['Obs', 'IV Access', 'Hydrocortisone', 'Fluids', 'Dextrose']
}, {
  id: 'PA019',
  title: 'Pertussis (Whooping Cough)',
  category: 'Medical',
  ageRange: 'Paediatric',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return 0.25;
  },
  patientProfileTemplate: "A 3-month-old. Coughing spells turning blue. Apnoeas.",
  presentingComplaint: 'Cough & Cyanosis',
  instructorBrief: {
    progression: "Apnoea and bradycardia.",
    interventions: ["Oxygen", "Suction", "Antibiotics (Macrolide)"],
    learningObjectives: ["Apnoea management", "Vaccination history"]
  },
  vitalsMod: {
    hr: 160,
    bpSys: 80,
    spO2: 88,
    rr: 60
  },
  deterioration: {
    active: true,
    rate: 0.1,
    type: 'respiratory'
  },
  stabilisers: ['Oxygen', 'Antibiotics'],
  recommendedActions: ['Obs', 'Oxygen', 'Antibiotics', 'Suction']
}, {
  id: 'PA020',
  title: 'Measles',
  category: 'Medical',
  ageRange: 'Paediatric',
  acuity: 'Majors',
  ageGenerator: function ageGenerator() {
    return getRandomInt(1, 5);
  },
  patientProfileTemplate: "A {age}-year-old. High fever, coryza, conjunctivitis, rash.",
  presentingComplaint: 'Fever & Rash',
  instructorBrief: {
    progression: "Pneumonia or Encephalitis.",
    interventions: ["Vitamin A", "Isolation", "Supportive"],
    learningObjectives: ["Koplik spots", "Isolation protocols"]
  },
  vitalsMod: {
    hr: 140,
    bpSys: 95,
    spO2: 94,
    temp: 40.0
  },
  deterioration: {
    active: true,
    rate: 0.05,
    type: 'respiratory'
  },
  recommendedActions: ['Obs', 'IV Access', 'Fluids', 'Analgesia', 'VitaminA']
}, {
  id: 'PA021',
  title: 'Inborn Error of Metabolism',
  category: 'Medical',
  ageRange: 'Paediatric',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return 0.02;
  },
  patientProfileTemplate: "A 1-week-old. Encephalopathic, poor feeding, seizures.",
  presentingComplaint: 'Seizures',
  instructorBrief: {
    progression: "Hyperammonaemia. Brain injury.",
    interventions: ["Stop feeds", "Glucose 10%", "Ammonia Scavengers"],
    learningObjectives: ["Ammonia measurement", "Sepsis mimic"]
  },
  vitalsMod: {
    hr: 160,
    bpSys: 70,
    spO2: 95,
    gcs: 8
  },
  deterioration: {
    active: true,
    rate: 0.1,
    type: 'neuro'
  },
  stabilisers: ['Dextrose'],
  recommendedActions: ['Obs', 'IV Access', 'Dextrose']
}, {
  id: 'PA022',
  title: 'Supracondylar Fracture',
  category: 'Trauma',
  ageRange: 'Paediatric',
  acuity: 'Majors',
  ageGenerator: function ageGenerator() {
    return getRandomInt(4, 8);
  },
  patientProfileTemplate: "A {age}-year-old. Fall from monkey bars. Pale hand.",
  presentingComplaint: 'Arm Injury',
  instructorBrief: {
    progression: "Vascular compromise (Brachial artery).",
    interventions: ["Urgent Reduction", "Orthopaedics"],
    learningObjectives: ["Gartland classification", "Pulse check"]
  },
  vitalsMod: {
    hr: 120,
    bpSys: 100,
    spO2: 99
  },
  deterioration: {
    active: false,
    rate: 0
  },
  stabilisers: ['Reduction'],
  recommendedActions: ['Obs', 'IV Access', 'Reduction', 'Surgery', 'Analgesia']
}, {
  id: 'PA023',
  title: 'Severe Neonatal Jaundice',
  category: 'Medical',
  ageRange: 'Paediatric',
  acuity: 'Majors',
  ageGenerator: function ageGenerator() {
    return 0;
  },
  patientProfileTemplate: "A 4-day-old. Yellow down to toes. Lethargic.",
  presentingComplaint: 'Jaundice',
  instructorBrief: {
    progression: "Kernicterus.",
    interventions: ["Phototherapy", "Exchange Transfusion (if critical)", "Hydration"],
    learningObjectives: ["Bilirubin nomogram", "Kernicterus signs"]
  },
  vitalsMod: {
    hr: 150,
    bpSys: 70,
    spO2: 98,
    gcs: 12
  },
  deterioration: {
    active: true,
    rate: 0.05,
    type: 'neuro'
  },
  recommendedActions: ['Obs', 'Fluids', 'Phototherapy']
}, {
  id: 'PA024',
  title: 'Paediatric Scald',
  category: 'Trauma',
  ageRange: 'Paediatric',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(1, 3);
  },
  patientProfileTemplate: "A {age}-year-old. Pulled kettle over. Burns to chest and face.",
  presentingComplaint: 'Burns',
  instructorBrief: {
    progression: "Airway oedema. Hypothermia.",
    interventions: ["Cooling (20 mins)", "Cling Film", "Ketamine"],
    learningObjectives: ["Lund and Browder", "Cooling limits"]
  },
  vitalsMod: {
    hr: 160,
    bpSys: 90,
    spO2: 95,
    temp: 36.5
  },
  deterioration: {
    active: true,
    rate: 0.1,
    type: 'airway'
  },
  stabilisers: ['Analgesia', 'Warming'],
  recommendedActions: ['Obs', 'IV Access', 'Analgesia', 'Warming', 'Ketamine', 'Fluids', 'Cooling']
}, {
  id: 'PA025',
  title: 'Complex Febrile Convulsion',
  category: 'Medical',
  ageRange: 'Paediatric',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(1, 4);
  },
  patientProfileTemplate: "A {age}-year-old. Seizure > 15 mins. Fever.",
  presentingComplaint: 'Seizure',
  instructorBrief: {
    progression: "Status Epilepticus.",
    interventions: ["Benzodiazepines", "Paracetamol (for comfort)", "Source hunt"],
    learningObjectives: ["Simple vs Complex", "Meningitis exclusion"]
  },
  vitalsMod: {
    hr: 150,
    bpSys: 95,
    spO2: 92,
    temp: 39.8,
    gcs: 3
  },
  deterioration: {
    active: true,
    rate: 0.1,
    type: 'neuro'
  },
  stabilisers: ['Midazolam', 'Lorazepam'],
  recommendedActions: ['Obs', 'Oxygen', 'Midazolam', 'Lorazepam', 'Paracetamol']
}, {
  id: 'OB009',
  title: 'Uterine Inversion',
  category: 'Obstetrics & Gynae',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(18, 40);
  },
  patientProfileTemplate: "A {age}-year-old. Just delivered. Mass at introitus. Shock.",
  presentingComplaint: 'Collapse',
  instructorBrief: {
    progression: "Neurogenic and Haemorrhagic Shock.",
    interventions: ["Johnson Manoeuvre (Push back)", "Stop Oxytocin", "Fluids"],
    learningObjectives: ["Do not pull cord", "Reinvert immediately"]
  },
  vitalsMod: {
    hr: 130,
    bpSys: 70,
    spO2: 94
  },
  deterioration: {
    active: true,
    rate: 0.15,
    type: 'shock'
  },
  stabilisers: ['Fluids', 'Surgery'],
  recommendedActions: ['Obs', 'IV Access', 'Fluids', 'Surgery', 'ObstetricManoeuvres']
}, {
  id: 'OB010',
  title: 'Placental Abruption',
  category: 'Obstetrics & Gynae',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(18, 40);
  },
  patientProfileTemplate: "34 weeks pregnant. Severe constant abdo pain. 'Woody' uterus.",
  presentingComplaint: 'Abdo Pain',
  instructorBrief: {
    progression: "Fetal distress and DIC.",
    interventions: ["Emergency C-Section", "Blood Products"],
    learningObjectives: ["Concealed abruption", "Pain disproportionate to bleed"]
  },
  vitalsMod: {
    hr: 110,
    bpSys: 100,
    spO2: 98
  },
  deterioration: {
    active: true,
    rate: 0.1,
    type: 'shock'
  },
  stabilisers: ['Delivery', 'Blood'],
  recommendedActions: ['Obs', 'IV Access', 'Delivery', 'Blood', 'Analgesia']
}, {
  id: 'OB011',
  title: 'Placenta Praevia Bleed',
  category: 'Obstetrics & Gynae',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(18, 40);
  },
  patientProfileTemplate: "32 weeks pregnant. Sudden painless heavy vaginal bleeding.",
  presentingComplaint: 'PV Bleed',
  instructorBrief: {
    progression: "Exsanguination.",
    interventions: ["No PV Exam", "Blood", "C-Section"],
    learningObjectives: ["Painless bleed = Praevia", "Digital exam contraindication"]
  },
  vitalsMod: {
    hr: 120,
    bpSys: 90,
    spO2: 96
  },
  deterioration: {
    active: true,
    rate: 0.1,
    type: 'shock'
  },
  stabilisers: ['Blood', 'Delivery'],
  recommendedActions: ['Obs', 'IV Access', 'Blood', 'Delivery']
}, {
  id: 'OB012',
  title: 'Hyperemesis Gravidarum',
  category: 'Obstetrics & Gynae',
  ageRange: 'Adult',
  acuity: 'Majors',
  ageGenerator: function ageGenerator() {
    return getRandomInt(18, 35);
  },
  patientProfileTemplate: "10 weeks pregnant. Vomiting 20x day. Ketotic.",
  presentingComplaint: 'Vomiting',
  instructorBrief: {
    progression: "Wernicke's Encephalopathy. AKI.",
    interventions: ["Thiamine", "Fluids", "Antiemetics"],
    learningObjectives: ["Wernicke's prevention", "PUQE score"]
  },
  vitalsMod: {
    hr: 110,
    bpSys: 100,
    spO2: 98,
    bm: 3.2
  },
  deterioration: {
    active: false,
    rate: 0
  },
  stabilisers: ['Fluids', 'Pabrinex'],
  recommendedActions: ['Obs', 'IV Access', 'Fluids', 'Pabrinex', 'Antiemetic']
}, {
  id: 'OB013',
  title: 'Breech Delivery',
  category: 'Obstetrics & Gynae',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(18, 40);
  },
  patientProfileTemplate: "Term pregnancy. Legs delivered, head stuck.",
  presentingComplaint: 'Imminent Delivery',
  instructorBrief: {
    progression: "Head entrapment. Fetal hypoxia.",
    interventions: ["Mauriceau-Smellie-Veit", "Lovset Manoeuvre"],
    learningObjectives: ["Breech manoeuvres", "Hands off breech"]
  },
  vitalsMod: {
    hr: 110,
    bpSys: 130,
    spO2: 98
  },
  deterioration: {
    active: false,
    rate: 0
  },
  stabilisers: ['Delivery'],
  recommendedActions: ['Obs', 'IV Access', 'Delivery', 'ObstetricManoeuvres']
}, {
  id: 'TX006',
  title: 'Calcium Channel Blocker OD',
  category: 'Toxicology',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(30, 60);
  },
  patientProfileTemplate: "A {age}-year-old. Amlodipine overdose. Hypotensive and hyperglycaemic.",
  presentingComplaint: 'Overdose',
  instructorBrief: {
    progression: "Refractory shock.",
    interventions: ["IV calcium (6.8 mmol bolus, up to 3 doses)", "High Dose Insulin", "Noradrenaline or adrenaline (metaraminol: benefit unclear)", "IV glucagon", "Lipid emulsion only if life-threatening and other treatments have failed", "Observe at least 12 hours (24 hours if modified release)"],
    learningObjectives: ["Hyperglycaemia in CCB OD", "Insulin euglycaemia"]
  },
  vitalsMod: {
    hr: 100,
    bpSys: 70,
    spO2: 96,
    bm: 18.0
  },
  deterioration: {
    active: true,
    rate: 0.1,
    type: 'shock'
  },
  stabilisers: ['HIET', 'Calcium', 'Noradrenaline'],
  recommendedActions: ['Obs', 'IV Access', 'Calcium', 'HIET', 'Noradrenaline', 'GlucagonIV']
}, {
  id: 'TX007',
  title: 'Salicylate Toxicity',
  category: 'Toxicology',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(20, 50);
  },
  patientProfileTemplate: "A {age}-year-old. Aspirin overdose. Tinnitus and hyperventilation.",
  presentingComplaint: 'Overdose',
  instructorBrief: {
    progression: "Respiratory Alkalosis -> Metabolic Acidosis. Cerebral Oedema. Correct potassium first, then IV bicarbonate; urinary alkalinisation if level above 500 mg/L. Charcoal only within 1 h of 125 mg/kg or more. Avoid intubation unless respiratory failure (if ventilated, keep pH 7.5-7.6). Urgent dialysis if 900 mg/L or more, above 700 mg/L with acidosis, or coma (TOXBASE).",
    interventions: ["Urinary Alkalinisation (Bicarb)", "Dialysis"],
    learningObjectives: ["Uncoupling oxidative phosphorylation", "pH trapping"]
  },
  vitalsMod: {
    hr: 110,
    bpSys: 120,
    spO2: 98,
    rr: 35,
    temp: 38.5
  },
  deterioration: {
    active: true,
    rate: 0.1,
    type: 'neuro'
  },
  vbgClinicalState: "metabolic_acidosis_severe",
  recommendedActions: ['Obs', 'IV Access', 'Fluids', 'SodiumBicarb', 'Charcoal']
}, {
  id: 'TX008',
  title: 'MDMA Hyperpyrexia',
  category: 'Toxicology',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(18, 30);
  },
  patientProfileTemplate: "A {age}-year-old. Clubbing. Agitated, hot, seizure.",
  presentingComplaint: 'Seizure',
  instructorBrief: {
    progression: "Hyperthermia, Rhabdomyolysis, Hyponatraemia. TOXBASE: urgent cooling once above 38 C; benzodiazepines (diazepam 10-20 mg, large doses may be needed); rapid sequence intubation with paralysis if temperature keeps rising despite cooling (avoid suxamethonium if hyperkalaemia likely); dantrolene may be considered for muscle hyperactivity; cyproheptadine (oral/NG) for serotonin toxicity. Check sodium and CK.",
    interventions: ["Active Cooling", "Benzodiazepines", "Dantrolene?"],
    learningObjectives: ["Serotonin syndrome features", "Cooling urgency"]
  },
  vitalsMod: {
    hr: 160,
    bpSys: 170,
    spO2: 94,
    temp: 41.5,
    gcs: 8
  },
  deterioration: {
    active: true,
    rate: 0.15,
    type: 'neuro'
  },
  stabilisers: ['Cooling', 'Midazolam'],
  recommendedActions: ['Obs', 'IV Access', 'Cooling', 'Midazolam', 'Fluids', 'Dantrolene']
}, {
  id: 'TX009',
  title: 'Cocaine Chest Pain',
  category: 'Toxicology',
  ageRange: 'Adult',
  acuity: 'Majors',
  ageGenerator: function ageGenerator() {
    return getRandomInt(20, 40);
  },
  patientProfileTemplate: "A {age}-year-old. Cocaine use. Severe chest pain.",
  presentingComplaint: 'Chest Pain',
  instructorBrief: {
    progression: "Coronary vasospasm vs Dissection. TOXBASE: early benzodiazepines (diazepam 10-20 mg), aspirin and nitrates (sublingual then IV) as per ACS protocol; labetalol 5 mg IV only if pain persists after a nitrate infusion; avoid pure beta-blockers. Thrombolysis/PPCI if the ECG shows infarction despite this. Bicarbonate if the QRS widens. Observe at least 4 h.",
    interventions: ["Benzodiazepines", "GTN", "Phentolamine", "NO Beta Blockers"],
    learningObjectives: ["Unopposed alpha stimulation", "Benzo utility"]
  },
  vitalsMod: {
    hr: 130,
    bpSys: 180,
    spO2: 98
  },
  deterioration: {
    active: true,
    rate: 0.05,
    type: 'cardiac'
  },
  stabilisers: ['Midazolam', 'GTN'],
  recommendedActions: ['Obs', 'IV Access', 'Midazolam', 'GTN', 'Phentolamine', 'Analgesia']
}, {
  id: 'TX010',
  title: 'Adder Bite',
  category: 'Toxicology',
  ageRange: 'Adult',
  acuity: 'Majors',
  ageGenerator: function ageGenerator() {
    return getRandomInt(18, 60);
  },
  patientProfileTemplate: "A {age}-year-old. Walking in dunes. Bitten on hand. Swelling extending to forearm.",
  presentingComplaint: 'Snake Bite',
  instructorBrief: {
    progression: "Anaphylaxis-like venom effects or spreading swelling. TOXBASE: swelling of the forearm after a hand bite (beyond the next major joint) is an indication for antivenom even without systemic features, as are hypotension over 10 minutes, vomiting or abdominal pain, white count above 20, ECG changes, acidosis or raised CK. Adrenaline and chlorphenamine as well for anaphylaxis-like features. Immobilise (no sling elevation), no heparin, no prophylactic antibiotics, observe at least 24 hours.",
    interventions: ["Immobilise Limb", "Antivenom (systemic features or swelling beyond the next major joint)", "IV Fluids"],
    learningObjectives: ["UK Adder management", "Antivenom indications"]
  },
  vitalsMod: {
    hr: 110,
    bpSys: 100,
    spO2: 98
  },
  deterioration: {
    active: true,
    rate: 0.05,
    type: 'shock'
  },
  stabilisers: ['Fluids'],
  recommendedActions: ['Obs', 'IV Access', 'Fluids', 'Analgesia', 'Splinting', 'Antivenom']
}, {
  id: 'TX011',
  title: 'Drowning (Secondary)',
  category: 'Medical',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(20, 50);
  },
  patientProfileTemplate: "A {age}-year-old. Pulled from river. Initially fine, now breathless.",
  presentingComplaint: 'Dyspnoea',
  instructorBrief: {
    progression: "Surfactant wash-out. ARDS.",
    interventions: ["CPAP/PEEP", "Warming"],
    learningObjectives: ["Non-cardiogenic pulmonary oedema", "C-spine in drowning"]
  },
  vitalsMod: {
    hr: 110,
    bpSys: 110,
    spO2: 86,
    rr: 30,
    temp: 35.0
  },
  deterioration: {
    active: true,
    rate: 0.1,
    type: 'respiratory'
  },
  stabilisers: ['CPAP', 'Oxygen'],
  recommendedActions: ['Obs', 'IV Access', 'CPAP', 'Oxygen', 'Warming']
}, {
  id: 'TX012',
  title: 'Heat Stroke',
  category: 'Medical',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(20, 50);
  },
  patientProfileTemplate: "A {age}-year-old runner. Marathon day. Collapsed, hot dry skin.",
  presentingComplaint: 'Collapse',
  instructorBrief: {
    progression: "Multiorgan failure.",
    interventions: ["Rapid Cooling (Ice/Water)", "Fluids"],
    learningObjectives: ["Heat stroke vs exhaustion", "Cooling methods"]
  },
  vitalsMod: {
    hr: 140,
    bpSys: 90,
    spO2: 96,
    temp: 41.0,
    gcs: 9
  },
  deterioration: {
    active: true,
    rate: 0.1,
    type: 'shock'
  },
  stabilisers: ['Fluids'],
  recommendedActions: ['Obs', 'IV Access', 'Fluids', 'Cooling']
}, {
  id: 'PS001',
  title: 'Neuroleptic Malignant Syndrome',
  category: 'Psychiatric',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(20, 50);
  },
  patientProfileTemplate: "A {age}-year-old. Schizophrenic. Rigid, fever, confused.",
  presentingComplaint: 'Confusion & Rigidity',
  instructorBrief: {
    progression: "Rhabdomyolysis and Autonomic Instability.",
    interventions: ["Stop Antipsychotics", "Bromocriptine/Dantrolene", "Fluids"],
    learningObjectives: ["NMS vs Serotonin Syndrome", "Lead pipe rigidity"]
  },
  vitalsMod: {
    hr: 120,
    bpSys: 160,
    spO2: 96,
    temp: 39.5,
    gcs: 11
  },
  deterioration: {
    active: true,
    rate: 0.1,
    type: 'neuro'
  },
  stabilisers: ['Fluids'],
  recommendedActions: ['Obs', 'IV Access', 'Fluids', 'Lorazepam', 'Dantrolene']
}, {
  id: 'PS002',
  title: 'Lithium Toxicity',
  category: 'Psychiatric',
  ageRange: 'Adult',
  acuity: 'Majors',
  ageGenerator: function ageGenerator() {
    return getRandomInt(30, 60);
  },
  patientProfileTemplate: "A {age}-year-old. Coarse tremor, vomiting, ataxia.",
  presentingComplaint: 'Tremor & Vomiting',
  instructorBrief: {
    progression: "Seizures and renal failure. TOXBASE: charcoal does not bind lithium; avoid hyponatraemia; haemodialysis strongly recommended for reduced consciousness, cerebellar signs, seizures or life-threatening arrhythmia at any level, or above 4.0 mmol/L with impaired renal function; consider above 2.5 mmol/L in chronic toxicity. Observe at least 24 h.",
    interventions: ["Aggressive Hydration", "Dialysis (if severe)"],
    learningObjectives: ["Chronic vs Acute toxicity", "Dialysis indications"]
  },
  vitalsMod: {
    hr: 90,
    bpSys: 130,
    spO2: 98,
    gcs: 14
  },
  deterioration: {
    active: true,
    rate: 0.05,
    type: 'neuro'
  },
  stabilisers: ['Fluids'],
  recommendedActions: ['Obs', 'IV Access', 'Fluids']
}, {
  id: 'PS003',
  title: 'Catatonia',
  category: 'Psychiatric',
  ageRange: 'Adult',
  acuity: 'Majors',
  ageGenerator: function ageGenerator() {
    return getRandomInt(20, 50);
  },
  patientProfileTemplate: "A {age}-year-old. Mute, immobile, holding awkward postures.",
  presentingComplaint: 'Unresponsive',
  instructorBrief: {
    progression: "Malnutrition/DVT risks.",
    interventions: ["Lorazepam Trial", "Exclude organic cause"],
    learningObjectives: ["Benzodiazepine response", "Waxy flexibility"]
  },
  vitalsMod: {
    hr: 80,
    bpSys: 120,
    spO2: 98,
    gcs: 10
  },
  deterioration: {
    active: false,
    rate: 0
  },
  stabilisers: ['Lorazepam'],
  recommendedActions: ['Obs', 'IV Access', 'Lorazepam', 'Fluids']
},
// --- ADULT CARDIAC ARRESTS ---
{
  id: 'CA_A01',
  title: 'Adult - VF Arrest',
  category: 'Cardiac Arrest',
  sex: 'Male',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(50, 70);
  },
  patientProfileTemplate: "Adult Male. Collapsed. Witnessed.",
  presentingComplaint: 'Cardiac Arrest',
  instructorBrief: {
    progression: "Refractory VF.",
    interventions: ["CPR", "Shock", "Adrenaline", "Amiodarone"],
    learningObjectives: ["ALS Algorithm"]
  },
  vitalsMod: {
    hr: 0,
    bpSys: 0,
    spO2: 0,
    gcs: 3
  },
  deterioration: {
    active: false
  },
  ecg: {
    type: "VF",
    findings: "Coarse VF"
  },
  recommendedActions: ['Obs', 'CPR', 'Defib', 'AdrenalineIV', 'Amiodarone']
}, {
  id: 'CA_A02',
  title: 'Adult - Pulseless VT',
  category: 'Cardiac Arrest',
  sex: 'Female',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(50, 70);
  },
  patientProfileTemplate: "Adult Female. Palpitations then collapse.",
  presentingComplaint: 'Cardiac Arrest',
  instructorBrief: {
    progression: "Pulseless VT. Treat as VF.",
    interventions: ["CPR", "Shock", "Adrenaline", "Amiodarone"],
    learningObjectives: ["Shockable rhythms"]
  },
  vitalsMod: {
    hr: 0,
    bpSys: 0,
    spO2: 0,
    gcs: 3
  },
  deterioration: {
    active: false
  },
  ecg: {
    type: "pVT",
    findings: "Monomorphic VT (No Pulse)"
  },
  recommendedActions: ['Obs', 'CPR', 'Defib', 'AdrenalineIV', 'Amiodarone']
}, {
  id: 'CA_A03',
  title: 'Adult - PEA Arrest',
  category: 'Cardiac Arrest',
  sex: 'Male',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(50, 70);
  },
  patientProfileTemplate: "Adult Male. DIB for 2 days. Sudden collapse.",
  presentingComplaint: 'Cardiac Arrest',
  instructorBrief: {
    progression: "PEA. 4Hs & 4Ts.",
    interventions: ["CPR", "Adrenaline", "Fluids", "Airway"],
    learningObjectives: ["Reversible causes"]
  },
  vitalsMod: {
    hr: 40,
    bpSys: 0,
    spO2: 0,
    gcs: 3
  },
  deterioration: {
    active: false
  },
  ecg: {
    type: "PEA",
    findings: "Slow nodal rhythm (No Pulse)"
  },
  recommendedActions: ['Obs', 'CPR', 'AdrenalineIV', 'Fluids']
}, {
  id: 'CA_A04',
  title: 'Adult - Asystole',
  category: 'Cardiac Arrest',
  sex: 'Female',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(70, 90);
  },
  patientProfileTemplate: "Adult Female. Found unresponsive.",
  presentingComplaint: 'Cardiac Arrest',
  instructorBrief: {
    progression: "Asystole. Poor prognosis.",
    interventions: ["CPR", "Adrenaline"],
    learningObjectives: ["Confirmation of death"]
  },
  vitalsMod: {
    hr: 0,
    bpSys: 0,
    spO2: 0,
    gcs: 3
  },
  deterioration: {
    active: false
  },
  ecg: {
    type: "Asystole",
    findings: "Flatline"
  },
  recommendedActions: ['Obs', 'CPR', 'AdrenalineIV']
}, {
  id: 'CA_A05',
  title: 'Adult - Traumatic Arrest',
  category: 'Cardiac Arrest',
  sex: 'Male',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(20, 40);
  },
  patientProfileTemplate: "Adult Male. Stabbed chest. Lost output on arrival.",
  presentingComplaint: 'Traumatic Arrest',
  instructorBrief: {
    progression: "HOT protocol. Thoracotomy?",
    interventions: ["Thoracotomy", "Finger Thoracostomy", "Blood"],
    learningObjectives: ["Traumatic cardiac arrest algorithm"]
  },
  vitalsMod: {
    hr: 40,
    bpSys: 0,
    spO2: 0,
    gcs: 3
  },
  deterioration: {
    active: false
  },
  ecg: {
    type: "PEA",
    findings: "Narrow complex PEA"
  },
  recommendedActions: ['Obs', 'CPR', 'Thoracotomy', 'FingerThoracostomy', 'Blood']
},
// --- PAEDIATRIC CARDIAC ARRESTS ---
{
  id: 'CA_P01',
  title: 'Paediatric - VF Arrest',
  category: 'Cardiac Arrest',
  ageRange: 'Paediatric',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(8, 14);
  },
  patientProfileTemplate: "Child. Electrocution/Congenital Heart. Collapsed.",
  presentingComplaint: 'Cardiac Arrest',
  instructorBrief: {
    progression: "Rare in kids. Shock 4J/kg.",
    interventions: ["CPR", "Shock", "Adrenaline", "Amiodarone"],
    learningObjectives: ["Paeds Defib Dosing"]
  },
  vitalsMod: {
    hr: 0,
    bpSys: 0,
    spO2: 0,
    gcs: 3
  },
  deterioration: {
    active: false
  },
  ecg: {
    type: "VF",
    findings: "VF"
  },
  recommendedActions: ['Obs', 'CPR', 'Defib', 'AdrenalineIV', 'Amiodarone']
}, {
  id: 'CA_P02',
  title: 'Paediatric - Pulseless VT',
  category: 'Cardiac Arrest',
  ageRange: 'Paediatric',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(10, 15);
  },
  patientProfileTemplate: "Adolescent. Collapsed during sport.",
  presentingComplaint: 'Cardiac Arrest',
  instructorBrief: {
    progression: "Shockable rhythm.",
    interventions: ["CPR", "Shock"],
    learningObjectives: ["Manage a paediatric shockable arrest (4 J/kg)"]
  },
  vitalsMod: {
    hr: 0,
    bpSys: 0,
    spO2: 0,
    gcs: 3
  },
  deterioration: {
    active: false
  },
  ecg: {
    type: "pVT",
    findings: "Wide Complex Tachycardia (No Pulse)"
  },
  recommendedActions: ['Obs', 'CPR', 'Defib', 'AdrenalineIV']
}, {
  id: 'CA_P03',
  title: 'Paediatric - PEA Arrest',
  category: 'Cardiac Arrest',
  ageRange: 'Paediatric',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(1, 6);
  },
  patientProfileTemplate: "Child. Choking episode then limp.",
  presentingComplaint: 'Cardiac Arrest',
  instructorBrief: {
    progression: "Hypoxic arrest. Airway is priority.",
    interventions: ["Oxygen", "Airway", "CPR", "Adrenaline"],
    learningObjectives: ["Recognise hypoxia as the cause of paediatric arrest"]
  },
  vitalsMod: {
    hr: 40,
    bpSys: 0,
    spO2: 0,
    gcs: 3
  },
  deterioration: {
    active: false
  },
  ecg: {
    type: "PEA",
    findings: "Sinus Bradycardia (No Pulse)"
  },
  recommendedActions: ['Obs', 'CPR', 'AdrenalineIV', 'Oxygen', 'Bagging']
}, {
  id: 'CA_P04',
  title: 'Paediatric - Asystole',
  category: 'Cardiac Arrest',
  ageRange: 'Paediatric',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return Math.round(getRandomInt(1, 6) / 12 * 100) / 100;
  },
  patientProfileTemplate: "Infant. SIDS presentation. Cold.",
  presentingComplaint: 'Cardiac Arrest',
  instructorBrief: {
    progression: "Asystole.",
    interventions: ["CPR", "Adrenaline"],
    learningObjectives: ["SIDS management"]
  },
  vitalsMod: {
    hr: 0,
    bpSys: 0,
    spO2: 0,
    gcs: 3
  },
  deterioration: {
    active: false
  },
  ecg: {
    type: "Asystole",
    findings: "Asystole"
  },
  recommendedActions: ['Obs', 'CPR', 'AdrenalineIV']
}, {
  id: 'CA_P05',
  title: 'Paediatric - Traumatic Arrest',
  category: 'Cardiac Arrest',
  ageRange: 'Paediatric',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(4, 10);
  },
  patientProfileTemplate: "Child. RTC. Run over.",
  presentingComplaint: 'Traumatic Arrest',
  instructorBrief: {
    progression: "Hypovolaemia/Tension. Poor prognosis.",
    interventions: ["Fluid/Blood", "Decompression"],
    learningObjectives: ["Paeds trauma arrest"]
  },
  vitalsMod: {
    hr: 60,
    bpSys: 0,
    spO2: 0,
    gcs: 3
  },
  deterioration: {
    active: false
  },
  ecg: {
    type: "PEA",
    findings: "PEA"
  },
  recommendedActions: ['Obs', 'CPR', 'Blood', 'Fluids', 'Needle']
},
// --- ELDERLY CARDIAC ARRESTS ---
{
  id: 'CA_E01',
  title: 'Elderly - VF Arrest',
  category: 'Cardiac Arrest',
  ageRange: 'Elderly',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(75, 90);
  },
  patientProfileTemplate: "Elderly. Chest pain then collapse.",
  presentingComplaint: 'Cardiac Arrest',
  instructorBrief: {
    progression: "Standard ALS.",
    interventions: ["CPR", "Defib"],
    learningObjectives: ["ALS in elderly"]
  },
  vitalsMod: {
    hr: 0,
    bpSys: 0,
    spO2: 0,
    gcs: 3
  },
  deterioration: {
    active: false
  },
  ecg: {
    type: "VF",
    findings: "Fine VF"
  },
  recommendedActions: ['Obs', 'CPR', 'Defib', 'AdrenalineIV']
}, {
  id: 'CA_E02',
  title: 'Elderly - Pulseless VT',
  category: 'Cardiac Arrest',
  ageRange: 'Elderly',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(75, 90);
  },
  patientProfileTemplate: "Elderly. Known heart failure.",
  presentingComplaint: 'Cardiac Arrest',
  instructorBrief: {
    progression: "Scar related VT.",
    interventions: ["CPR", "Defib"],
    learningObjectives: ["ICD management"]
  },
  vitalsMod: {
    hr: 0,
    bpSys: 0,
    spO2: 0,
    gcs: 3
  },
  deterioration: {
    active: false
  },
  ecg: {
    type: "pVT",
    findings: "VT (No Pulse)"
  },
  recommendedActions: ['Obs', 'CPR', 'Defib']
}, {
  id: 'CA_E03',
  title: 'Elderly - PEA Arrest',
  category: 'Cardiac Arrest',
  ageRange: 'Elderly',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(80, 95);
  },
  patientProfileTemplate: "Elderly. 'Unwell' for 3 days.",
  presentingComplaint: 'Cardiac Arrest',
  instructorBrief: {
    progression: "Sepsis/Hypovolaemia.",
    interventions: ["CPR", "Adrenaline", "Fluids"],
    learningObjectives: ["DNACPR decisions"]
  },
  vitalsMod: {
    hr: 50,
    bpSys: 0,
    spO2: 0,
    gcs: 3
  },
  deterioration: {
    active: false
  },
  ecg: {
    type: "PEA",
    findings: "AF (No Pulse)"
  },
  recommendedActions: ['Obs', 'CPR', 'AdrenalineIV', 'Fluids']
}, {
  id: 'CA_E04',
  title: 'Elderly - Asystole',
  category: 'Cardiac Arrest',
  ageRange: 'Elderly',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(85, 99);
  },
  patientProfileTemplate: "Elderly. Found cold in bed.",
  presentingComplaint: 'Cardiac Arrest',
  instructorBrief: {
    progression: "End of life.",
    interventions: ["Confirm death?"],
    learningObjectives: ["Recognition of life extinct"]
  },
  vitalsMod: {
    hr: 0,
    bpSys: 0,
    spO2: 0,
    gcs: 3
  },
  deterioration: {
    active: false
  },
  ecg: {
    type: "Asystole",
    findings: "Asystole"
  },
  recommendedActions: ['Obs', 'CPR']
}, {
  id: 'CA_E05',
  title: 'Elderly - Traumatic Arrest',
  category: 'Cardiac Arrest',
  ageRange: 'Elderly',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(75, 90);
  },
  patientProfileTemplate: "Elderly. Fall down stairs. Head injury.",
  presentingComplaint: 'Traumatic Arrest',
  instructorBrief: {
    progression: "Cushing's/Brain herniation.",
    interventions: ["Airway", "CPR"],
    learningObjectives: ["Futility in elderly trauma arrest"]
  },
  vitalsMod: {
    hr: 0,
    bpSys: 0,
    spO2: 0,
    gcs: 3
  },
  deterioration: {
    active: false
  },
  ecg: {
    type: "PEA",
    findings: "Agonal Rhythm"
  },
  recommendedActions: ['Obs', 'CPR', 'AdrenalineIV']
},
// --- OBSTETRIC CARDIAC ARRESTS ---
{
  id: 'CA_O01',
  title: 'Obstetric - VF Arrest',
  category: 'Cardiac Arrest',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(25, 40);
  },
  patientProfileTemplate: "Pregnant (36 weeks). Known cardiomyopathy. Collapsed.",
  presentingComplaint: 'Maternal Arrest',
  instructorBrief: {
    progression: "Perimortem C-Section indicated.",
    interventions: ["CPR", "Defib", "Hysterotomy", "Tilt"],
    learningObjectives: ["Maternal Resus"]
  },
  vitalsMod: {
    hr: 0,
    bpSys: 0,
    spO2: 0,
    gcs: 3
  },
  deterioration: {
    active: false
  },
  ecg: {
    type: "VF",
    findings: "VF"
  },
  recommendedActions: ['Obs', 'CPR', 'Defib', 'Hysterotomy']
}, {
  id: 'CA_O02',
  title: 'Obstetric - Pulseless VT',
  category: 'Cardiac Arrest',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(25, 40);
  },
  patientProfileTemplate: "Pregnant (30 weeks). Palpitations.",
  presentingComplaint: 'Maternal Arrest',
  instructorBrief: {
    progression: "Standard shockable algorithm + C-Section.",
    interventions: ["CPR", "Defib", "Hysterotomy"],
    learningObjectives: ["Defib safety in pregnancy"]
  },
  vitalsMod: {
    hr: 0,
    bpSys: 0,
    spO2: 0,
    gcs: 3
  },
  deterioration: {
    active: false
  },
  ecg: {
    type: "pVT",
    findings: "VT (No Pulse)"
  },
  recommendedActions: ['Obs', 'CPR', 'Defib', 'Hysterotomy']
}, {
  id: 'CA_O03',
  title: 'Obstetric - PEA Arrest',
  category: 'Cardiac Arrest',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(20, 40);
  },
  patientProfileTemplate: "Pregnant (38 weeks). Sudden collapse. SOB.",
  presentingComplaint: 'Maternal Arrest',
  instructorBrief: {
    progression: "PE/Amniotic Fluid Embolism.",
    interventions: ["CPR", "Thrombolysis?", "Hysterotomy"],
    learningObjectives: ["AFE management"]
  },
  vitalsMod: {
    hr: 120,
    bpSys: 0,
    spO2: 0,
    gcs: 3
  },
  deterioration: {
    active: false
  },
  ecg: {
    type: "PEA",
    findings: "Sinus Tachy (No Pulse)"
  },
  recommendedActions: ['Obs', 'CPR', 'AdrenalineIV', 'Hysterotomy']
}, {
  id: 'CA_O04',
  title: 'Obstetric - Asystole',
  category: 'Cardiac Arrest',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(20, 40);
  },
  patientProfileTemplate: "Pregnant. Eclamptic seizure then arrest.",
  presentingComplaint: 'Maternal Arrest',
  instructorBrief: {
    progression: "Hypoxia/Intracranial bleed.",
    interventions: ["CPR", "Airway", "Hysterotomy"],
    learningObjectives: ["Eclampsia arrest"]
  },
  vitalsMod: {
    hr: 0,
    bpSys: 0,
    spO2: 0,
    gcs: 3
  },
  deterioration: {
    active: false
  },
  ecg: {
    type: "Asystole",
    findings: "Asystole"
  },
  recommendedActions: ['Obs', 'CPR', 'Hysterotomy', 'AdrenalineIV']
}, {
  id: 'CA_O05',
  title: 'Obstetric - Traumatic Arrest',
  category: 'Cardiac Arrest',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(20, 40);
  },
  patientProfileTemplate: "Pregnant (34 weeks). RTC steering wheel injury.",
  presentingComplaint: 'Traumatic Maternal Arrest',
  instructorBrief: {
    progression: "Uterine rupture/Splenic rupture.",
    interventions: ["Hysterotomy", "Massive Transfusion"],
    learningObjectives: ["Trauma in pregnancy"]
  },
  vitalsMod: {
    hr: 0,
    bpSys: 0,
    spO2: 0,
    gcs: 3
  },
  deterioration: {
    active: false
  },
  ecg: {
    type: "PEA",
    findings: "PEA"
  },
  recommendedActions: ['Obs', 'CPR', 'Blood', 'Hysterotomy']
},
// --- ADULT MEDICAL: CARDIOLOGY / VASCULAR ---
{
  id: 'AM065',
  title: 'NSTEMI with Ongoing Ischaemia',
  category: 'Medical',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(50, 64);
  },
  patientProfileTemplate: "A {age}-year-old {sex}. Two hours of crescendo chest pain, now settling with GTN.",
  presentingComplaint: 'Chest Pain',
  instructorBrief: {
    progression: "Dynamic ST depression V4-V6. Pain recurs after 5 minutes. Needs early invasive strategy, not thrombolysis.",
    interventions: ["Aspirin", "Ticagrelor", "Fondaparinux/Heparin", "Risk score (GRACE)"],
    learningObjectives: ["Differentiate NSTEMI from STEMI", "Understand why thrombolysis is not indicated", "Apply GRACE risk stratification"]
  },
  vitalsMod: {
    hr: 92,
    bpSys: 138,
    spO2: 96,
    rr: 20
  },
  deterioration: {
    active: true,
    rate: 0.05,
    type: 'cardiac'
  },
  ecg: {
    type: "Sinus Rhythm",
    findings: "Dynamic lateral ST depression and T inversion"
  },
  recommendedActions: ['Obs', 'IV Access', 'Aspirin', 'Ticagrelor', 'Heparin', 'GTN', 'Analgesia', 'Oxygen']
}, {
  id: 'AM066',
  title: 'Cardiogenic Shock Post-MI',
  category: 'Medical',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(55, 64);
  },
  patientProfileTemplate: "A {age}-year-old {sex}. Anterior MI two days ago, now cold, clammy and confused.",
  presentingComplaint: 'Shock',
  instructorBrief: {
    progression: "Pump failure. Fluids make the pulmonary oedema worse. Needs inotropic support and urgent cardiology input.",
    interventions: ["Noradrenaline", "Cautious fluid", "Urgent echo", "Revascularisation"],
    learningObjectives: ["Recognise cardiogenic versus hypovolaemic shock", "Avoid harmful fluid loading", "Escalate for mechanical support", "Start a vasopressor"]
  },
  vitalsMod: {
    hr: 118,
    bpSys: 78,
    spO2: 89,
    rr: 30,
    gcs: 13
  },
  deterioration: {
    active: true,
    rate: 0.12,
    type: 'shock'
  },
  ecg: {
    type: "Sinus Tachycardia",
    findings: "Anterior Q waves, persistent ST elevation"
  },
  vbgClinicalState: "metabolic_acidosis_severe",
  stabilisers: ['Noradrenaline', 'CPAP'],
  recommendedActions: ['Obs', 'IV Access', 'Oxygen', 'Noradrenaline', 'ArtLine', 'CPAP', 'Catheter', 'PPCI']
}, {
  id: 'AM067',
  title: 'Fast AF with Adverse Features',
  category: 'Medical',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(45, 64);
  },
  patientProfileTemplate: "A {age}-year-old {sex}. Sudden palpitations, now light-headed with chest tightness.",
  presentingComplaint: 'Palpitations',
  instructorBrief: {
    progression: "AF at 180 with hypotension and ischaemic chest pain. Adverse features mandate synchronised DC cardioversion, not rate control.",
    interventions: ["Sedation", "Synchronised cardioversion", "Anticoagulation"],
    learningObjectives: ["Identify adverse features in tachyarrhythmia", "Perform synchronised cardioversion safely", "Understand sync versus unsynchronised shocks"]
  },
  vitalsMod: {
    hr: 178,
    bpSys: 86,
    spO2: 94,
    rr: 24
  },
  deterioration: {
    active: true,
    rate: 0.08,
    type: 'cardiac'
  },
  ecg: {
    type: "AF",
    findings: "AF with rapid ventricular response, rate 180"
  },
  stabilisers: ['Cardioversion'],
  recommendedActions: ['Obs', 'IV Access', 'Oxygen', 'Cardioversion', 'Ketamine', 'Midazolam', 'Heparin', 'Analgesia']
}, {
  id: 'AM068',
  title: 'Acute Limb Ischaemia',
  category: 'Medical',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(55, 64);
  },
  patientProfileTemplate: "A {age}-year-old {sex} with AF. Sudden onset painful, white, cold right leg three hours ago.",
  presentingComplaint: 'Limb Pain',
  instructorBrief: {
    progression: "Embolic occlusion. The six Ps. Paralysis and paraesthesia mean this is a threatened limb needing revascularisation within hours.",
    interventions: ["Heparin", "Analgesia", "Urgent vascular referral"],
    learningObjectives: ["Recognise the six Ps of acute limb ischaemia", "Understand Rutherford categories", "Appreciate the revascularisation time window"]
  },
  vitalsMod: {
    hr: 104,
    bpSys: 152,
    spO2: 97,
    rr: 20
  },
  deterioration: {
    active: true,
    rate: 0.03,
    type: 'shock'
  },
  ecg: {
    type: "AF",
    findings: "Atrial fibrillation, rate 104"
  },
  recommendedActions: ['Obs', 'IV Access', 'Analgesia', 'Fentanyl', 'Heparin', 'Oxygen', 'Surgery']
}, {
  id: 'AM069',
  title: 'Superior Vena Cava Obstruction',
  category: 'Medical',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(55, 64);
  },
  patientProfileTemplate: "A {age}-year-old {sex} with known lung cancer. Facial swelling and breathlessness, worse lying flat.",
  presentingComplaint: 'Facial Swelling',
  instructorBrief: {
    progression: "Facial and upper limb oedema, distended neck veins, stridor developing. Oncological emergency requiring steroids and urgent stenting.",
    interventions: ["Dexamethasone", "Sit upright", "Urgent CT and stenting"],
    learningObjectives: ["Recognise SVC obstruction", "Manage the threatened airway", "Escalate an oncological emergency"]
  },
  vitalsMod: {
    hr: 106,
    bpSys: 132,
    spO2: 91,
    rr: 28
  },
  deterioration: {
    active: true,
    rate: 0.07,
    type: 'airway'
  },
  ecg: {
    type: "Sinus Tachycardia",
    findings: "Sinus tachycardia, low voltage complexes"
  },
  stabilisers: ['Dexamethasone', 'Oxygen'],
  recommendedActions: ['Obs', 'IV Access', 'Oxygen', 'Dexamethasone', 'Analgesia', 'RSI']
},
// --- ADULT MEDICAL: GASTROINTESTINAL / SURGICAL ---
{
  id: 'AM070',
  title: 'Upper GI Bleed (Peptic Ulcer)',
  category: 'Medical',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(45, 64);
  },
  patientProfileTemplate: "A {age}-year-old {sex} on long-term NSAIDs. Two episodes of coffee-ground vomit, now frank haematemesis.",
  presentingComplaint: 'Haematemesis',
  instructorBrief: {
    progression: "Non-variceal bleed. Blatchford score high. Terlipressin is not indicated here; needs transfusion and urgent endoscopy.",
    interventions: ["Blood", "Major haemorrhage protocol", "Urgent OGD"],
    learningObjectives: ["Differentiate variceal from non-variceal bleeding", "Apply the Glasgow-Blatchford score", "Activate major haemorrhage appropriately"]
  },
  vitalsMod: {
    hr: 126,
    bpSys: 88,
    spO2: 96,
    rr: 26,
    gcs: 14
  },
  deterioration: {
    active: true,
    rate: 0.12,
    type: 'shock'
  },
  ecg: {
    type: "Sinus Tachycardia",
    findings: "Sinus tachycardia"
  },
  vbgClinicalState: "gi_bleed",
  stabilisers: ['Blood', 'Fluids'],
  recommendedActions: ['Obs', 'IV Access', 'Oxygen', 'Blood', 'Fluids', 'NGTube', 'Catheter']
}, {
  id: 'AM071',
  title: 'Massive Lower GI Bleed',
  category: 'Medical',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(55, 64);
  },
  patientProfileTemplate: "A {age}-year-old {sex}. Repeated large volume fresh red rectal bleeding, feeling faint.",
  presentingComplaint: 'PR Bleeding',
  instructorBrief: {
    progression: "Diverticular bleed. Brisk enough to cause shock. A brisk upper GI bleed can present as fresh PR blood, so do not anchor.",
    interventions: ["Blood", "CT angiogram", "Interventional radiology"],
    learningObjectives: ["Resuscitate massive GI haemorrhage", "Consider upper GI source in fresh PR bleeding", "Understand the role of CT angiography"]
  },
  vitalsMod: {
    hr: 122,
    bpSys: 84,
    spO2: 96,
    rr: 24
  },
  deterioration: {
    active: true,
    rate: 0.12,
    type: 'shock'
  },
  ecg: {
    type: "Sinus Tachycardia",
    findings: "Sinus tachycardia"
  },
  vbgClinicalState: "haemorrhagic_shock",
  stabilisers: ['Blood'],
  recommendedActions: ['Obs', 'IV Access', 'Oxygen', 'Blood', 'Fluids', 'Catheter']
}, {
  id: 'AM072',
  title: 'Perforated Peptic Ulcer',
  category: 'Medical',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(40, 64);
  },
  patientProfileTemplate: "A {age}-year-old {sex}. Sudden severe epigastric pain, now rigid abdomen and unwilling to move.",
  presentingComplaint: 'Abdominal Pain',
  instructorBrief: {
    progression: "Free air under the diaphragm. Peritonitic and becoming septic. Needs fluids, antibiotics and theatre.",
    interventions: ["Tazocin", "Fluids", "Urgent laparotomy"],
    learningObjectives: ["Recognise peritonism", "Resuscitate the surgical abdomen", "Expedite theatre for perforation"]
  },
  vitalsMod: {
    hr: 118,
    bpSys: 96,
    spO2: 95,
    rr: 26,
    temp: 38.2
  },
  deterioration: {
    active: true,
    rate: 0.1,
    type: 'shock'
  },
  ecg: {
    type: "Sinus Tachycardia",
    findings: "Sinus tachycardia"
  },
  vbgClinicalState: "metabolic_acidosis_severe",
  stabilisers: ['Fluids', 'Tazocin'],
  recommendedActions: ['Obs', 'IV Access', 'Oxygen', 'Fluids', 'Tazocin', 'Analgesia', 'Fentanyl', 'Antiemetic', 'NGTube', 'Catheter', 'Surgery']
}, {
  id: 'AM073',
  title: 'Obstructed Infected Kidney',
  category: 'Medical',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(35, 64);
  },
  patientProfileTemplate: "A {age}-year-old {sex}. Right loin pain for two days, now rigors and confusion.",
  presentingComplaint: 'Loin Pain',
  instructorBrief: {
    progression: "Obstructing stone with pyonephrosis. Antibiotics alone will not work; the system must be decompressed by nephrostomy or stent.",
    interventions: ["Gentamicin", "Fluids", "Urgent decompression"],
    learningObjectives: ["Recognise infected obstructed system as a urological emergency", "Understand source control principles", "Apply the sepsis six"]
  },
  vitalsMod: {
    hr: 124,
    bpSys: 86,
    spO2: 95,
    rr: 28,
    temp: 39.1,
    gcs: 14
  },
  deterioration: {
    active: true,
    rate: 0.12,
    type: 'shock'
  },
  ecg: {
    type: "Sinus Tachycardia",
    findings: "Sinus tachycardia"
  },
  vbgClinicalState: "septic_shock",
  stabilisers: ['Fluids', 'Gentamicin'],
  recommendedActions: ['Obs', 'IV Access', 'Oxygen', 'Fluids', 'Gentamicin', 'Tazocin', 'Analgesia', 'Catheter', 'Surgery']
},
// --- ADULT MEDICAL: ONCOLOGY / HAEMATOLOGY / IMMUNOLOGY ---
{
  id: 'AM074',
  title: 'Neutropenic Sepsis',
  category: 'Medical',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(30, 64);
  },
  patientProfileTemplate: "A {age}-year-old {sex}. Chemotherapy 10 days ago, now febrile and shivering.",
  presentingComplaint: 'Fever',
  instructorBrief: {
    progression: "Neutrophils 0.2. Antibiotics must be given within one hour of arrival, before the source is known.",
    interventions: ["Tazocin within 1 hour", "Fluids", "Cultures"],
    learningObjectives: ["Recognise neutropenic sepsis in any recent chemotherapy patient", "Deliver door-to-needle antibiotics within 60 minutes", "Avoid delaying treatment for investigations"]
  },
  vitalsMod: {
    hr: 128,
    bpSys: 88,
    spO2: 94,
    rr: 28,
    temp: 39.4
  },
  deterioration: {
    active: true,
    rate: 0.12,
    type: 'shock'
  },
  ecg: {
    type: "Sinus Tachycardia",
    findings: "Sinus tachycardia"
  },
  vbgClinicalState: "septic_shock",
  stabilisers: ['Tazocin', 'Fluids'],
  recommendedActions: ['Obs', 'IV Access', 'Oxygen', 'Tazocin', 'Fluids', 'Paracetamol', 'Catheter', 'Noradrenaline']
}, {
  id: 'AM075',
  title: 'Malignant Spinal Cord Compression',
  category: 'Medical',
  ageRange: 'Adult',
  acuity: 'Majors',
  ageGenerator: function ageGenerator() {
    return getRandomInt(50, 64);
  },
  patientProfileTemplate: "A {age}-year-old {sex} with known prostate cancer. Worsening back pain, now leg weakness and difficulty passing urine.",
  presentingComplaint: 'Back Pain',
  instructorBrief: {
    progression: "Progressive paraparesis with a sensory level. Time to steroids and MRI determines whether the patient walks again.",
    interventions: ["Dexamethasone", "Urgent whole spine MRI", "Oncology referral"],
    learningObjectives: ["Elicit red flag back pain features", "Give high dose dexamethasone promptly", "Arrange urgent whole spine MRI"]
  },
  vitalsMod: {
    hr: 88,
    bpSys: 138,
    spO2: 97,
    rr: 18
  },
  deterioration: {
    active: true,
    rate: 0.02,
    type: 'neuro'
  },
  ecg: {
    type: "Sinus Rhythm",
    findings: "Normal sinus rhythm"
  },
  recommendedActions: ['Obs', 'IV Access', 'Dexamethasone', 'Analgesia', 'Fentanyl', 'Catheter']
}, {
  id: 'AM076',
  title: 'Acute Chest Syndrome (Sickle Cell)',
  category: 'Medical',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(18, 40);
  },
  patientProfileTemplate: "A {age}-year-old {sex} with HbSS disease. Painful crisis for two days, now chest pain and hypoxia.",
  presentingComplaint: 'Chest Pain',
  instructorBrief: {
    progression: "New infiltrate with fever and hypoxia. The leading cause of death in sickle cell disease. Needs oxygen, analgesia, antibiotics and exchange transfusion.",
    interventions: ["Oxygen", "Opiate analgesia", "Antibiotics", "Exchange transfusion"],
    learningObjectives: ["Recognise acute chest syndrome", "Deliver timely opiate analgesia in sickle crisis", "Escalate for exchange transfusion"]
  },
  vitalsMod: {
    hr: 118,
    bpSys: 112,
    spO2: 88,
    rr: 32,
    temp: 38.6
  },
  deterioration: {
    active: true,
    rate: 0.1,
    type: 'respiratory'
  },
  ecg: {
    type: "Sinus Tachycardia",
    findings: "Sinus tachycardia"
  },
  stabilisers: ['Oxygen', 'ExchangeTransfusion'],
  recommendedActions: ['Obs', 'IV Access', 'Oxygen', 'Fentanyl', 'Analgesia', 'Fluids', 'Ceftriaxone', 'ExchangeTransfusion', 'CPAP']
}, {
  id: 'AM077',
  title: 'Acute Haemolytic Transfusion Reaction',
  category: 'Medical',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(35, 64);
  },
  patientProfileTemplate: "A {age}-year-old {sex}. Fifteen minutes into a red cell transfusion, now loin pain, fever and dark urine.",
  presentingComplaint: 'Transfusion Reaction',
  instructorBrief: {
    progression: "ABO incompatible unit. Stop the transfusion immediately, keep the line, resuscitate and report as a serious incident.",
    interventions: ["Stop transfusion", "Fluids", "Recheck identity", "SHOT reporting"],
    learningObjectives: ["Distinguish haemolytic reaction from febrile or allergic reactions", "Follow immediate transfusion reaction steps", "Understand incident reporting duties"]
  },
  vitalsMod: {
    hr: 130,
    bpSys: 82,
    spO2: 94,
    rr: 28,
    temp: 39.5
  },
  deterioration: {
    active: true,
    rate: 0.12,
    type: 'shock'
  },
  ecg: {
    type: "Sinus Tachycardia",
    findings: "Sinus tachycardia, peaked T waves"
  },
  vbgClinicalState: "hyperkalemia",
  stabilisers: ['Fluids'],
  recommendedActions: ['Obs', 'IV Access', 'Oxygen', 'Fluids', 'Calcium', 'Catheter', 'Noradrenaline']
}, {
  id: 'AM078',
  title: 'ACE-Inhibitor Angio-oedema',
  category: 'Medical',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(45, 64);
  },
  patientProfileTemplate: "A {age}-year-old {sex} on ramipril. Progressive tongue and lip swelling over two hours. No rash, no wheeze.",
  presentingComplaint: 'Airway Swelling',
  instructorBrief: {
    progression: "Bradykinin-mediated, so adrenaline, steroids and antihistamines have little effect. The airway is the whole scenario: plan early for awake fibreoptic or front of neck access.",
    interventions: ["Early airway plan", "Senior anaesthetic and ENT help", "Stop ACE inhibitor"],
    learningObjectives: ["Distinguish bradykinin angio-oedema from anaphylaxis", "Recognise limits of adrenaline in this condition", "Plan a difficult airway with a surgical backup"]
  },
  vitalsMod: {
    hr: 104,
    bpSys: 156,
    spO2: 95,
    rr: 24
  },
  deterioration: {
    active: true,
    rate: 0.1,
    type: 'airway'
  },
  ecg: {
    type: "Sinus Tachycardia",
    findings: "Sinus tachycardia"
  },
  stabilisers: ['RSI', 'FONA'],
  recommendedActions: ['Obs', 'IV Access', 'Oxygen', 'RSI', 'FONA']
}, {
  id: 'AM079',
  title: 'Anaphylaxis (IV Contrast)',
  category: 'Medical',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(30, 64);
  },
  patientProfileTemplate: "A {age}-year-old {sex}. Collapsed in the CT scanner moments after iodinated contrast injection.",
  presentingComplaint: 'Anaphylaxis',
  instructorBrief: {
    progression: "Rapid onset shock with urticaria and wheeze in a remote location. IM adrenaline first, then fluids. Refractory cases need an adrenaline infusion.",
    interventions: ["AdrenalineIM", "Fluids", "Remove trigger", "Serial tryptase"],
    learningObjectives: ["Manage anaphylaxis away from the resus room", "Prioritise IM adrenaline and fluids", "Arrange tryptase sampling and allergy follow-up"]
  },
  vitalsMod: {
    hr: 138,
    bpSys: 68,
    spO2: 88,
    rr: 32
  },
  deterioration: {
    active: true,
    rate: 0.15,
    type: 'shock'
  },
  ecg: {
    type: "Sinus Tachycardia",
    findings: "Sinus tachycardia"
  },
  stabilisers: ['AdrenalineIM', 'Fluids'],
  recommendedActions: ['Obs', 'IV Access', 'Oxygen', 'AdrenalineIM', 'Fluids', 'Nebs', 'AdrenalineInfusion']
},
// --- ADULT MEDICAL: NEUROLOGY / ENDOCRINE / ENT ---
{
  id: 'AM080',
  title: 'Symptomatic Hypoglycaemia',
  category: 'Medical',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(25, 64);
  },
  patientProfileTemplate: "A {age}-year-old {sex} with type 1 diabetes. Found drowsy and sweating at home, aggressive on waking.",
  presentingComplaint: 'Reduced GCS',
  instructorBrief: {
    progression: "Capillary glucose 1.8. Rapid correction reverses everything. Look for the cause: missed meal, alcohol, or a long acting insulin error.",
    interventions: ["Dextrose", "Glucagon if no access", "Recheck glucose", "Feed and observe"],
    learningObjectives: ["Always check glucose in reduced consciousness", "Choose the right route for glucose replacement", "Plan safe discharge after sulfonylurea or long-acting insulin"]
  },
  vitalsMod: {
    hr: 108,
    bpSys: 138,
    spO2: 97,
    rr: 18,
    gcs: 10,
    bm: 1.8
  },
  deterioration: {
    active: true,
    rate: 0.05,
    type: 'neuro'
  },
  ecg: {
    type: "Sinus Tachycardia",
    findings: "Sinus tachycardia"
  },
  stabilisers: ['Dextrose'],
  recommendedActions: ['Obs', 'IV Access', 'Dextrose', 'Glucagon', 'Oxygen', 'Manoeuvres']
}, {
  id: 'AM081',
  title: 'Herpes Simplex Encephalitis',
  category: 'Medical',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(25, 64);
  },
  patientProfileTemplate: "A {age}-year-old {sex}. Three days of fever and odd behaviour, now confused with word-finding difficulty.",
  presentingComplaint: 'Confusion',
  instructorBrief: {
    progression: "Temporal lobe encephalitis. Aciclovir must not wait for imaging or LP. A focal seizure develops if treatment is delayed.",
    interventions: ["Aciclovir", "Ceftriaxone", "CT then LP"],
    learningObjectives: ["Distinguish encephalitis from meningitis", "Treat empirically before confirmatory tests", "Sequence CT and lumbar puncture safely"]
  },
  vitalsMod: {
    hr: 106,
    bpSys: 132,
    spO2: 96,
    rr: 20,
    temp: 38.7,
    gcs: 13
  },
  deterioration: {
    active: true,
    rate: 0.07,
    type: 'neuro'
  },
  ecg: {
    type: "Sinus Tachycardia",
    findings: "Sinus tachycardia"
  },
  stabilisers: ['Ceftriaxone', 'Aciclovir'],
  recommendedActions: ['Obs', 'IV Access', 'Aciclovir', 'Ceftriaxone', 'Dexamethasone', 'Fluids', 'Lorazepam', 'LumbarPuncture', 'Paracetamol']
}, {
  id: 'AM082',
  title: 'Transient Ischaemic Attack',
  category: 'Medical',
  ageRange: 'Adult',
  acuity: 'Majors',
  ageGenerator: function ageGenerator() {
    return getRandomInt(55, 64);
  },
  patientProfileTemplate: "A {age}-year-old {sex}. Forty minutes of right arm weakness and slurred speech, now fully resolved.",
  presentingComplaint: 'Resolved Neurology',
  instructorBrief: {
    progression: "Symptoms have resolved but the risk of completed stroke is highest in the first 48 hours. Aspirin, carotid imaging and rapid clinic follow-up.",
    interventions: ["Aspirin 300mg", "Assess for AF", "Rapid access TIA clinic"],
    learningObjectives: ["Risk stratify TIA", "Start secondary prevention immediately", "Recognise indications for admission versus clinic"]
  },
  vitalsMod: {
    hr: 84,
    bpSys: 168,
    bpDia: 96,
    spO2: 97,
    rr: 16
  },
  deterioration: {
    active: false,
    rate: 0.01,
    type: 'neuro'
  },
  ecg: {
    type: "AF",
    findings: "Newly identified atrial fibrillation"
  },
  recommendedActions: ['Obs', 'IV Access', 'Aspirin', 'Heparin']
}, {
  id: 'AM083',
  title: 'Severe Posterior Epistaxis',
  category: 'Medical',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(50, 64);
  },
  patientProfileTemplate: "A {age}-year-old {sex} on apixaban. Heavy nosebleed for an hour, swallowing large amounts of blood.",
  presentingComplaint: 'Epistaxis',
  instructorBrief: {
    progression: "Posterior bleed not controlled by pressure. Risk of aspiration and haemodynamic compromise. Needs packing and reversal considerations.",
    interventions: ["First aid pressure", "Nasal packing", "TXA", "ENT referral"],
    learningObjectives: ["Escalate epistaxis management stepwise", "Recognise the airway risk of posterior bleeding", "Manage bleeding on direct oral anticoagulants"]
  },
  vitalsMod: {
    hr: 116,
    bpSys: 96,
    spO2: 95,
    rr: 24
  },
  deterioration: {
    active: true,
    rate: 0.08,
    type: 'shock'
  },
  ecg: {
    type: "Sinus Tachycardia",
    findings: "Sinus tachycardia"
  },
  stabilisers: ['TXA', 'Fluids'],
  recommendedActions: ['Obs', 'IV Access', 'Oxygen', 'TXA', 'Fluids', 'Blood', 'Suction', 'Antiemetic', 'Octaplex']
}, {
  id: 'AM084',
  title: 'Primary Spontaneous Pneumothorax',
  category: 'Medical',
  ageRange: 'Adult',
  acuity: 'Majors',
  ageGenerator: function ageGenerator() {
    return getRandomInt(18, 35);
  },
  patientProfileTemplate: "A {age}-year-old tall thin {sex}. Sudden left pleuritic chest pain and breathlessness while sitting still.",
  presentingComplaint: 'Chest Pain',
  instructorBrief: {
    progression: "Large primary pneumothorax but not under tension. Symptom-directed management: this patient is breathless so needs intervention, not simple observation.",
    interventions: ["Oxygen", "Needle aspiration or Seldinger drain", "Smoking advice"],
    learningObjectives: ["Differentiate primary and secondary pneumothorax", "Apply symptom-based BTS management", "Recognise when a pneumothorax is under tension"]
  },
  vitalsMod: {
    hr: 104,
    bpSys: 124,
    spO2: 93,
    rr: 26
  },
  deterioration: {
    active: true,
    rate: 0.04,
    type: 'respiratory'
  },
  ecg: {
    type: "Sinus Tachycardia",
    findings: "Sinus tachycardia"
  },
  stabilisers: ['SeldingerDrain'],
  recommendedActions: ['Obs', 'IV Access', 'Oxygen', 'Needle', 'SeldingerDrain', 'Analgesia']
},
// --- ADULT MEDICAL: ENVIRONMENTAL / ASPHYXIAL ---
{
  id: 'AM085',
  title: 'Drowning (Immersion)',
  category: 'Medical',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(18, 45);
  },
  patientProfileTemplate: "A {age}-year-old {sex}. Pulled from a canal after around five minutes submerged. Coughing frothy pink sputum.",
  presentingComplaint: 'Drowning',
  instructorBrief: {
    progression: "Hypoxia is the primary problem, so ventilation comes before compressions in drowning. Beware concurrent hypothermia and cervical spine injury if the patient dived.",
    interventions: ["Oxygen", "Early ventilation", "Rewarming", "PEEP/CPAP"],
    learningObjectives: ["Apply the drowning-modified resuscitation sequence", "Prioritise oxygenation over circulation", "Manage associated hypothermia"]
  },
  vitalsMod: {
    hr: 118,
    bpSys: 104,
    spO2: 82,
    rr: 34,
    temp: 33.8,
    gcs: 12
  },
  deterioration: {
    active: true,
    rate: 0.12,
    type: 'respiratory'
  },
  ecg: {
    type: "Sinus Tachycardia",
    findings: "Sinus tachycardia with shivering artefact"
  },
  vbgClinicalState: "respiratory_acidosis_acute",
  stabilisers: ['Oxygen', 'CPAP', 'Warming'],
  recommendedActions: ['Obs', 'IV Access', 'Oxygen', 'Bagging', 'CPAP', 'RSI', 'Warming', 'Collar', 'Suction']
}, {
  id: 'AM086',
  title: 'Near-Hanging',
  category: 'Medical',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(18, 50);
  },
  patientProfileTemplate: "A {age}-year-old {sex}. Cut down from a ligature by family. Ligature mark visible, hoarse voice, agitated.",
  presentingComplaint: 'Hanging',
  instructorBrief: {
    progression: "Airway oedema evolves over hours and can obstruct late. Also consider carotid injury and post-hypoxic brain injury. Mental health assessment is mandatory once medically stable.",
    interventions: ["Early airway assessment", "CT angiogram neck", "Mental health referral"],
    learningObjectives: ["Anticipate delayed airway obstruction after strangulation", "Screen for vascular and cervical spine injury", "Integrate psychiatric risk assessment into physical care"]
  },
  vitalsMod: {
    hr: 112,
    bpSys: 142,
    spO2: 93,
    rr: 24,
    gcs: 13
  },
  deterioration: {
    active: true,
    rate: 0.09,
    type: 'airway'
  },
  ecg: {
    type: "Sinus Tachycardia",
    findings: "Sinus tachycardia"
  },
  stabilisers: ['Oxygen', 'RSI'],
  recommendedActions: ['Obs', 'IV Access', 'Oxygen', 'Collar', 'RSI', 'FONA', 'Dexamethasone', 'Suction']
}, {
  id: 'AM087',
  title: 'Cyanide Toxicity (House Fire)',
  category: 'Medical',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(25, 60);
  },
  patientProfileTemplate: "A {age}-year-old {sex}. Rescued from a smoke-filled flat. Soot around the mouth, drowsy, profound lactic acidosis.",
  presentingComplaint: 'Smoke Inhalation',
  instructorBrief: {
    progression: "Combined carbon monoxide and cyanide toxicity. A high lactate with normal-looking saturations is the clue. Give hydroxocobalamin empirically.",
    interventions: ["High flow oxygen", "Hydroxocobalamin", "Airway assessment for burns"],
    learningObjectives: ["Recognise cyanide toxicity in fire victims", "Interpret a raised lactate with normal SpO2", "Treat empirically without waiting for levels"]
  },
  vitalsMod: {
    hr: 128,
    bpSys: 84,
    spO2: 98,
    rr: 34,
    gcs: 11
  },
  deterioration: {
    active: true,
    rate: 0.13,
    type: 'shock'
  },
  ecg: {
    type: "Sinus Tachycardia",
    findings: "Sinus tachycardia with ischaemic changes"
  },
  vbgClinicalState: "co_poisoning",
  stabilisers: ['Oxygen', 'Hydroxocobalamin'],
  recommendedActions: ['Obs', 'IV Access', 'Oxygen', 'Hydroxocobalamin', 'Bagging', 'RSI', 'Fluids', 'SodiumBicarb']
}, {
  id: 'AM088',
  title: 'Decompression Sickness',
  category: 'Medical',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(20, 55);
  },
  patientProfileTemplate: "A {age}-year-old {sex} diver. Rapid ascent from 30 metres. Joint pains, rash and now leg weakness.",
  presentingComplaint: 'Diving Illness',
  instructorBrief: {
    progression: "Neurological decompression illness. One hundred percent oxygen and fluids while arranging recompression. Do not transport by unpressurised air at altitude.",
    interventions: ["High flow oxygen", "Fluids", "Hyperbaric referral"],
    learningObjectives: ["Recognise neurological decompression illness", "Understand the role of 100% oxygen", "Arrange safe transfer for recompression"]
  },
  vitalsMod: {
    hr: 96,
    bpSys: 122,
    spO2: 96,
    rr: 20,
    gcs: 15
  },
  deterioration: {
    active: true,
    rate: 0.05,
    type: 'neuro'
  },
  ecg: {
    type: "Sinus Rhythm",
    findings: "Normal sinus rhythm"
  },
  stabilisers: ['Oxygen', 'Hyperbaric'],
  recommendedActions: ['Obs', 'IV Access', 'Oxygen', 'Fluids', 'Analgesia', 'Hyperbaric', 'Catheter']
},
// --- GERIATRIC MEDICAL ---
{
  id: 'EL008',
  title: 'Aspiration Pneumonia',
  category: 'Medical',
  ageRange: 'Elderly',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(78, 94);
  },
  patientProfileTemplate: "A {age}-year-old {sex} from a nursing home with advanced dementia. Coughing during meals for a week, now febrile and hypoxic.",
  presentingComplaint: 'Breathlessness',
  instructorBrief: {
    progression: "Right lower lobe aspiration with sepsis. Explore swallow assessment, oral intake safety and realistic treatment goals with the family.",
    interventions: ["Oxygen", "Antibiotics", "Fluids", "Swallow assessment"],
    learningObjectives: ["Recognise aspiration risk in frail patients", "Balance escalation against frailty", "Communicate treatment goals with relatives"]
  },
  vitalsMod: {
    hr: 112,
    bpSys: 98,
    spO2: 86,
    rr: 30,
    temp: 38.6,
    gcs: 13
  },
  deterioration: {
    active: true,
    rate: 0.1,
    type: 'respiratory'
  },
  ecg: {
    type: "Sinus Tachycardia",
    findings: "Sinus tachycardia"
  },
  vbgClinicalState: "septic_shock",
  stabilisers: ['Oxygen', 'Tazocin', 'Fluids'],
  recommendedActions: ['Obs', 'IV Access', 'Oxygen', 'Tazocin', 'Fluids', 'Paracetamol', 'NIV', 'Suction', 'Catheter']
}, {
  id: 'EL009',
  title: 'Large Bowel Obstruction',
  category: 'Medical',
  ageRange: 'Elderly',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(70, 90);
  },
  patientProfileTemplate: "A {age}-year-old {sex}. Five days without bowels open, distended abdomen and faeculent vomiting.",
  presentingComplaint: 'Abdominal Distension',
  instructorBrief: {
    progression: "Obstructing sigmoid tumour with a competent ileocaecal valve, so a closed loop at risk of perforation. Third space losses cause profound dehydration.",
    interventions: ["Drip and suck", "Aggressive fluids", "Urgent CT", "Surgical referral"],
    learningObjectives: ["Recognise closed loop obstruction risk", "Correct large third space fluid deficits", "Expedite imaging and surgical review"]
  },
  vitalsMod: {
    hr: 116,
    bpSys: 94,
    spO2: 95,
    rr: 24,
    temp: 37.6
  },
  deterioration: {
    active: true,
    rate: 0.09,
    type: 'shock'
  },
  ecg: {
    type: "Sinus Tachycardia",
    findings: "Sinus tachycardia"
  },
  vbgClinicalState: "metabolic_alkalosis",
  stabilisers: ['Fluids', 'NGTube'],
  recommendedActions: ['Obs', 'IV Access', 'Fluids', 'NGTube', 'Antiemetic', 'Cyclizine', 'Analgesia', 'Catheter', 'Tazocin', 'Surgery']
}, {
  id: 'EL010',
  title: 'Posterior Circulation Stroke',
  category: 'Medical',
  ageRange: 'Elderly',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(66, 88);
  },
  patientProfileTemplate: "A {age}-year-old {sex}. Sudden vertigo, vomiting and unsteadiness. Cannot sit unsupported.",
  presentingComplaint: 'Dizziness',
  instructorBrief: {
    progression: "Cerebellar infarct. Standard stroke scales score poorly in posterior circulation events, so dizziness plus inability to walk should prompt urgent imaging. Risk of malignant oedema.",
    interventions: ["Urgent CT and CTA", "Thrombolysis assessment", "Airway monitoring"],
    learningObjectives: ["Recognise posterior circulation stroke presentations", "Understand limitations of stroke scales", "Anticipate cerebellar swelling and hydrocephalus"]
  },
  vitalsMod: {
    hr: 78,
    bpSys: 178,
    bpDia: 98,
    spO2: 96,
    rr: 18,
    gcs: 14
  },
  deterioration: {
    active: true,
    rate: 0.07,
    type: 'neuro'
  },
  ecg: {
    type: "AF",
    findings: "Atrial fibrillation"
  },
  stabilisers: ['Thrombolysis'],
  recommendedActions: ['Obs', 'IV Access', 'Oxygen', 'Thrombolysis', 'Antiemetic', 'Labetalol', 'RSI', 'NGTube']
}, {
  id: 'EL011',
  title: 'Frailty and Ceilings of Care',
  category: 'Medical',
  ageRange: 'Elderly',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(84, 96);
  },
  patientProfileTemplate: "A {age}-year-old {sex}, bed-bound with a clinical frailty score of 8. Pneumonia and hypotension. Daughter is asking for everything to be done.",
  presentingComplaint: 'Sepsis',
  instructorBrief: {
    progression: "The clinical work is straightforward; the challenge is the conversation. Explore treatment escalation planning, ReSPECT documentation and managing family expectations while still treating reversible illness.",
    interventions: ["Antibiotics", "Fluids", "Escalation planning", "Family discussion"],
    learningObjectives: ["Make and document treatment escalation decisions", "Communicate ceilings of care compassionately", "Deliver active symptom control alongside limits"]
  },
  vitalsMod: {
    hr: 108,
    bpSys: 88,
    spO2: 89,
    rr: 28,
    temp: 38.4,
    gcs: 13
  },
  deterioration: {
    active: true,
    rate: 0.08,
    type: 'shock'
  },
  ecg: {
    type: "Sinus Tachycardia",
    findings: "Sinus tachycardia"
  },
  vbgClinicalState: "septic_shock",
  stabilisers: ['Fluids', 'Tazocin', 'Oxygen'],
  recommendedActions: ['Obs', 'IV Access', 'Oxygen', 'Tazocin', 'Fluids', 'Analgesia', 'Midazolam', 'Paracetamol']
}, {
  id: 'EL012',
  title: 'Severe Symptomatic Anaemia',
  category: 'Medical',
  ageRange: 'Elderly',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(70, 90);
  },
  patientProfileTemplate: "A {age}-year-old {sex}. Months of tiredness, now chest pain and breathlessness at rest. Conjunctivae are white.",
  presentingComplaint: 'Breathlessness',
  instructorBrief: {
    progression: "Haemoglobin 42 from occult GI loss. Demand ischaemia on the ECG. Transfuse, but slowly and with diuretic cover to avoid TACO.",
    interventions: ["Blood", "Furosemide cover", "Investigate source"],
    learningObjectives: ["Recognise anaemia causing demand ischaemia", "Transfuse safely in chronic anaemia", "Prevent transfusion associated circulatory overload"]
  },
  vitalsMod: {
    hr: 116,
    bpSys: 104,
    spO2: 94,
    rr: 26
  },
  deterioration: {
    active: true,
    rate: 0.06,
    type: 'cardiac'
  },
  ecg: {
    type: "Sinus Tachycardia",
    findings: "Widespread ST depression from demand ischaemia"
  },
  stabilisers: ['Blood'],
  recommendedActions: ['Obs', 'IV Access', 'Oxygen', 'Blood', 'Furosemide', 'Analgesia', 'Catheter']
}, {
  id: 'EL013',
  title: 'Obstructive AKI (Urinary Retention)',
  category: 'Medical',
  sex: 'Male',
  ageRange: 'Elderly',
  acuity: 'Majors',
  ageGenerator: function ageGenerator() {
    return getRandomInt(70, 90);
  },
  patientProfileTemplate: "A {age}-year-old {sex} with prostatism. Unable to pass urine for two days, confused and vomiting.",
  presentingComplaint: 'Urinary Retention',
  instructorBrief: {
    progression: "Chronic high pressure retention with a creatinine of 480 and potassium of 6.4. Catheterisation is the treatment. Warn about post-obstructive diuresis.",
    interventions: ["Catheter", "Treat hyperkalaemia", "Monitor post-obstructive diuresis"],
    learningObjectives: ["Identify post-renal AKI", "Manage hyperkalaemia urgently", "Anticipate post-obstructive diuresis and decompression haematuria"]
  },
  vitalsMod: {
    hr: 92,
    bpSys: 148,
    spO2: 96,
    rr: 20,
    gcs: 14
  },
  deterioration: {
    active: true,
    rate: 0.04,
    type: 'cardiac'
  },
  ecg: {
    type: "Sinus Rhythm",
    findings: "Tented T waves in the precordial leads"
  },
  vbgClinicalState: "hyperkalemia",
  stabilisers: ['Catheter', 'Calcium'],
  recommendedActions: ['Obs', 'IV Access', 'Catheter', 'Calcium', 'InsulinDextrose', 'Nebs', 'Fluids']
},
// --- PAEDIATRIC MEDICAL ---
{
  id: 'PA026',
  title: 'Paediatric Acute Severe Asthma',
  category: 'Medical',
  ageRange: 'Paediatric',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(5, 12);
  },
  patientProfileTemplate: "A {age}-year-old {sex}. Known asthmatic, three days of coryza, now too breathless to complete sentences.",
  presentingComplaint: 'Wheeze',
  instructorBrief: {
    progression: "Silent chest and exhaustion develop if back-to-back salbutamol is not escalated. Move to IV magnesium then aminophylline or salbutamol infusion. Intubation is high risk.",
    interventions: ["Burst nebulisers", "Steroids", "MagSulph", "PICU referral"],
    learningObjectives: ["Grade paediatric asthma severity", "Escalate treatment in the correct order", "Recognise the exhausted child and the silent chest"]
  },
  vitalsMod: {
    hr: 152,
    bpSys: 104,
    spO2: 88,
    rr: 44,
    temp: 37.4
  },
  deterioration: {
    active: true,
    rate: 0.12,
    type: 'respiratory'
  },
  ecg: {
    type: "Sinus Tachycardia",
    findings: "Sinus tachycardia from beta agonists"
  },
  vbgClinicalState: "respiratory_acidosis_acute",
  stabilisers: ['Nebs', 'MagSulph', 'Hydrocortisone'],
  recommendedActions: ['Obs', 'Oxygen', 'Nebs', 'IV Access', 'Hydrocortisone', 'MagSulph', 'Dexamethasone', 'Fluids', 'RSI']
}, {
  id: 'PA027',
  title: 'Bacterial Tracheitis',
  category: 'Medical',
  ageRange: 'Paediatric',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(2, 6);
  },
  patientProfileTemplate: "A {age}-year-old {sex}. Croupy cough for three days, now high fever, toxic-looking and stridulous. No response to nebulised adrenaline.",
  presentingComplaint: 'Stridor',
  instructorBrief: {
    progression: "Failure to respond to steroid and adrenaline distinguishes this from croup. Thick purulent secretions can obstruct suddenly. Needs theatre for intubation and bronchoscopy.",
    interventions: ["Minimal handling", "Senior airway team", "Ceftriaxone", "Theatre intubation"],
    learningObjectives: ["Distinguish tracheitis from croup and epiglottitis", "Avoid distressing the child with a critical airway", "Mobilise the difficult paediatric airway team"]
  },
  vitalsMod: {
    hr: 168,
    bpSys: 92,
    spO2: 90,
    rr: 42,
    temp: 39.4
  },
  deterioration: {
    active: true,
    rate: 0.14,
    type: 'airway'
  },
  ecg: {
    type: "Sinus Tachycardia",
    findings: "Sinus tachycardia"
  },
  stabilisers: ['NebAdrenaline', 'Ceftriaxone', 'RSI'],
  recommendedActions: ['Obs', 'Oxygen', 'NebAdrenaline', 'Dexamethasone', 'IV Access', 'Ceftriaxone', 'RSI', 'FONA', 'Suction']
}, {
  id: 'PA028',
  title: 'Gastroenteritis with Shock',
  category: 'Medical',
  ageRange: 'Paediatric',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(1, 3);
  },
  patientProfileTemplate: "A {age}-year-old {sex}. Four days of profuse diarrhoea and vomiting. Sunken eyes, no wet nappies for 12 hours.",
  presentingComplaint: 'Dehydration',
  instructorBrief: {
    progression: "Decompensated hypovolaemic shock with over 10 percent dehydration. Needs 10ml/kg boluses then careful deficit replacement. Watch for hypoglycaemia and hypernatraemia.",
    interventions: ["Fluid boluses at 10ml/kg", "Check glucose and electrolytes", "Deficit plus maintenance calculation"],
    learningObjectives: ["Assess paediatric dehydration clinically", "Use weight-based fluid resuscitation", "Correct sodium abnormalities safely"]
  },
  vitalsMod: {
    hr: 178,
    bpSys: 74,
    spO2: 97,
    rr: 40,
    temp: 37.8,
    gcs: 13,
    bm: 2.6
  },
  deterioration: {
    active: true,
    rate: 0.13,
    type: 'shock'
  },
  ecg: {
    type: "Sinus Tachycardia",
    findings: "Sinus tachycardia"
  },
  vbgClinicalState: "metabolic_acidosis_severe",
  stabilisers: ['Fluids', 'Dextrose'],
  recommendedActions: ['Obs', 'IV Access', 'Fluids', 'Dextrose', 'Antiemetic', 'Oxygen', 'Catheter']
}, {
  id: 'PA029',
  title: 'Early Onset Neonatal Sepsis',
  category: 'Medical',
  ageRange: 'Paediatric',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return 0;
  },
  patientProfileTemplate: "A 2-day-old baby, born at term. Prolonged rupture of membranes. Poor feeding, grunting and mottled.",
  presentingComplaint: 'Unwell Neonate',
  instructorBrief: {
    progression: "Group B streptococcal sepsis. Neonates decompensate late then suddenly. Benzylpenicillin and gentamicin, glucose check and fluid boluses at 10ml/kg.",
    interventions: ["Benzylpenicillin plus gentamicin (NICE NG195)", "Fluids 10ml/kg", "Glucose", "Neonatal referral"],
    learningObjectives: ["Recognise subtle signs of neonatal sepsis", "Apply neonatal weight-based dosing", "Escalate to the neonatal team early"]
  },
  vitalsMod: {
    hr: 188,
    bpSys: 52,
    bpDia: 30,
    spO2: 90,
    rr: 68,
    temp: 35.6,
    bm: 2.2
  },
  deterioration: {
    active: true,
    rate: 0.15,
    type: 'shock'
  },
  ecg: {
    type: "Sinus Tachycardia",
    findings: "Sinus tachycardia"
  },
  vbgClinicalState: "septic_shock",
  stabilisers: ['Benzylpenicillin', 'Fluids', 'Dextrose'],
  recommendedActions: ['Obs', 'IV Access', 'Oxygen', 'Benzylpenicillin', 'Gentamicin', 'Fluids', 'Dextrose', 'Warming', 'Bagging']
}, {
  id: 'PA030',
  title: 'Infant Urosepsis',
  category: 'Medical',
  ageRange: 'Paediatric',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return 0.12;
  },
  patientProfileTemplate: "A 6-week-old baby. Two days of fever, vomiting and poor feeding. No focus on examination.",
  presentingComplaint: 'Fever in Infant',
  instructorBrief: {
    progression: "Febrile infant under three months is high risk by definition. Urinary tract infection with early shock. Full septic screen including lumbar puncture and empirical antibiotics.",
    interventions: ["Full septic screen", "Antibiotics", "Fluids", "Clean catch urine"],
    learningObjectives: ["Apply NICE traffic light and febrile infant pathways", "Justify a full septic screen under three months", "Obtain reliable urine samples in infants"]
  },
  vitalsMod: {
    hr: 182,
    bpSys: 66,
    bpDia: 40,
    spO2: 96,
    rr: 58,
    temp: 39.2
  },
  deterioration: {
    active: true,
    rate: 0.11,
    type: 'shock'
  },
  ecg: {
    type: "Sinus Tachycardia",
    findings: "Sinus tachycardia"
  },
  vbgClinicalState: "septic_shock",
  stabilisers: ['Ceftriaxone', 'Fluids'],
  recommendedActions: ['Obs', 'IV Access', 'Ceftriaxone', 'Fluids', 'Paracetamol', 'Oxygen', 'LumbarPuncture', 'Catheter']
}, {
  id: 'PA031',
  title: 'Infant Apnoea (BRUE)',
  category: 'Medical',
  ageRange: 'Paediatric',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return 0.12;
  },
  patientProfileTemplate: "A 6-week-old baby. Parents describe going blue and floppy for around 30 seconds during a feed. Now looks well.",
  presentingComplaint: 'Apnoea',
  instructorBrief: {
    progression: "A well-looking infant after a frightening event. Distinguish lower risk BRUE from a sentinel event: consider sepsis, pertussis, reflux, cardiac disease and non-accidental injury.",
    interventions: ["Structured history", "Observation and monitoring", "Consider safeguarding"],
    learningObjectives: ["Apply BRUE risk stratification", "Recognise mimics including NAI and pertussis", "Counsel anxious parents appropriately"]
  },
  vitalsMod: {
    hr: 148,
    bpSys: 74,
    bpDia: 44,
    spO2: 97,
    rr: 44,
    temp: 36.9
  },
  deterioration: {
    active: true,
    rate: 0.06,
    type: 'respiratory'
  },
  ecg: {
    type: "Sinus Tachycardia",
    findings: "Sinus rhythm for age"
  },
  recommendedActions: ['Obs', 'IV Access', 'Oxygen', 'Bagging', 'Suction', 'Dextrose']
}, {
  id: 'PA032',
  title: 'VP Shunt Malfunction',
  category: 'Medical',
  ageRange: 'Paediatric',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(4, 12);
  },
  patientProfileTemplate: "A {age}-year-old {sex} with a ventriculoperitoneal shunt for congenital hydrocephalus. Two days of headache and vomiting, now drowsy.",
  presentingComplaint: 'Headache',
  instructorBrief: {
    progression: "Raised intracranial pressure from shunt blockage. Cushing response develops. Needs urgent CT, neurosurgical referral and possibly a shunt tap.",
    interventions: ["Urgent CT head", "Neurosurgical referral", "Manage raised ICP"],
    learningObjectives: ["Recognise shunt malfunction", "Identify the Cushing reflex", "Institute neuroprotective measures"]
  },
  vitalsMod: {
    hr: 58,
    bpSys: 132,
    bpDia: 78,
    spO2: 97,
    rr: 12,
    gcs: 11
  },
  deterioration: {
    active: true,
    rate: 0.12,
    type: 'neuro'
  },
  ecg: {
    type: "Sinus Bradycardia",
    findings: "Sinus bradycardia"
  },
  stabilisers: ['HypertonicSaline', 'RSI'],
  recommendedActions: ['Obs', 'IV Access', 'Oxygen', 'HypertonicSaline', 'Mannitol', 'RSI', 'Antiemetic', 'Analgesia']
}, {
  id: 'PA033',
  title: 'Paediatric Febrile Neutropenia',
  category: 'Medical',
  ageRange: 'Paediatric',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(3, 12);
  },
  patientProfileTemplate: "A {age}-year-old {sex} with acute lymphoblastic leukaemia and a central line. Fever of 39 at home this evening.",
  presentingComplaint: 'Fever',
  instructorBrief: {
    progression: "Line-associated sepsis. Antibiotics within one hour through the central line. Deteriorates rapidly to shock if delayed.",
    interventions: ["Tazocin within 1 hour", "Cultures from line and peripherally", "Fluids"],
    learningObjectives: ["Treat paediatric febrile neutropenia within the golden hour", "Sample central and peripheral cultures", "Recognise rapid decompensation in immunocompromised children"]
  },
  vitalsMod: {
    hr: 164,
    bpSys: 82,
    spO2: 95,
    rr: 36,
    temp: 39.3
  },
  deterioration: {
    active: true,
    rate: 0.13,
    type: 'shock'
  },
  ecg: {
    type: "Sinus Tachycardia",
    findings: "Sinus tachycardia"
  },
  vbgClinicalState: "septic_shock",
  stabilisers: ['Tazocin', 'Fluids'],
  recommendedActions: ['Obs', 'IV Access', 'Tazocin', 'Gentamicin', 'Fluids', 'Oxygen', 'Paracetamol', 'Noradrenaline']
}, {
  id: 'PA034',
  title: 'Perforated Appendicitis (Child)',
  category: 'Medical',
  ageRange: 'Paediatric',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(8, 14);
  },
  patientProfileTemplate: "A {age}-year-old {sex}. Three days of abdominal pain, initially central then right iliac fossa. Now generalised pain and high fever.",
  presentingComplaint: 'Abdominal Pain',
  instructorBrief: {
    progression: "Delayed presentation with perforation and peritonitis. Fluid resuscitate, give antibiotics and analgesia, and expedite theatre. Analgesia does not mask the surgical diagnosis.",
    interventions: ["Fluids", "Antibiotics", "Opiate analgesia", "Surgery"],
    learningObjectives: ["Recognise perforated appendicitis in children", "Provide adequate paediatric analgesia", "Resuscitate before theatre"]
  },
  vitalsMod: {
    hr: 148,
    bpSys: 92,
    spO2: 97,
    rr: 32,
    temp: 39.0
  },
  deterioration: {
    active: true,
    rate: 0.1,
    type: 'shock'
  },
  ecg: {
    type: "Sinus Tachycardia",
    findings: "Sinus tachycardia"
  },
  vbgClinicalState: "septic_shock",
  stabilisers: ['Fluids', 'Tazocin'],
  recommendedActions: ['Obs', 'IV Access', 'Fluids', 'Tazocin', 'Analgesia', 'Fentanyl', 'Antiemetic', 'Oxygen', 'Surgery']
}, {
  id: 'PA035',
  title: 'Long QT Collapse (Child)',
  category: 'Medical',
  ageRange: 'Paediatric',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(10, 15);
  },
  patientProfileTemplate: "A {age}-year-old {sex}. Collapsed while swimming at a school gala. Brief jerking then spontaneous recovery. A cousin died suddenly aged 19.",
  presentingComplaint: 'Collapse',
  instructorBrief: {
    progression: "Congenital long QT with torsades. Do not label this as a seizure. Correct magnesium and potassium, avoid QT-prolonging drugs and refer to inherited cardiac conditions.",
    interventions: ["12 lead ECG and QTc", "MagSulph", "Avoid QT prolonging drugs", "Family screening"],
    learningObjectives: ["Distinguish cardiac syncope from seizure", "Calculate and interpret QTc in children", "Arrange family screening for inherited arrhythmia"]
  },
  vitalsMod: {
    hr: 62,
    bpSys: 104,
    spO2: 98,
    rr: 18,
    gcs: 15
  },
  deterioration: {
    active: true,
    rate: 0.09,
    type: 'cardiac'
  },
  ecg: {
    type: "Sinus Bradycardia",
    findings: "Sinus bradycardia with markedly prolonged QTc"
  },
  stabilisers: ['MagSulph'],
  recommendedActions: ['Obs', 'IV Access', 'MagSulph', 'Defib', 'Pacing', 'Oxygen']
}, {
  id: 'PA036',
  title: 'Newborn Life Support (Unbooked Delivery)',
  category: 'Medical',
  ageRange: 'Paediatric',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return 0;
  },
  patientProfileTemplate: "A term newborn delivered in the ED waiting room minutes ago. Floppy, blue and not breathing.",
  presentingComplaint: 'Newborn Resuscitation',
  instructorBrief: {
    progression: "Delay cord clamping if possible, stimulate and keep warm. Open the airway, then five inflation breaths at 30 cm H2O in air (PEEP 6 cm H2O if possible) and look for chest rise; if the chest does not move, check mask, head and jaw position, use two-person support and consider an SGA, higher pressures, suction or a tracheal tube. Once the chest moves, ventilation breaths at 30 per minute. Compressions at 3:1 with 100% oxygen only if the heart rate is below 60 after 30 seconds of effective ventilation; if it stays below 60, vascular access, drugs, volume and a glucose check. Aeration of the lungs is everything.",
    interventions: ["Delayed cord clamping, stimulation, thermal care", "Five inflation breaths at 30 cm H2O", "Ventilation breaths at 30 per minute", "3:1 compressions if HR under 60 after 30 s of ventilation", "Titrate oxygen to pre-ductal SpO2 targets"],
    learningObjectives: ["Follow the Newborn Life Support algorithm", "Prioritise lung aeration over compressions", "Prevent neonatal heat loss"]
  },
  vitalsMod: {
    hr: 48,
    bpSys: 40,
    bpDia: 24,
    spO2: 55,
    rr: 0,
    temp: 35.2,
    gcs: 3,
    bm: 2.0
  },
  deterioration: {
    active: true,
    rate: 0.15,
    type: 'respiratory'
  },
  ecg: {
    type: "Sinus Bradycardia",
    findings: "Profound bradycardia"
  },
  stabilisers: ['Bagging', 'Warming'],
  recommendedActions: ['Obs', 'Bagging', 'Manoeuvres', 'Warming', 'CPR', 'IV Access', 'AdrenalineIV', 'Dextrose']
}, {
  id: 'PA037',
  title: 'Paediatric Anaphylaxis (Antibiotic)',
  category: 'Medical',
  ageRange: 'Paediatric',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(6, 14);
  },
  patientProfileTemplate: "A {age}-year-old {sex}. Given oral amoxicillin in the department 10 minutes ago. Now urticarial, wheezy and hypotensive.",
  presentingComplaint: 'Anaphylaxis',
  instructorBrief: {
    progression: "Iatrogenic anaphylaxis. IM adrenaline dosed by age band, fluids at 10ml/kg, then reassess. Biphasic reactions mandate observation.",
    interventions: ["AdrenalineIM by age band", "Fluids 10ml/kg", "Serial tryptase", "Allergy referral"],
    learningObjectives: ["Use correct paediatric adrenaline doses", "Recognise and document iatrogenic drug reactions", "Plan observation for biphasic reactions"]
  },
  vitalsMod: {
    hr: 162,
    bpSys: 68,
    spO2: 89,
    rr: 40
  },
  deterioration: {
    active: true,
    rate: 0.15,
    type: 'shock'
  },
  ecg: {
    type: "Sinus Tachycardia",
    findings: "Sinus tachycardia"
  },
  stabilisers: ['AdrenalineIM', 'Fluids'],
  recommendedActions: ['Obs', 'AdrenalineIM', 'Oxygen', 'IV Access', 'Fluids', 'Nebs', 'AdrenalineInfusion']
},
// --- ADULT TRAUMA ---
{
  id: 'AT024',
  title: 'Trauma in Pregnancy',
  category: 'Trauma',
  sex: 'Female',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(20, 38);
  },
  patientProfileTemplate: "A {age}-year-old woman, 32 weeks pregnant. Restrained front seat passenger in a 50mph RTC.",
  presentingComplaint: 'Polytrauma',
  instructorBrief: {
    progression: "Physiological hypervolaemia of pregnancy masks blood loss until late. Left lateral tilt or manual uterine displacement relieves aortocaval compression. Concealed abruption is the killer.",
    interventions: ["Manual uterine displacement", "Blood", "Obstetric team", "CTG and anti-D"],
    learningObjectives: ["Resuscitate the mother to save the fetus", "Relieve aortocaval compression", "Recognise concealed placental abruption after trauma"]
  },
  vitalsMod: {
    hr: 128,
    bpSys: 96,
    spO2: 94,
    rr: 28,
    gcs: 14
  },
  deterioration: {
    active: true,
    rate: 0.13,
    type: 'shock'
  },
  ecg: {
    type: "Sinus Tachycardia",
    findings: "Sinus tachycardia"
  },
  vbgClinicalState: "haemorrhagic_shock",
  stabilisers: ['Blood', 'TXA'],
  recommendedActions: ['Obs', 'IV Access', 'Oxygen', 'Blood', 'TXA', 'Collar', 'AntiD', 'Catheter', 'Hysterotomy']
}, {
  id: 'AT025',
  title: 'Blunt Abdominal Trauma (Splenic Rupture)',
  category: 'Trauma',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(18, 45);
  },
  patientProfileTemplate: "A {age}-year-old {sex}. Fell from a mountain bike onto the handlebars. Left upper quadrant pain radiating to the left shoulder.",
  presentingComplaint: 'Abdominal Trauma',
  instructorBrief: {
    progression: "Grade 4 splenic laceration. Transiently responds to fluid then drops again. Kehr sign present. Decide between CT, interventional radiology and laparotomy based on response.",
    interventions: ["Blood", "FAST scan", "CT if stable", "Laparotomy if not"],
    learningObjectives: ["Classify transient versus non-responders", "Use FAST appropriately", "Decide between angioembolisation and laparotomy"]
  },
  vitalsMod: {
    hr: 132,
    bpSys: 82,
    spO2: 96,
    rr: 28,
    gcs: 14
  },
  deterioration: {
    active: true,
    rate: 0.14,
    type: 'shock'
  },
  ecg: {
    type: "Sinus Tachycardia",
    findings: "Sinus tachycardia"
  },
  vbgClinicalState: "haemorrhagic_shock",
  stabilisers: ['Blood', 'TXA'],
  recommendedActions: ['Obs', 'IV Access', 'Oxygen', 'Blood', 'TXA', 'Analgesia', 'Fentanyl', 'Catheter', 'Surgery']
}, {
  id: 'AT026',
  title: 'Abdominal Evisceration (Stab)',
  category: 'Trauma',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(18, 40);
  },
  patientProfileTemplate: "A {age}-year-old {sex}. Stabbed in the abdomen. Loops of bowel visible through the wound.",
  presentingComplaint: 'Penetrating Trauma',
  instructorBrief: {
    progression: "Do not reduce the bowel. Cover with saline-soaked gauze and cling film. Evisceration is an absolute indication for laparotomy; imaging must not delay theatre.",
    interventions: ["Cover with moist dressing", "Blood", "Antibiotics", "Immediate laparotomy"],
    learningObjectives: ["Manage eviscerated bowel correctly", "Identify absolute indications for laparotomy", "Avoid imaging delays in penetrating trauma"]
  },
  vitalsMod: {
    hr: 126,
    bpSys: 88,
    spO2: 96,
    rr: 26
  },
  deterioration: {
    active: true,
    rate: 0.13,
    type: 'shock'
  },
  ecg: {
    type: "Sinus Tachycardia",
    findings: "Sinus tachycardia"
  },
  vbgClinicalState: "haemorrhagic_shock",
  stabilisers: ['Blood', 'ClingFilm'],
  recommendedActions: ['Obs', 'IV Access', 'Oxygen', 'ClingFilm', 'Blood', 'TXA', 'Tazocin', 'Analgesia', 'Fentanyl', 'Surgery']
}, {
  id: 'AT027',
  title: 'Gunshot Wound (Thigh)',
  category: 'Trauma',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(18, 40);
  },
  patientProfileTemplate: "A {age}-year-old {sex}. Single gunshot wound to the medial thigh. Pulsatile bleeding at the scene, tourniquet applied by police.",
  presentingComplaint: 'Penetrating Trauma',
  instructorBrief: {
    progression: "Junctional femoral artery injury. Do not release the tourniquet to look. Note the time of application. Needs blood, TXA and vascular surgery.",
    interventions: ["Tourniquet", "Blood", "TXA", "Vascular surgery"],
    learningObjectives: ["Use tourniquets correctly and document timing", "Resuscitate catastrophic external haemorrhage", "Consider forensic and police liaison duties"]
  },
  vitalsMod: {
    hr: 136,
    bpSys: 78,
    spO2: 95,
    rr: 30,
    gcs: 14
  },
  deterioration: {
    active: true,
    rate: 0.15,
    type: 'shock'
  },
  ecg: {
    type: "Sinus Tachycardia",
    findings: "Sinus tachycardia"
  },
  vbgClinicalState: "haemorrhagic_shock",
  stabilisers: ['Tourniquet', 'Blood'],
  recommendedActions: ['Obs', 'Tourniquet', 'IV Access', 'Oxygen', 'Blood', 'TXA', 'Ketamine', 'Analgesia', 'Splinting', 'Surgery']
}, {
  id: 'AT028',
  title: 'Inhalational Airway Burn',
  category: 'Trauma',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(20, 55);
  },
  patientProfileTemplate: "A {age}-year-old {sex}. Trapped in a burning caravan. Singed nasal hair, hoarse voice and carbonaceous sputum. 25 percent body surface burns.",
  presentingComplaint: 'Burns',
  instructorBrief: {
    progression: "The airway will swell over the next few hours. Intubate early with an uncut tube before oedema makes it impossible. Parkland formula fluids and escharotomy if circumferential.",
    interventions: ["Early intubation", "Parkland fluids", "Escharotomy", "Burns centre referral"],
    learningObjectives: ["Identify inhalation injury features", "Intubate early rather than late", "Calculate burns fluid resuscitation"]
  },
  vitalsMod: {
    hr: 124,
    bpSys: 108,
    spO2: 92,
    rr: 30,
    temp: 36.2,
    gcs: 14
  },
  deterioration: {
    active: true,
    rate: 0.13,
    type: 'airway'
  },
  ecg: {
    type: "Sinus Tachycardia",
    findings: "Sinus tachycardia"
  },
  vbgClinicalState: "co_poisoning",
  stabilisers: ['RSI', 'Fluids'],
  recommendedActions: ['Obs', 'Oxygen', 'IV Access', 'RSI', 'FONA', 'Fluids', 'Fentanyl', 'Ketamine', 'Escharotomy', 'ClingFilm', 'Catheter']
}, {
  id: 'AT029',
  title: 'Central Cord Syndrome',
  category: 'Trauma',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(60, 64);
  },
  patientProfileTemplate: "A {age}-year-old {sex} with cervical spondylosis. Tripped and struck the forehead. Profound arm weakness with much better leg power.",
  presentingComplaint: 'Spinal Injury',
  instructorBrief: {
    progression: "Hyperextension injury in a degenerate canal. Disproportionate upper limb weakness is the hallmark. Often occurs without fracture, so plain imaging can be falsely reassuring.",
    interventions: ["Spinal immobilisation", "MRI cervical spine", "Maintain MAP", "Spinal surgery referral"],
    learningObjectives: ["Recognise incomplete cord syndromes", "Understand why CT alone may miss cord injury", "Maintain spinal cord perfusion pressure"]
  },
  vitalsMod: {
    hr: 76,
    bpSys: 108,
    spO2: 96,
    rr: 20,
    gcs: 15
  },
  deterioration: {
    active: true,
    rate: 0.05,
    type: 'neuro'
  },
  ecg: {
    type: "Sinus Rhythm",
    findings: "Normal sinus rhythm"
  },
  stabilisers: ['Collar'],
  recommendedActions: ['Obs', 'Collar', 'IV Access', 'Oxygen', 'Analgesia', 'Metaraminol', 'Catheter', 'ArtLine']
}, {
  id: 'AT030',
  title: 'Globe Rupture',
  category: 'Trauma',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(20, 55);
  },
  patientProfileTemplate: "A {age}-year-old {sex}. Struck in the eye by a metal fragment while grinding without goggles. Severe pain and loss of vision.",
  presentingComplaint: 'Eye Injury',
  instructorBrief: {
    progression: "Teardrop pupil and a positive Seidel test. Do not measure intraocular pressure or instil pressure. Shield the eye, give antiemetics and analgesia and refer for urgent ophthalmic surgery.",
    interventions: ["Rigid eye shield", "Antiemetics", "Antibiotics", "Urgent ophthalmology"],
    learningObjectives: ["Recognise open globe injury", "Avoid manoeuvres that raise intraocular pressure", "Arrange emergency ophthalmic referral"]
  },
  vitalsMod: {
    hr: 96,
    bpSys: 142,
    spO2: 98,
    rr: 20
  },
  deterioration: {
    active: false,
    rate: 0.02,
    type: 'neuro'
  },
  ecg: {
    type: "Sinus Rhythm",
    findings: "Normal sinus rhythm"
  },
  recommendedActions: ['Obs', 'IV Access', 'Analgesia', 'Fentanyl', 'Antiemetic', 'Cyclizine', 'Ceftriaxone', 'Surgery']
}, {
  id: 'AT031',
  title: 'Lightning Strike',
  category: 'Trauma',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(18, 50);
  },
  patientProfileTemplate: "A {age}-year-old {sex}. Struck by lightning on a golf course. Feathering skin marks, confused, both legs numb and pulseless.",
  presentingComplaint: 'Electrical Injury',
  instructorBrief: {
    progression: "Keraunoparalysis usually resolves. The real risk is immediate asystolic arrest and apnoea from medullary stunning, so reverse triage applies: treat the apparently dead first.",
    interventions: ["Prolonged ventilation", "Cardiac monitoring", "Reverse triage in multiple casualties"],
    learningObjectives: ["Apply reverse triage in lightning strike", "Recognise keraunoparalysis as transient", "Monitor for arrhythmia and rhabdomyolysis"]
  },
  vitalsMod: {
    hr: 58,
    bpSys: 96,
    spO2: 93,
    rr: 10,
    gcs: 12
  },
  deterioration: {
    active: true,
    rate: 0.1,
    type: 'cardiac'
  },
  ecg: {
    type: "Sinus Bradycardia",
    findings: "Sinus bradycardia with prolonged QT"
  },
  stabilisers: ['Bagging', 'Fluids'],
  recommendedActions: ['Obs', 'Oxygen', 'Bagging', 'IV Access', 'Fluids', 'Defib', 'Pacing', 'Analgesia', 'Catheter']
}, {
  id: 'AT032',
  title: 'High-Pressure Injection Injury',
  category: 'Trauma',
  ageRange: 'Adult',
  acuity: 'Majors',
  ageGenerator: function ageGenerator() {
    return getRandomInt(20, 55);
  },
  patientProfileTemplate: "A {age}-year-old {sex} painter. Paint gun discharged into the left index finger. Only a pinprick mark visible but the finger is tense and throbbing.",
  presentingComplaint: 'Hand Injury',
  instructorBrief: {
    progression: "A deceptively trivial-looking wound with a high amputation rate. Solvent causes chemical necrosis along tendon sheaths. Needs urgent surgical debridement, not a dressing and discharge.",
    interventions: ["Urgent hand surgery", "Antibiotics", "Analgesia", "Do not perform digital block"],
    learningObjectives: ["Recognise the severity of injection injuries", "Avoid falsely reassuring discharge", "Refer urgently to hand surgery"]
  },
  vitalsMod: {
    hr: 98,
    bpSys: 138,
    spO2: 98,
    rr: 18
  },
  deterioration: {
    active: true,
    rate: 0.02,
    type: 'shock'
  },
  ecg: {
    type: "Sinus Rhythm",
    findings: "Normal sinus rhythm"
  },
  recommendedActions: ['Obs', 'IV Access', 'Analgesia', 'Fentanyl', 'Tazocin', 'Splinting', 'Surgery']
},
// --- PAEDIATRIC TRAUMA ---
{
  id: 'PT003',
  title: 'Paediatric Pedestrian RTC',
  category: 'Trauma',
  ageRange: 'Paediatric',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(5, 11);
  },
  patientProfileTemplate: "A {age}-year-old {sex}. Struck by a car at 30mph while crossing to school. Thrown several metres.",
  presentingComplaint: 'Polytrauma',
  instructorBrief: {
    progression: "Waddell triad of head, chest and femoral injuries. Children compensate then crash. Use weight-based blood volumes at 10ml/kg and keep them warm.",
    interventions: ["Blood 10ml/kg", "TXA", "Splinting", "Major trauma centre"],
    learningObjectives: ["Apply paediatric trauma resuscitation by weight", "Recognise the Waddell triad", "Prevent hypothermia in injured children"]
  },
  vitalsMod: {
    hr: 168,
    bpSys: 76,
    spO2: 91,
    rr: 40,
    gcs: 11,
    temp: 35.4
  },
  deterioration: {
    active: true,
    rate: 0.15,
    type: 'shock'
  },
  ecg: {
    type: "Sinus Tachycardia",
    findings: "Sinus tachycardia"
  },
  vbgClinicalState: "haemorrhagic_shock",
  stabilisers: ['Blood', 'TXA', 'Warming'],
  recommendedActions: ['Obs', 'IV Access', 'Oxygen', 'Blood', 'TXA', 'Collar', 'Splinting', 'Warming', 'RSI', 'PelvicBinder']
}, {
  id: 'PT004',
  title: 'Paediatric Drowning',
  category: 'Trauma',
  ageRange: 'Paediatric',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(2, 6);
  },
  patientProfileTemplate: "A {age}-year-old {sex}. Found face down in a garden pond, unknown submersion time. Bystander CPR started.",
  presentingComplaint: 'Drowning',
  instructorBrief: {
    progression: "Hypoxic cardiac arrest. Five rescue breaths first, then 15:2. Prolonged resuscitation is justified in cold water drowning. Consider safeguarding and supervision issues in the debrief.",
    interventions: ["Five rescue breaths", "15:2 CPR", "Rewarming", "Safeguarding review"],
    learningObjectives: ["Apply the paediatric drowning algorithm", "Justify prolonged resuscitation in hypothermia", "Consider safeguarding in childhood drowning"]
  },
  vitalsMod: {
    hr: 42,
    bpSys: 54,
    bpDia: 32,
    spO2: 68,
    rr: 6,
    temp: 31.8,
    gcs: 3
  },
  deterioration: {
    active: true,
    rate: 0.15,
    type: 'respiratory'
  },
  ecg: {
    type: "Sinus Bradycardia",
    findings: "Profound bradycardia with J waves"
  },
  vbgClinicalState: "hypothermia",
  stabilisers: ['Bagging', 'Warming'],
  recommendedActions: ['Obs', 'Oxygen', 'Bagging', 'CPR', 'IV Access', 'Warming', 'AdrenalineIV', 'RSI', 'Suction']
}, {
  id: 'PT005',
  title: 'Handlebar Abdominal Injury',
  category: 'Trauma',
  ageRange: 'Paediatric',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(8, 14);
  },
  patientProfileTemplate: "A {age}-year-old {sex}. Fell onto bicycle handlebars two hours ago. Bruise over the epigastrium, worsening pain and vomiting.",
  presentingComplaint: 'Abdominal Trauma',
  instructorBrief: {
    progression: "Pancreatic and duodenal injury from a focal epigastric blow. FAST is often negative in hollow viscus injury, so a normal scan does not exclude it. Serial examination and CT are needed.",
    interventions: ["Serial examination", "CT abdomen", "Amylase", "Surgical referral"],
    learningObjectives: ["Appreciate the limits of FAST in children", "Recognise the handlebar injury pattern", "Consider NAI where the mechanism does not fit"]
  },
  vitalsMod: {
    hr: 138,
    bpSys: 96,
    spO2: 97,
    rr: 30,
    temp: 37.2
  },
  deterioration: {
    active: true,
    rate: 0.09,
    type: 'shock'
  },
  ecg: {
    type: "Sinus Tachycardia",
    findings: "Sinus tachycardia"
  },
  stabilisers: ['Fluids'],
  recommendedActions: ['Obs', 'IV Access', 'Fluids', 'Analgesia', 'Fentanyl', 'Antiemetic', 'NGTube', 'Blood', 'Surgery']
}, {
  id: 'PT006',
  title: 'Adolescent Stabbing',
  category: 'Trauma',
  ageRange: 'Paediatric',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(14, 15);
  },
  patientProfileTemplate: "A {age}-year-old {sex}. Stabbed in the left flank outside a youth club. Police escort, refusing to name the assailant.",
  presentingComplaint: 'Penetrating Trauma',
  instructorBrief: {
    progression: "Retroperitoneal and renal injury with progressive shock. Alongside resuscitation, address child protection, forensic evidence preservation and youth violence referral.",
    interventions: ["Blood", "TXA", "Surgery", "Safeguarding referral"],
    learningObjectives: ["Resuscitate penetrating trauma in adolescents", "Preserve forensic evidence", "Fulfil safeguarding duties in youth violence"]
  },
  vitalsMod: {
    hr: 142,
    bpSys: 84,
    spO2: 96,
    rr: 30,
    gcs: 14
  },
  deterioration: {
    active: true,
    rate: 0.14,
    type: 'shock'
  },
  ecg: {
    type: "Sinus Tachycardia",
    findings: "Sinus tachycardia"
  },
  vbgClinicalState: "haemorrhagic_shock",
  stabilisers: ['Blood', 'TXA'],
  recommendedActions: ['Obs', 'IV Access', 'Oxygen', 'Blood', 'TXA', 'Analgesia', 'Fentanyl', 'Catheter', 'Surgery']
}, {
  id: 'PT007',
  title: 'Paediatric Flame Burn',
  category: 'Trauma',
  ageRange: 'Paediatric',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(3, 9);
  },
  patientProfileTemplate: "A {age}-year-old {sex}. Clothing caught fire at a bonfire. 20 percent body surface burns to the chest and arms, and hoarse voice.",
  presentingComplaint: 'Burns',
  instructorBrief: {
    progression: "Children have a proportionally larger head and lose heat fast. Use a Lund and Browder chart, not the rule of nines. Parkland fluids are in addition to maintenance. Early airway assessment.",
    interventions: ["Lund and Browder assessment", "Parkland plus maintenance fluids", "Analgesia", "Burns centre"],
    learningObjectives: ["Estimate paediatric burn area accurately", "Calculate paediatric burns fluids including maintenance", "Anticipate airway compromise and hypothermia"]
  },
  vitalsMod: {
    hr: 158,
    bpSys: 92,
    spO2: 93,
    rr: 36,
    temp: 35.8
  },
  deterioration: {
    active: true,
    rate: 0.13,
    type: 'airway'
  },
  ecg: {
    type: "Sinus Tachycardia",
    findings: "Sinus tachycardia"
  },
  stabilisers: ['Fluids', 'RSI', 'Warming'],
  recommendedActions: ['Obs', 'Oxygen', 'IV Access', 'Fluids', 'Fentanyl', 'Ketamine', 'RSI', 'ClingFilm', 'Warming', 'Catheter']
},
// --- GERIATRIC TRAUMA ---
{
  id: 'ET001',
  title: 'Silver Trauma (Low Fall)',
  category: 'Trauma',
  ageRange: 'Elderly',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(78, 94);
  },
  patientProfileTemplate: "A {age}-year-old {sex} on bisoprolol. Fell down four stairs at home. Looks comfortable, observations look normal.",
  presentingComplaint: 'Fall',
  instructorBrief: {
    progression: "Occult multi-system injury. Beta blockade prevents a compensatory tachycardia and the baseline hypertension makes 110 systolic a shock state. Standard trauma triage tools under-triage older patients.",
    interventions: ["Whole body CT", "Low threshold for major trauma call", "Reverse anticoagulation"],
    learningObjectives: ["Recognise under-triage of silver trauma", "Interpret vitals in beta-blocked hypertensive patients", "Lower the threshold for whole body CT"]
  },
  vitalsMod: {
    hr: 72,
    bpSys: 110,
    spO2: 94,
    rr: 22,
    gcs: 15
  },
  deterioration: {
    active: true,
    rate: 0.1,
    type: 'shock'
  },
  ecg: {
    type: "Sinus Rhythm",
    findings: "Sinus rhythm, rate limited by beta blockade"
  },
  vbgClinicalState: "haemorrhagic_shock",
  stabilisers: ['Blood', 'Octaplex'],
  recommendedActions: ['Obs', 'IV Access', 'Oxygen', 'Blood', 'TXA', 'Octaplex', 'Analgesia', 'Fentanyl', 'PelvicBinder', 'Catheter']
}, {
  id: 'ET002',
  title: 'Elderly Multiple Rib Fractures',
  category: 'Trauma',
  ageRange: 'Elderly',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(72, 90);
  },
  patientProfileTemplate: "A {age}-year-old {sex}. Fell against a kitchen worktop yesterday. Six rib fractures on CT and cannot take a deep breath.",
  presentingComplaint: 'Chest Trauma',
  instructorBrief: {
    progression: "Mortality rises with each additional fractured rib in the elderly. Pain causes splinting, atelectasis and pneumonia. Regional analgesia and chest physiotherapy change outcomes more than admission alone.",
    interventions: ["Serratus anterior or erector spinae block", "Multimodal analgesia", "Incentive spirometry", "NIV if needed"],
    learningObjectives: ["Recognise rib fractures as a high mortality injury in the elderly", "Deliver regional analgesia in chest trauma", "Prevent secondary pneumonia"]
  },
  vitalsMod: {
    hr: 104,
    bpSys: 138,
    spO2: 89,
    rr: 28,
    temp: 37.5
  },
  deterioration: {
    active: true,
    rate: 0.08,
    type: 'respiratory'
  },
  ecg: {
    type: "Sinus Tachycardia",
    findings: "Sinus tachycardia"
  },
  stabilisers: ['NerveBlock', 'Oxygen'],
  recommendedActions: ['Obs', 'Oxygen', 'IV Access', 'NerveBlock', 'Fentanyl', 'Analgesia', 'Paracetamol', 'NIV', 'SeldingerDrain']
}, {
  id: 'ET003',
  title: 'Head Injury on Anticoagulants',
  category: 'Trauma',
  ageRange: 'Elderly',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(75, 92);
  },
  patientProfileTemplate: "A {age}-year-old {sex} on warfarin for AF. Simple fall striking the head. Currently GCS 15 with a scalp haematoma.",
  presentingComplaint: 'Head Injury',
  instructorBrief: {
    progression: "CT within one hour by NICE criteria. A large acute subdural is found and GCS drops. Immediate reversal with prothrombin complex concentrate and vitamin K, and urgent neurosurgical referral.",
    interventions: ["CT head within 1 hour", "Octaplex and vitamin K", "Neurosurgical referral", "Neuroprotection"],
    learningObjectives: ["Apply NICE head injury imaging rules for anticoagulated patients", "Reverse warfarin rapidly and correctly", "Deliver neuroprotective care while awaiting transfer"]
  },
  vitalsMod: {
    hr: 68,
    bpSys: 168,
    bpDia: 92,
    spO2: 95,
    rr: 14,
    gcs: 14
  },
  deterioration: {
    active: true,
    rate: 0.13,
    type: 'neuro'
  },
  ecg: {
    type: "AF",
    findings: "Atrial fibrillation"
  },
  stabilisers: ['Octaplex', 'VitaminK'],
  recommendedActions: ['Obs', 'IV Access', 'Oxygen', 'Octaplex', 'VitaminK', 'RSI', 'HypertonicSaline', 'Mannitol', 'Analgesia', 'Collar']
},
// --- OBSTETRICS & GYNAECOLOGY ---
{
  id: 'OB014',
  title: 'Severe Pre-eclampsia',
  category: 'Obstetrics & Gynae',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(20, 40);
  },
  patientProfileTemplate: "A {age}-year-old woman at 34 weeks. Severe headache, visual flashes and epigastric pain. BP 178/112 with 3+ proteinuria.",
  presentingComplaint: 'Hypertension in Pregnancy',
  instructorBrief: {
    progression: "Imminent eclampsia. Control blood pressure with labetalol, give magnesium sulphate for seizure prophylaxis, and remember the only cure is delivery.",
    interventions: ["Labetalol", "MagSulph", "Strict fluid balance", "Obstetric team"],
    learningObjectives: ["Recognise severe features of pre-eclampsia", "Use magnesium for seizure prophylaxis", "Avoid fluid overload in pre-eclampsia"]
  },
  vitalsMod: {
    hr: 96,
    bpSys: 178,
    bpDia: 112,
    spO2: 97,
    rr: 20,
    gcs: 15
  },
  deterioration: {
    active: true,
    rate: 0.09,
    type: 'neuro'
  },
  ecg: {
    type: "Sinus Rhythm",
    findings: "Normal sinus rhythm"
  },
  stabilisers: ['MagSulph', 'Labetalol'],
  recommendedActions: ['Obs', 'IV Access', 'Labetalol', 'MagSulph', 'Catheter', 'Oxygen', 'Delivery']
}, {
  id: 'OB015',
  title: 'HELLP Syndrome',
  category: 'Obstetrics & Gynae',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(22, 40);
  },
  patientProfileTemplate: "A {age}-year-old woman at 36 weeks. Right upper quadrant pain, nausea and malaise. Platelets 38 and ALT 620.",
  presentingComplaint: 'Abdominal Pain in Pregnancy',
  instructorBrief: {
    progression: "Haemolysis, elevated liver enzymes and low platelets. Blood pressure may be only mildly raised, which misleads. Risk of hepatic capsule rupture and DIC. Needs delivery and blood products.",
    interventions: ["MagSulph", "Platelets and blood products", "Steroids for fetal lungs", "Urgent delivery"],
    learningObjectives: ["Recognise HELLP without marked hypertension", "Anticipate DIC and hepatic rupture", "Coordinate urgent multidisciplinary delivery"]
  },
  vitalsMod: {
    hr: 108,
    bpSys: 152,
    bpDia: 96,
    spO2: 96,
    rr: 22
  },
  deterioration: {
    active: true,
    rate: 0.1,
    type: 'shock'
  },
  ecg: {
    type: "Sinus Tachycardia",
    findings: "Sinus tachycardia"
  },
  stabilisers: ['MagSulph', 'Blood'],
  recommendedActions: ['Obs', 'IV Access', 'MagSulph', 'Labetalol', 'Blood', 'Dexamethasone', 'Catheter', 'Delivery']
}, {
  id: 'OB016',
  title: 'Maternal Sepsis (Chorioamnionitis)',
  category: 'Obstetrics & Gynae',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(20, 40);
  },
  patientProfileTemplate: "A {age}-year-old woman at 30 weeks. Membranes ruptured three days ago. Fever, offensive discharge and abdominal tenderness.",
  presentingComplaint: 'Sepsis in Pregnancy',
  instructorBrief: {
    progression: "Genital tract sepsis remains a leading cause of direct maternal death. Group A streptococcus can be fulminant. Physiological changes of pregnancy mask deterioration until collapse.",
    interventions: ["Broad spectrum antibiotics", "Fluids", "Urgent delivery for source control"],
    learningObjectives: ["Recognise sepsis masked by maternal physiology", "Prioritise antibiotics and source control", "Use the maternal early warning score"]
  },
  vitalsMod: {
    hr: 132,
    bpSys: 84,
    spO2: 95,
    rr: 30,
    temp: 39.4,
    gcs: 14
  },
  deterioration: {
    active: true,
    rate: 0.14,
    type: 'shock'
  },
  ecg: {
    type: "Sinus Tachycardia",
    findings: "Sinus tachycardia"
  },
  vbgClinicalState: "septic_shock",
  stabilisers: ['Tazocin', 'Fluids'],
  recommendedActions: ['Obs', 'IV Access', 'Oxygen', 'Tazocin', 'Gentamicin', 'Fluids', 'Paracetamol', 'Catheter', 'Noradrenaline', 'Delivery']
}, {
  id: 'OB017',
  title: 'Miscarriage with Haemorrhage',
  category: 'Obstetrics & Gynae',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(18, 40);
  },
  patientProfileTemplate: "A {age}-year-old woman at 10 weeks. Heavy vaginal bleeding, clots and cramping. Feeling faint and bradycardic.",
  presentingComplaint: 'PV Bleeding',
  instructorBrief: {
    progression: "Cervical shock from products of conception in the os. Removing them with sponge forceps reverses the vagal bradycardia dramatically. Anti-D is not needed at 10 weeks, even if RhD-negative (NICE NG126 2026: not needed up to 11+6 weeks).",
    interventions: ["Speculum and remove products", "Fluids", "No anti-D at 10 weeks (NICE NG126)", "Sensitive communication"],
    learningObjectives: ["Recognise and treat cervical shock", "Resuscitate early pregnancy haemorrhage", "Deliver compassionate care in pregnancy loss"]
  },
  vitalsMod: {
    hr: 48,
    bpSys: 82,
    spO2: 97,
    rr: 22,
    gcs: 14
  },
  deterioration: {
    active: true,
    rate: 0.11,
    type: 'shock'
  },
  ecg: {
    type: "Sinus Bradycardia",
    findings: "Vagally mediated sinus bradycardia"
  },
  vbgClinicalState: "haemorrhagic_shock",
  stabilisers: ['Fluids', 'Atropine'],
  recommendedActions: ['Obs', 'IV Access', 'Fluids', 'Blood', 'Atropine', 'Oxygen', 'Analgesia', 'Surgery']
}, {
  id: 'OB018',
  title: 'Ovarian Hyperstimulation Syndrome',
  category: 'Obstetrics & Gynae',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(25, 40);
  },
  patientProfileTemplate: "A {age}-year-old woman. Egg collection for IVF eight days ago. Abdominal distension, breathlessness and reduced urine output.",
  presentingComplaint: 'Abdominal Distension',
  instructorBrief: {
    progression: "Severe OHSS with third space loss, ascites and pleural effusions. Intravascularly deplete despite oedema, and profoundly prothrombotic. Needs albumin, thromboprophylaxis and possibly ascitic drainage.",
    interventions: ["Fluids and albumin", "Thromboprophylaxis", "Ascitic tap", "Fertility unit liaison"],
    learningObjectives: ["Recognise severe OHSS", "Understand intravascular depletion with oedema", "Prevent thromboembolism in OHSS"]
  },
  vitalsMod: {
    hr: 118,
    bpSys: 92,
    spO2: 92,
    rr: 28
  },
  deterioration: {
    active: true,
    rate: 0.08,
    type: 'shock'
  },
  ecg: {
    type: "Sinus Tachycardia",
    findings: "Sinus tachycardia"
  },
  stabilisers: ['Albumin', 'Fluids'],
  recommendedActions: ['Obs', 'IV Access', 'Oxygen', 'Fluids', 'Albumin', 'Heparin', 'AsciticTap', 'Analgesia', 'Catheter']
}, {
  id: 'OB019',
  title: 'Tubo-ovarian Abscess',
  category: 'Obstetrics & Gynae',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(18, 40);
  },
  patientProfileTemplate: "A {age}-year-old woman. Two weeks of pelvic pain and discharge, now rigors and severe adnexal tenderness.",
  presentingComplaint: 'Pelvic Pain',
  instructorBrief: {
    progression: "Complicated pelvic inflammatory disease with abscess and sepsis. Risk of rupture and peritonitis. Antibiotics plus drainage. Address sexual health screening and contact tracing sensitively.",
    interventions: ["Broad spectrum antibiotics", "Fluids", "Imaging and drainage", "Sexual health referral"],
    learningObjectives: ["Recognise complicated PID", "Arrange source control for pelvic abscess", "Address sexual health and safeguarding sensitively"]
  },
  vitalsMod: {
    hr: 124,
    bpSys: 90,
    spO2: 96,
    rr: 26,
    temp: 39.0
  },
  deterioration: {
    active: true,
    rate: 0.11,
    type: 'shock'
  },
  ecg: {
    type: "Sinus Tachycardia",
    findings: "Sinus tachycardia"
  },
  vbgClinicalState: "septic_shock",
  stabilisers: ['Tazocin', 'Fluids'],
  recommendedActions: ['Obs', 'IV Access', 'Oxygen', 'Tazocin', 'Gentamicin', 'Fluids', 'Analgesia', 'Antiemetic', 'Catheter', 'Surgery']
}, {
  id: 'OB020',
  title: 'Precipitate Delivery in ED',
  category: 'Obstetrics & Gynae',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(18, 40);
  },
  patientProfileTemplate: "A {age}-year-old woman at 39 weeks, unbooked. Arrives in the ambulance bay with an urge to push. Head is visible.",
  presentingComplaint: 'Imminent Delivery',
  instructorBrief: {
    progression: "Normal vertex delivery proceeding too fast to transfer. Control the head, check for cord around the neck, deliver, dry and warm the baby, and prepare for postpartum haemorrhage.",
    interventions: ["Controlled delivery", "Delayed cord clamping", "Oxytocin for third stage", "Newborn warming"],
    learningObjectives: ["Conduct a normal delivery in the ED", "Prepare simultaneously for two patients", "Anticipate and prevent postpartum haemorrhage"]
  },
  vitalsMod: {
    hr: 112,
    bpSys: 132,
    spO2: 98,
    rr: 24
  },
  deterioration: {
    active: true,
    rate: 0.06,
    type: 'shock'
  },
  ecg: {
    type: "Sinus Tachycardia",
    findings: "Sinus tachycardia"
  },
  stabilisers: ['Delivery', 'Oxytocin'],
  recommendedActions: ['Obs', 'IV Access', 'Delivery', 'Oxytocin', 'Warming', 'Fluids', 'Analgesia', 'Bagging']
}, {
  id: 'OB021',
  title: 'Pulmonary Embolism in Pregnancy',
  category: 'Obstetrics & Gynae',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(22, 40);
  },
  patientProfileTemplate: "A {age}-year-old woman at 28 weeks. Sudden pleuritic chest pain and breathlessness after a long-haul flight.",
  presentingComplaint: 'Breathlessness in Pregnancy',
  instructorBrief: {
    progression: "Pregnancy is prothrombotic and D-dimer and Wells scores are not validated. Treatment dose low molecular weight heparin should not wait for imaging. Discuss CTPA versus VQ radiation risk honestly.",
    interventions: ["Treatment dose LMWH", "Imaging discussion", "Left lateral tilt", "Obstetric and haematology input"],
    learningObjectives: ["Recognise why standard PE rules fail in pregnancy", "Anticoagulate empirically when suspicion is high", "Counsel on imaging radiation risk"]
  },
  vitalsMod: {
    hr: 126,
    bpSys: 96,
    spO2: 89,
    rr: 32
  },
  deterioration: {
    active: true,
    rate: 0.11,
    type: 'respiratory'
  },
  ecg: {
    type: "Sinus Tachycardia",
    findings: "Sinus tachycardia with right heart strain"
  },
  stabilisers: ['Heparin', 'Oxygen'],
  recommendedActions: ['Obs', 'IV Access', 'Oxygen', 'Heparin', 'Fluids', 'Analgesia', 'Thrombolysis']
},
// --- TOXICOLOGY ---
{
  id: 'TX013',
  title: 'Benzodiazepine Overdose',
  category: 'Toxicology',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(20, 55);
  },
  patientProfileTemplate: "A {age}-year-old {sex}. Empty diazepam packets found. Deeply drowsy with shallow breathing.",
  presentingComplaint: 'Overdose',
  instructorBrief: {
    progression: "Respiratory depression is the problem, and supportive airway management is the treatment. Flumazenil risks precipitating seizures in mixed or chronic users and is rarely appropriate.",
    interventions: ["Airway support", "Ventilation", "Avoid routine flumazenil", "Mental health assessment"],
    learningObjectives: ["Manage sedative overdose supportively", "Understand the hazards of flumazenil", "Screen for co-ingestants"]
  },
  vitalsMod: {
    hr: 62,
    bpSys: 96,
    spO2: 88,
    rr: 8,
    gcs: 8,
    etco2: 7.5
  },
  deterioration: {
    active: true,
    rate: 0.09,
    type: 'respiratory'
  },
  ecg: {
    type: "Sinus Bradycardia",
    findings: "Sinus bradycardia"
  },
  vbgClinicalState: "respiratory_acidosis_acute",
  stabilisers: ['Bagging', 'OPA'],
  recommendedActions: ['Obs', 'Manoeuvres', 'OPA', 'Oxygen', 'Bagging', 'IV Access', 'RSI', 'Fluids', 'ToggleETCO2']
}, {
  id: 'TX014',
  title: 'GHB Overdose',
  category: 'Toxicology',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(18, 40);
  },
  patientProfileTemplate: "A {age}-year-old {sex}. Collapsed at a nightclub. Deeply unresponsive with intermittent violent agitation when stimulated.",
  presentingComplaint: 'Reduced GCS',
  instructorBrief: {
    progression: "Classic GHB pattern of deep coma with abrupt agitated awakening. TOXBASE: effects usually resolve within 24 hours (longest reported 96 h); observe at least 4 h; supportive care and airway vigilance; atropine for symptomatic bradycardia; watch for withdrawal (agitation, hallucinations, tachycardia) in regular users. Consider spiked drinks and safeguarding.",
    interventions: ["Airway support", "Left lateral position", "Observation", "Safeguarding"],
    learningObjectives: ["Recognise the GHB coma and agitation cycle", "Avoid unnecessary intubation where recovery is rapid", "Consider drink spiking and sexual assault"]
  },
  vitalsMod: {
    hr: 54,
    bpSys: 104,
    spO2: 91,
    rr: 10,
    gcs: 6
  },
  deterioration: {
    active: true,
    rate: 0.08,
    type: 'airway'
  },
  ecg: {
    type: "Sinus Bradycardia",
    findings: "Sinus bradycardia"
  },
  stabilisers: ['Manoeuvres', 'Oxygen'],
  recommendedActions: ['Obs', 'Manoeuvres', 'NPA', 'Oxygen', 'Bagging', 'IV Access', 'RSI', 'Suction', 'Dextrose']
}, {
  id: 'TX015',
  title: 'Citalopram Overdose (QT)',
  category: 'Toxicology',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(18, 50);
  },
  patientProfileTemplate: "A {age}-year-old {sex}. Took 40 citalopram tablets four hours ago. Nauseated and tremulous. QTc is 560ms.",
  presentingComplaint: 'Overdose',
  instructorBrief: {
    progression: "Dose-dependent QT prolongation with risk of torsades; the QT effect peaks about 8 hours after ingestion. TOXBASE: keep potassium, magnesium and calcium high-normal; IV magnesium 2 g for AV block, severe bradycardia or pauses (it treats torsades but does not shorten the QT); avoid other QT-prolonging drugs; charcoal only within 1 hour; monitor for at least 12 hours and repeat the ECG before discharge. Check glucose (hypoglycaemia can precede seizures).",
    interventions: ["Serial ECGs", "MagSulph", "Correct electrolytes", "Cardiac monitoring"],
    learningObjectives: ["Measure and interpret QTc after overdose", "Prevent and treat torsades de pointes", "Determine safe monitoring duration"]
  },
  vitalsMod: {
    hr: 104,
    bpSys: 118,
    spO2: 97,
    rr: 20,
    gcs: 15
  },
  deterioration: {
    active: true,
    rate: 0.08,
    type: 'cardiac'
  },
  ecg: {
    type: "Sinus Tachycardia",
    findings: "Sinus tachycardia with QTc 560ms"
  },
  stabilisers: ['MagSulph'],
  recommendedActions: ['Obs', 'IV Access', 'MagSulph', 'Fluids', 'Defib', 'Antiemetic', 'Pacing']
}, {
  id: 'TX016',
  title: 'Metformin Lactic Acidosis',
  category: 'Toxicology',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(50, 64);
  },
  patientProfileTemplate: "A {age}-year-old {sex} on metformin. Two days of diarrhoea, now Kussmaul breathing and profoundly unwell. Lactate 14, pH 6.98.",
  presentingComplaint: 'Metabolic Acidosis',
  instructorBrief: {
    progression: "Metformin-associated lactic acidosis precipitated by acute kidney injury. Mortality is high. Fluids and bicarbonate temporise but haemodialysis is the definitive treatment as it clears metformin and corrects acidosis. TOXBASE: dialyse for lactate above 15 mmol/L or pH below 7.1 despite fluids and bicarbonate, sooner with kidney injury, shock or reduced consciousness; continue until lactate below 3 and pH above 7.35.",
    interventions: ["Fluids", "SodiumBicarb", "Urgent renal referral for dialysis"],
    learningObjectives: ["Recognise metformin associated lactic acidosis", "Understand sick day rules for metformin", "Escalate for extracorporeal removal"]
  },
  vitalsMod: {
    hr: 118,
    bpSys: 86,
    spO2: 96,
    rr: 38,
    temp: 35.9,
    gcs: 13,
    bm: 4.2
  },
  deterioration: {
    active: true,
    rate: 0.13,
    type: 'shock'
  },
  ecg: {
    type: "Sinus Tachycardia",
    findings: "Sinus tachycardia"
  },
  vbgClinicalState: "metabolic_acidosis_severe",
  stabilisers: ['Fluids', 'SodiumBicarb'],
  recommendedActions: ['Obs', 'IV Access', 'Oxygen', 'Fluids', 'SodiumBicarb', 'Noradrenaline', 'Catheter', 'CVC']
}, {
  id: 'TX017',
  title: 'Sulfonylurea Ingestion (Toddler)',
  category: 'Toxicology',
  ageRange: 'Paediatric',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(1, 4);
  },
  patientProfileTemplate: "A {age}-year-old {sex}. Found with grandmother's gliclazide packet. Now drowsy and sweaty.",
  presentingComplaint: 'Ingestion',
  instructorBrief: {
    progression: "One tablet can kill a toddler. Hypoglycaemia is profound and recurrent, so a single dextrose bolus is not enough. TOXBASE: 2 mL/kg 10% glucose then a glucose infusion, checking every 5 minutes until above 4 mmol/L; if hypoglycaemia persists despite enough glucose, octreotide 1-1.5 micrograms/kg IV or SC, repeated 6-hourly. Charcoal only within 1 hour and only if the airway is safe (not in this drowsy child). Stay until glucose has been normal for at least 6 hours off supplementary glucose and at least 24 hours after octreotide.",
    interventions: ["Dextrose", "Repeated glucose checks", "Octreotide", "24 hour admission"],
    learningObjectives: ["Recognise one-pill-can-kill toxins in children", "Treat recurrent sulfonylurea hypoglycaemia", "Explore accidental ingestion and safeguarding"]
  },
  vitalsMod: {
    hr: 156,
    bpSys: 88,
    spO2: 98,
    rr: 30,
    gcs: 12,
    bm: 1.4
  },
  deterioration: {
    active: true,
    rate: 0.1,
    type: 'neuro'
  },
  ecg: {
    type: "Sinus Tachycardia",
    findings: "Sinus tachycardia"
  },
  stabilisers: ['Dextrose'],
  recommendedActions: ['Obs', 'IV Access', 'Dextrose', 'Fluids', 'Oxygen']
}, {
  id: 'TX018',
  title: 'Caustic Ingestion (Toddler)',
  category: 'Toxicology',
  ageRange: 'Paediatric',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(1, 4);
  },
  patientProfileTemplate: "A {age}-year-old {sex}. Drank from a decanted drain cleaner bottle. Drooling, refusing to swallow, hoarse cry.",
  presentingComplaint: 'Ingestion',
  instructorBrief: {
    progression: "Alkali causes liquefactive necrosis. Do not induce vomiting, do not give charcoal, do not attempt lavage or neutralisation. The airway may obstruct from oedema: TOXBASE advises a low threshold for securing the airway in children. Drooling, dysphagia and a hoarse cry mean urgent CT and/or endoscopy; erect chest X-ray; IV opioid analgesia. No oral dilution while she cannot swallow.",
    interventions: ["Nil by mouth", "Airway assessment", "No charcoal or emetics", "Early endoscopy"],
    learningObjectives: ["Manage caustic ingestion correctly", "Recognise contraindicated decontamination steps", "Anticipate airway oedema and later stricture"]
  },
  vitalsMod: {
    hr: 162,
    bpSys: 92,
    spO2: 94,
    rr: 36,
    temp: 37.4
  },
  deterioration: {
    active: true,
    rate: 0.12,
    type: 'airway'
  },
  ecg: {
    type: "Sinus Tachycardia",
    findings: "Sinus tachycardia"
  },
  stabilisers: ['Oxygen', 'RSI'],
  recommendedActions: ['Obs', 'Oxygen', 'IV Access', 'Fluids', 'Fentanyl', 'RSI', 'FONA', 'Suction']
}, {
  id: 'TX019',
  title: 'Adolescent Alcohol Intoxication',
  category: 'Toxicology',
  ageRange: 'Paediatric',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(13, 15);
  },
  patientProfileTemplate: "A {age}-year-old {sex}. Found unresponsive in a park after drinking spirits. Vomited, smells of alcohol, GCS 9.",
  presentingComplaint: 'Reduced GCS',
  instructorBrief: {
    progression: "Children develop hypoglycaemia with alcohol far more readily than adults. Do not attribute reduced GCS to alcohol alone: check glucose, exclude head injury and co-ingestion, and refer to safeguarding.",
    interventions: ["Check glucose", "Airway protection", "Exclude head injury", "Safeguarding referral"],
    learningObjectives: ["Recognise alcohol-induced hypoglycaemia in children", "Avoid anchoring on intoxication", "Fulfil safeguarding duties for intoxicated minors"]
  },
  vitalsMod: {
    hr: 118,
    bpSys: 98,
    spO2: 93,
    rr: 14,
    temp: 35.4,
    gcs: 9,
    bm: 2.4
  },
  deterioration: {
    active: true,
    rate: 0.09,
    type: 'neuro'
  },
  ecg: {
    type: "Sinus Tachycardia",
    findings: "Sinus tachycardia"
  },
  stabilisers: ['Dextrose', 'Warming'],
  recommendedActions: ['Obs', 'Manoeuvres', 'Oxygen', 'IV Access', 'Dextrose', 'Fluids', 'Warming', 'Suction', 'Pabrinex']
}, {
  id: 'TX020',
  title: 'Warfarin Over-anticoagulation',
  category: 'Toxicology',
  ageRange: 'Elderly',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(72, 92);
  },
  patientProfileTemplate: "A {age}-year-old {sex} on warfarin, recently started clarithromycin. Extensive spontaneous bruising and haematuria. INR is 9.2.",
  presentingComplaint: 'Bleeding',
  instructorBrief: {
    progression: "Drug interaction potentiating warfarin. Management depends on whether bleeding is major: vitamin K alone for non-major, prothrombin complex concentrate for major bleeding. Fresh frozen plasma is not the correct reversal agent.",
    interventions: ["VitaminK", "Octaplex if major bleeding", "Stop interacting drug"],
    learningObjectives: ["Grade bleeding severity to guide reversal", "Choose PCC over FFP for warfarin reversal", "Recognise common warfarin drug interactions"]
  },
  vitalsMod: {
    hr: 102,
    bpSys: 108,
    spO2: 96,
    rr: 20
  },
  deterioration: {
    active: true,
    rate: 0.06,
    type: 'shock'
  },
  ecg: {
    type: "AF",
    findings: "Atrial fibrillation"
  },
  stabilisers: ['VitaminK', 'Octaplex'],
  recommendedActions: ['Obs', 'IV Access', 'VitaminK', 'Octaplex', 'Blood', 'Fluids', 'TXA', 'Catheter']
}, {
  id: 'TX021',
  title: 'Synthetic Cannabinoid Toxicity',
  category: 'Toxicology',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(18, 45);
  },
  patientProfileTemplate: "A {age}-year-old {sex}. Smoked 'spice'. Alternating between catatonic staring and violent agitation. Hyperthermic.",
  presentingComplaint: 'Agitation',
  instructorBrief: {
    progression: "Unpredictable potency compared with cannabis. Risk of seizures, hyperthermia and rhabdomyolysis. Verbal de-escalation first, then benzodiazepines. Physical restraint plus struggling worsens acidosis.",
    interventions: ["De-escalation", "Midazolam", "Active cooling", "Fluids for rhabdomyolysis"],
    learningObjectives: ["Manage acute agitation safely", "Recognise risks of prolonged restraint", "Treat hyperthermia and rhabdomyolysis"]
  },
  vitalsMod: {
    hr: 138,
    bpSys: 152,
    spO2: 96,
    rr: 28,
    temp: 39.6,
    gcs: 13
  },
  deterioration: {
    active: true,
    rate: 0.11,
    type: 'neuro'
  },
  ecg: {
    type: "Sinus Tachycardia",
    findings: "Sinus tachycardia"
  },
  vbgClinicalState: "metabolic_acidosis_severe",
  stabilisers: ['Midazolam', 'Cooling', 'Fluids'],
  recommendedActions: ['Obs', 'Midazolam', 'IV Access', 'Fluids', 'Cooling', 'Lorazepam', 'Oxygen', 'Catheter', 'SodiumBicarb']
}, {
  id: 'TX022',
  title: 'Methanol Poisoning',
  category: 'Toxicology',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(25, 60);
  },
  patientProfileTemplate: "A {age}-year-old {sex}. Drank illicitly distilled spirits last night. Now blurred vision described as a snowstorm, breathless and confused.",
  presentingComplaint: 'Poisoning',
  instructorBrief: {
    progression: "High anion gap and osmolar gap acidosis with visual failure from formic acid. Fomepizole (preferred) or ethanol blocks alcohol dehydrogenase, and haemodialysis removes methanol and formate. TOXBASE: visual disturbance, coma, seizures, severe acidosis or renal failure are indications for haemodialysis; give folinic acid 30 mg IV 6-hourly for 48 h; charcoal does not help. Blindness can be prevented by early treatment but is usually permanent once established.",
    interventions: ["Fomepizole", "SodiumBicarb", "Haemodialysis", "Ophthalmology review"],
    learningObjectives: ["Calculate and interpret the osmolar gap", "Treat toxic alcohol ingestion promptly", "Recognise visual loss as an indication for urgent dialysis"]
  },
  vitalsMod: {
    hr: 112,
    bpSys: 102,
    spO2: 96,
    rr: 34,
    gcs: 13
  },
  deterioration: {
    active: true,
    rate: 0.12,
    type: 'neuro'
  },
  ecg: {
    type: "Sinus Tachycardia",
    findings: "Sinus tachycardia"
  },
  vbgClinicalState: "metabolic_acidosis_severe",
  stabilisers: ['Fomepizole', 'SodiumBicarb'],
  recommendedActions: ['Obs', 'IV Access', 'Fomepizole', 'SodiumBicarb', 'Fluids', 'Pabrinex', 'RSI', 'Catheter']
},
// --- PSYCHIATRIC / MENTAL HEALTH ---
{
  id: 'PS004',
  title: 'Adolescent Self-Harm Crisis',
  category: 'Psychiatric',
  ageRange: 'Paediatric',
  acuity: 'Majors',
  ageGenerator: function ageGenerator() {
    return getRandomInt(13, 15);
  },
  patientProfileTemplate: "A {age}-year-old {sex}. Brought by a parent after deep forearm lacerations. Withdrawn, will not make eye contact, asks to be seen alone.",
  presentingComplaint: 'Self Harm',
  instructorBrief: {
    progression: "Physical injuries are manageable; the risk assessment is the scenario. Explore Gillick competence, confidentiality and its limits, safeguarding, and mandatory CAMHS assessment before discharge.",
    interventions: ["Wound care", "Risk assessment", "CAMHS referral", "Safeguarding"],
    learningObjectives: ["Assess suicide risk in adolescents", "Apply Gillick competence and confidentiality limits", "Arrange mandatory CAMHS assessment"]
  },
  vitalsMod: {
    hr: 96,
    bpSys: 112,
    spO2: 99,
    rr: 18,
    gcs: 15
  },
  deterioration: {
    active: false,
    rate: 0.01,
    type: 'neuro'
  },
  ecg: {
    type: "Sinus Rhythm",
    findings: "Normal sinus rhythm"
  },
  recommendedActions: ['Obs', 'IV Access', 'Analgesia', 'Paracetamol', 'Splinting']
}, {
  id: 'PS005',
  title: 'Severe Anorexia Nervosa',
  category: 'Psychiatric',
  ageRange: 'Paediatric',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(14, 15);
  },
  patientProfileTemplate: "A {age}-year-old {sex}. BMI 12.8, collapsed at school. Bradycardic, hypothermic and hypoglycaemic.",
  presentingComplaint: 'Collapse',
  instructorBrief: {
    progression: "Medical emergency in eating disorders. Bradycardia below 40, hypoglycaemia and hypophosphataemia mark high risk. Refeeding must be cautious and phosphate monitored to avoid refeeding syndrome.",
    interventions: ["Cautious glucose correction", "Electrolyte replacement", "Warming", "Specialist eating disorder unit"],
    learningObjectives: ["Apply MEED risk criteria", "Recognise and prevent refeeding syndrome", "Balance capacity, consent and compulsory treatment"]
  },
  vitalsMod: {
    hr: 36,
    bpSys: 78,
    bpDia: 48,
    spO2: 97,
    rr: 14,
    temp: 34.8,
    gcs: 14,
    bm: 2.1
  },
  deterioration: {
    active: true,
    rate: 0.1,
    type: 'cardiac'
  },
  ecg: {
    type: "Sinus Bradycardia",
    findings: "Marked sinus bradycardia with prolonged QTc"
  },
  stabilisers: ['Dextrose', 'Warming'],
  recommendedActions: ['Obs', 'IV Access', 'Dextrose', 'Fluids', 'Warming', 'Pabrinex', 'Calcium', 'Pacing', 'Atropine']
}, {
  id: 'PS006',
  title: 'Acute Behavioural Disturbance',
  category: 'Psychiatric',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(20, 45);
  },
  patientProfileTemplate: "A {age}-year-old {sex}. Brought in by police, extremely agitated, incoherent, sweating profusely and abnormally strong.",
  presentingComplaint: 'Agitation',
  instructorBrief: {
    progression: "A true medical emergency with a real mortality. Exclude hypoglycaemia, hypoxia and head injury. Prolonged struggle against restraint causes acidosis and sudden arrest. Avoid prone restraint and monitor continuously after sedation.",
    interventions: ["De-escalation", "Rapid tranquillisation", "Continuous monitoring", "Fluids and cooling"],
    learningObjectives: ["Recognise acute behavioural disturbance as a medical emergency", "Sedate safely and monitor afterwards", "Avoid prone restraint asphyxia"]
  },
  vitalsMod: {
    hr: 152,
    bpSys: 168,
    spO2: 94,
    rr: 34,
    temp: 39.8,
    gcs: 14
  },
  deterioration: {
    active: true,
    rate: 0.13,
    type: 'neuro'
  },
  ecg: {
    type: "Sinus Tachycardia",
    findings: "Sinus tachycardia"
  },
  vbgClinicalState: "metabolic_acidosis_severe",
  stabilisers: ['Midazolam', 'Fluids', 'Cooling'],
  recommendedActions: ['Obs', 'Midazolam', 'Ketamine', 'IV Access', 'Fluids', 'Cooling', 'Oxygen', 'SodiumBicarb', 'RSI']
}, {
  id: 'PS007',
  title: 'First Episode Psychosis',
  category: 'Psychiatric',
  ageRange: 'Adult',
  acuity: 'Majors',
  ageGenerator: function ageGenerator() {
    return getRandomInt(18, 30);
  },
  patientProfileTemplate: "A {age}-year-old {sex}. Three weeks of paranoid beliefs and auditory hallucinations. Brought by a housemate. No previous psychiatric history.",
  presentingComplaint: 'Psychosis',
  instructorBrief: {
    progression: "Organic causes must be excluded before labelling this psychiatric: consider encephalitis, drug-induced psychosis, thyroid disease and space-occupying lesion. Early intervention services improve long-term outcome.",
    interventions: ["Organic screen", "Collateral history", "Early intervention in psychosis referral"],
    learningObjectives: ["Exclude organic causes of new psychosis", "Take a structured collateral history", "Refer to early intervention services"]
  },
  vitalsMod: {
    hr: 98,
    bpSys: 128,
    spO2: 98,
    rr: 18,
    temp: 36.9,
    gcs: 15
  },
  deterioration: {
    active: false,
    rate: 0.02,
    type: 'neuro'
  },
  ecg: {
    type: "Sinus Rhythm",
    findings: "Normal sinus rhythm"
  },
  recommendedActions: ['Obs', 'IV Access', 'Lorazepam', 'Dextrose', 'LumbarPuncture']
}, {
  id: 'PS008',
  title: 'Ligature Self-Harm and Risk Assessment',
  category: 'Psychiatric',
  ageRange: 'Adult',
  acuity: 'Resus',
  ageGenerator: function ageGenerator() {
    return getRandomInt(20, 55);
  },
  patientProfileTemplate: "A {age}-year-old {sex}. Found with a ligature in a police cell, cut down quickly. Now alert but expressing continued intent to die.",
  presentingComplaint: 'Self Harm',
  instructorBrief: {
    progression: "Medically the neck examination and observation period matter, but the crux is the risk assessment and the decision about detention under the Mental Health Act when a patient with capacity refuses to stay.",
    interventions: ["Neck and airway assessment", "Structured risk assessment", "Mental Health Act consideration", "One-to-one observation"],
    learningObjectives: ["Perform a structured suicide risk assessment", "Apply capacity and Mental Health Act frameworks", "Arrange safe observation in the ED"]
  },
  vitalsMod: {
    hr: 104,
    bpSys: 138,
    spO2: 96,
    rr: 20,
    gcs: 15
  },
  deterioration: {
    active: true,
    rate: 0.03,
    type: 'airway'
  },
  ecg: {
    type: "Sinus Tachycardia",
    findings: "Sinus tachycardia"
  },
  recommendedActions: ['Obs', 'IV Access', 'Oxygen', 'Analgesia', 'Collar', 'Lorazepam']
}, {
  id: 'PS009',
  title: 'Acute Delirium (Elderly)',
  category: 'Psychiatric',
  ageRange: 'Elderly',
  acuity: 'Majors',
  ageGenerator: function ageGenerator() {
    return getRandomInt(78, 94);
  },
  patientProfileTemplate: "A {age}-year-old {sex} with mild dementia. Two days of fluctuating confusion, worse at night, seeing cats in the room.",
  presentingComplaint: 'Confusion',
  instructorBrief: {
    progression: "Hyperactive delirium from a urinary infection and constipation, compounded by an anticholinergic burden. Treat the cause. Sedation is a last resort and worsens outcomes.",
    interventions: ["Find and treat the cause", "Non-pharmacological measures", "Medication review", "Avoid routine sedation"],
    learningObjectives: ["Distinguish delirium from dementia", "Systematically search for precipitants", "Use non-pharmacological management first"]
  },
  vitalsMod: {
    hr: 96,
    bpSys: 132,
    spO2: 95,
    rr: 20,
    temp: 37.8,
    gcs: 14,
    bm: 6.2
  },
  deterioration: {
    active: true,
    rate: 0.03,
    type: 'neuro'
  },
  ecg: {
    type: "Sinus Rhythm",
    findings: "Sinus rhythm"
  },
  stabilisers: ['Fluids', 'Ceftriaxone'],
  recommendedActions: ['Obs', 'IV Access', 'Fluids', 'Ceftriaxone', 'Paracetamol', 'Catheter', 'Dextrose']
}, {
  id: 'PS010',
  title: 'Section 136 and Capacity Assessment',
  category: 'Psychiatric',
  ageRange: 'Adult',
  acuity: 'Majors',
  ageGenerator: function ageGenerator() {
    return getRandomInt(20, 50);
  },
  patientProfileTemplate: "A {age}-year-old {sex} brought in under Section 136 from a bridge. Now calm, articulate, and demanding to leave immediately.",
  presentingComplaint: 'Mental Health Crisis',
  instructorBrief: {
    progression: "The legal and ethical challenge is the scenario. Section 136 permits detention in a place of safety but does not authorise treatment. Assess capacity formally and know when common law or the Mental Capacity Act applies.",
    interventions: ["Capacity assessment", "Liaise with AMHP and police", "Place of safety", "Document reasoning"],
    learningObjectives: ["Understand the scope and limits of Section 136", "Perform and document a capacity assessment", "Distinguish the Mental Health Act from the Mental Capacity Act"]
  },
  vitalsMod: {
    hr: 88,
    bpSys: 126,
    spO2: 98,
    rr: 16,
    gcs: 15
  },
  deterioration: {
    active: false,
    rate: 0.01,
    type: 'neuro'
  },
  ecg: {
    type: "Sinus Rhythm",
    findings: "Normal sinus rhythm"
  },
  recommendedActions: ['Obs']
}];

// =================================================================================================
// LEARNING-OBJECTIVE COMPONENTS (authored, per scenario)
// -------------------------------------------------------------------------------------------------
// What has to be GIVEN or DONE for each learning objective to count as met in the debrief. The
// debrief used to infer this by keyword-matching the objective's wording against the scenario's
// recommended actions, which credited the wrong care (antihistamine and hydrocortisone "met"
// "Distinguish bradykinin angio-oedema from anaphylaxis"; dexamethasone and NIV "met" "Oxygen
// targets in COPD"). Every built-in objective is now authored here, by scenario id:
//
//   'Objective text, exactly as in the scenario': [['KeyA', 'KeyB'], ['KeyC']]
//
//   * each inner array is an OR-group of intervention keys (window.INTERVENTIONS): any one meets it;
//   * every group must be met for the objective to be met (fewer = "partly done");
//   * [] = not scorable from actions (recognition, judgement, communication, knowledge): the
//     facilitator ticks it in the debrief.
//
// Choices follow current UK guidance (RCUK ALS/PLS/NLS 2021, RCUK anaphylaxis 2021, APLS, NICE,
// BTS/SIGN, JBDS, RCEM, RCOG, DAS). Treatments that are wrong for the condition are never credited
// (e.g. antihistamine or steroid for bradykinin angio-oedema, high-flow oxygen for COPD targets,
// insulin for hypoglycaemia). A component that depends on how the scenario unfolds (amiodarone
// after the third shock; a hysterotomy only without ROSC) is not required, because the format cannot
// express "only if"; the facilitator judges those. scripts/check-objectives.mjs fails the build's
// test run if a built-in objective has no entry here or names an unknown intervention key.
// Custom (Builder) scenarios may carry their own `objectiveActions` in the same shape; an objective
// with no authored entry anywhere falls back to keyword inference.
// =================================================================================================
(function () {
  // Interchangeable treatments, named once so every scenario uses the same group.
  var CPR_ADULT = ['CPR', 'Lucas'];
  var ANAPHYLAXIS_ADRENALINE = ['AdrenalineIM', 'AdrenalineIVSmall', 'AdrenalinePush', 'AdrenalineInfusion'];
  var SEIZURE_BENZO = ['Lorazepam', 'MidazolamBuccal', 'MidazolamIN', 'MidazolamIM', 'Midazolam', 'DiazepamIV', 'DiazepamPR'];
  var SECOND_LINE_ANTISEIZURE = ['Levetiracetam', 'Phenytoin'];
  var SEPSIS_ANTIBIOTIC = ['Antibiotics', 'Tazocin', 'Ceftriaxone', 'Gentamicin'];
  var MENINGOCOCCAL_ANTIBIOTIC = ['Ceftriaxone', 'Benzylpenicillin', 'BenzylpenicillinIM'];
  var ABDOMINAL_ANTIBIOTIC = ['Tazocin', 'Antibiotics'];
  var NEBULISED_BRONCHODILATOR = ['Nebs', 'NebsContinuous'];
  var ASTHMA_STEROID = ['Hydrocortisone', 'Dexamethasone'];
  var CALCIUM = ['Calcium', 'CalciumChloride'];
  var POTASSIUM_SHIFT = ['InsulinDextrose'];
  var OPIOID = ['Analgesia', 'Fentanyl', 'MorphineIM', 'MorphineOral'];
  var PROCEDURAL_SEDATION = ['Propofol', 'Midazolam', 'Ketamine', 'Etomidate'];
  var AGITATION_SEDATION = ['Midazolam', 'MidazolamIM', 'Lorazepam', 'LorazepamIM', 'DiazepamIV', 'KetamineIM'];
  var VENTILATE = ['Bagging', 'i-gel', 'RSI'];
  var BP_LOWERING = ['Labetalol', 'LabetalolInfusion'];
  var MAGNESIUM_ECLAMPSIA = ['MagSulph', 'MagnesiumInfusion'];
  var VASOPRESSOR = ['Noradrenaline', 'Metaraminol'];
  var TENSION_DECOMPRESSION = ['Needle', 'FingerThoracostomy'];
  var CHEST_DRAIN = ['SeldingerDrain', 'SurgicalDrain'];
  var FLUIDS_ANY = ['Fluids', 'FluidInfusion'];
  var WARFARIN_REVERSAL = [['Octaplex'], ['VitaminK']];
  var HYPERKALAEMIA = [CALCIUM, POTASSIUM_SHIFT];
  window.SCENARIO_OBJECTIVE_ACTIONS = {
    // ---- ADULT MEDICAL ----------------------------------------------------------------------
    AM001: {
      // STEMI: aspirin, a P2Y12 inhibitor and reperfusion (PPCI, or lysis if PPCI is not timely)
      'Identify STEMI': [],
      'Manage ACS': [['Aspirin'], ['Ticagrelor', 'Clopidogrel'], ['PPCI', 'Thrombolysis']]
    },
    AM002: {
      // Septic shock, SpO2 88%: Sepsis Six actions that are buttons here
      'Sepsis 6': [['Oxygen'], SEPSIS_ANTIBIOTIC, ['Fluids']],
      'Fluid Resus': [['Fluids']]
    },
    AM003: {
      // Life-threatening asthma (BTS/SIGN): O2, nebulised bronchodilator, steroid, IV magnesium
      'Asthma Management': [['Oxygen'], NEBULISED_BRONCHODILATOR, ASTHMA_STEROID, ['MagSulph']]
    },
    AM004: {
      'Hyperkalaemia treatment': HYPERKALAEMIA
    },
    AM011: {
      // Hypertensive pulmonary oedema: nitrate + loop diuretic; CPAP for hypoxia
      'Manage acute heart failure': [['GTN', 'GTNInfusion'], ['Furosemide']],
      'CPAP Indications': [['CPAP', 'NIV']]
    },
    AM012: {
      // Controlled O2 (88-92%) is a judgement; "High Flow O2" is the WRONG button
      'Oxygen targets in COPD': [],
      'NIV indications': [['NIV']]
    },
    AM013: {
      // JBDS: fluids + fixed-rate IV insulin (not the hyperkalaemia insulin/dextrose bolus)
      'DKA Protocol': [FLUIDS_ANY, ['InsulinInfusion']],
      'Fluid management': [FLUIDS_ANY]
    },
    AM014: {
      'HHS vs DKA': [],
      'Osmolality': []
    },
    AM015: {
      'Massive PE recognition': [],
      'Thrombolysis indications': [['Thrombolysis']]
    },
    AM016: {
      // Terlipressin + prophylactic antibiotics; TXA is not credited (HALT-IT)
      'Major Haemorrhage Protocol': [['Blood']],
      'Variceal bleed management': [['Terlipressin'], ['Antibiotics', 'Ceftriaxone', 'Tazocin']]
    },
    AM017: {
      'Meningitis recognition': [],
      'Lumbar Puncture contraindications': [],
      'Give antibiotics within 1 hour': [['Ceftriaxone', 'Benzylpenicillin']]
    },
    AM018: {
      // Society for Endocrinology: hydrocortisone 100 mg + saline; glucose for the BM of 3.2
      'Adrenal crisis management': [['Hydrocortisone'], ['Fluids'], ['Dextrose']],
      'Steroid sick days': []
    },
    AM019: {
      'Thyroid storm recognition': [],
      'Burch-Wartofsky score': []
    },
    AM020: {
      'SAH presentation': [],
      "Cushing's Triad": []
    },
    AM021: {
      // Onset 1 h ago: a thrombolysis candidate once CT excludes a bleed
      'FAST positive': [],
      'Thrombolysis window': [['Thrombolysis']]
    },
    AM022: {
      // Refractory convulsive status, SpO2 88%: oxygen, benzodiazepine, then second-line drug
      'Status epilepticus algorithm': [['Oxygen', 'Bagging', 'RSI'], SEIZURE_BENZO, SECOND_LINE_ANTISEIZURE]
    },
    AM023: {
      // RCUK bradycardia: atropine, then interim measures (pacing, isoprenaline, adrenaline)
      'Bradycardia algorithm': [['Atropine'], ['Pacing', 'Isoprenaline', 'AdrenalineInfusion']],
      'Pacing indications': [['Pacing']]
    },
    AM024: {
      // Unstable VT: synchronised DC shock (amiodarone follows a failed third shock)
      'Tachycardia algorithm': [['Cardioversion']],
      'Safe cardioversion': [['Cardioversion'], PROCEDURAL_SEDATION]
    },
    AM025: {
      'Adenosine administration': [['Adenosine']],
      'ECG recognition': []
    },
    AM026: {
      // RCUK 2021: adrenaline (IM first) and a fluid bolus for shock; no antihistamine/steroid credit
      'Anaphylaxis algorithm': [ANAPHYLAXIS_ADRENALINE, ['Fluids']]
    },
    AM027: {
      // Anti-impulse therapy: beta-blockade first
      'Dissection recognition': [],
      'BP targets': [BP_LOWERING]
    },
    AM028: {
      // Symptomatic severe hyponatraemia: 3% saline bolus
      'Hyponatraemia correction': [['HypertonicSaline']],
      'Seizure management': []
    },
    AM029: {
      'Sepsis Source': [],
      "Charcot's Triad": []
    },
    AM030: {
      'CURB-65': [],
      'Oxygen therapy': [['Oxygen']]
    },
    AM031: {
      'Needle Thoracocentesis location': [TENSION_DECOMPRESSION],
      'Obstructive Shock signs': []
    },
    AM032: {
      // Passive rewarming: the "Active Warming" button is the caution, not the answer
      'Myxoedema recognition': [],
      'Warming caution': []
    },
    AM033: {
      'Hypercalcaemia management': [['Fluids'], ['Bisphosphonate']],
      'Fluid targets': [FLUIDS_ANY]
    },
    AM034: {
      'Oesophageal rupture signs': [],
      "Mackler's Triad": []
    },
    AM035: {
      'CO half-life': [],
      'SpO2 limitations': [],
      'Give high-flow oxygen': [['Oxygen', 'CPAP', 'NIV', 'Bagging', 'RSI']]
    },
    AM036: {
      'Serotonin toxicity criteria': [],
      'Cooling methods': [['Cooling']]
    },
    AM037: {
      'SLUDGE mnemonic': [],
      'Atropine dosing': [['Atropine']]
    },
    AM038: {
      'GBS recognition': [],
      'Respiratory monitoring': []
    },
    AM005: {
      // Sodium channel blockade: bicarbonate
      'TCA Toxicity': [['SodiumBicarb']],
      'ECG changes': []
    },
    AM006: {
      'Opioid Toxidrome': [],
      'Naloxone dosing': [['Naloxone', 'NaloxoneIM', 'NaloxoneIN']]
    },
    AM007: {
      'Paracetamol nomogram': [],
      'NAC indications': [['Acetylcysteine']]
    },
    AM008: {
      'CIWA scoring': [],
      'Safe sedation': [['Lorazepam', 'DiazepamIV']]
    },
    AM009: {
      // NICE NG10 rapid tranquillisation (IM lorazepam; no haloperidol button)
      'Rapid Tranq guidelines': [['LorazepamIM', 'Lorazepam', 'MidazolamIM']],
      'Mental Capacity Act': []
    },
    // ---- ADULT TRAUMA -----------------------------------------------------------------------
    AT001: {
      'Major Trauma Call': [],
      'Permissive Hypotension': []
    },
    AT002: {
      'Chest decompression': [['Needle', 'FingerThoracostomy', 'SeldingerDrain', 'SurgicalDrain']]
    },
    AT003: {
      // GCS 8, blown pupil, Cushing response: definitive airway + osmotherapy
      'Raised ICP management': [['RSI'], ['HypertonicSaline', 'Mannitol']],
      "Cushing's Triad": []
    },
    AT004: {
      'Burn airway assessment': [],
      'Fluid calculation': [FLUIDS_ANY]
    },
    AT005: {
      // Neurogenic shock: a pressor with beta activity suits the bradycardia
      'Neurogenic vs Spinal shock': [],
      'Vasopressor choice': [['Noradrenaline', 'Metaraminol', 'AdrenalineInfusion', 'Ephedrine']]
    },
    AT006: {
      'Flail chest mechanics': [],
      'Pain management importance': [['Analgesia', 'Fentanyl', 'NerveBlock', 'Ketamine']]
    },
    AT007: {
      'Neck trauma zones': [],
      'Hard vs Soft signs': []
    },
    AT008: {
      'Crush syndrome physiology': [],
      'Hyperkalaemia management': HYPERKALAEMIA
    },
    // ---- ELDERLY ----------------------------------------------------------------------------
    EL001: {
      // NICE CG124 / AAGBI: nerve block plus systemic analgesia
      'NOF management': [['NerveBlock'], ['Analgesia', 'Fentanyl', 'Paracetamol', 'ParacetamolOral', 'MorphineIM', 'MorphineOral']],
      'Frailty assessment': []
    },
    EL002: {
      'Sepsis in elderly': [SEPSIS_ANTIBIOTIC, ['Fluids']],
      'Delirium': []
    },
    EL003: {
      'Head injury in elderly': [],
      'Anticoagulation reversal': WARFARIN_REVERSAL
    },
    EL004: {
      'AAA presentation': [],
      'Hypotension targets': []
    },
    EL005: {
      'Swiss staging': [],
      'Resus modification': [],
      'Rewarm actively': [['Warming']]
    },
    // ---- PAEDIATRIC MEDICAL -----------------------------------------------------------------
    PA001: {
      // Meningococcal sepsis: ceftriaxone (benzylpenicillin pre-hospital), fluid bolus; IV/IO access
      'Paeds Sepsis': [MENINGOCOCCAL_ANTIBIOTIC, ['Fluids']],
      'IO Access': [['IV Access']]
    },
    PA002: {
      'Croup scoring': [],
      'Neb Adrenaline indications': [['NebAdrenaline']]
    },
    PA003: {
      // APLS: airway/oxygen, benzodiazepine (second-line only if it continues)
      'APLS Seizure Algorithm': [['Oxygen', 'Bagging', 'RSI'], SEIZURE_BENZO]
    },
    PA004: {
      'Paeds Anaphylaxis': [ANAPHYLAXIS_ADRENALINE, ['Fluids']]
    },
    PA005: {
      'Bronchiolitis escalation': [['CPAP', 'NIV']]
    },
    PA006: {
      'Paeds DKA Fluids': [FLUIDS_ANY],
      'Cerebral Oedema': []
    },
    PA007: {
      'Paeds SVT management': [['VagalManoeuvre', 'Adenosine', 'Cardioversion']]
    },
    PA008: {
      'Intussusception diagnosis': [],
      'Fluid resus': [['Fluids']]
    },
    PA009: {
      'Button battery time-criticality': [],
      'Fistula risk': []
    },
    PA010: {
      'Neonatal collapse diff dx': [],
      'Prostin use': [['Prostin']]
    },
    PT001: {
      'Recognising NAI': [],
      'Safeguarding': []
    },
    PT002: {
      'Apply the NICE head injury rules for children': [],
      'Paeds Head Injury': []
    },
    // ---- CARDIAC ARREST (legacy pair) -------------------------------------------------------
    CA001: {
      'ALS Algorithm': [CPR_ADULT, ['Defib']]
    },
    CA002: {
      // Non-shockable: CPR with ventilation and adrenaline as soon as possible
      'APLS Arrest': [['CPR'], VENTILATE, ['AdrenalineIV']],
      '4Hs 4Ts': []
    },
    // ---- OBSTETRICS -------------------------------------------------------------------------
    OB001: {
      'Cord prolapse management': [['ObstetricManoeuvres'], ['Surgery', 'Delivery']]
    },
    OB002: {
      'HELPERR Mnemonic': [['ObstetricManoeuvres']]
    },
    OB003: {
      'Ectopic recognition': [],
      'Haemorrhage management': [['Blood'], ['Surgery']]
    },
    OB004: {
      // NICE NG133: airway/O2, magnesium, treat severe hypertension
      'Eclampsia management': [['Oxygen', 'Bagging', 'RSI'], MAGNESIUM_ECLAMPSIA, BP_LOWERING],
      'Mag Sulph dosing': [['MagSulph'], ['MagnesiumInfusion']]
    },
    OB005: {
      'AFE recognition': [],
      'Maternal arrest modification': []
    },
    // ---- MORE ADULT MEDICAL -----------------------------------------------------------------
    AM039: {
      "Beck's Triad": [],
      'Electrical Alternans': []
    },
    AM040: {
      'Wellens ECG signs': [],
      'Do not exercise test': []
    },
    AM041: {
      'Bronchial artery anatomy': [],
      'Positioning': []
    },
    AM042: {
      'Brugada ECG types': [],
      'Sodium channel blockers': []
    },
    AM043: {
      'FVC monitoring': [],
      'Cholinergic vs Myasthenic': []
    },
    AM044: {
      'Dissection risk factors': [],
      'Cerebellar signs': []
    },
    AM045: {
      'Alpha before Beta rule': [['Phentolamine']],
      'Catecholamine surge': []
    },
    AM046: {
      'Pituitary anatomy': [],
      'Steroid replacement': [['Hydrocortisone']]
    },
    AM047: {
      'Airway assessment': [],
      'FONA anticipation': []
    },
    AM048: {
      'Travel history': [],
      'Parasitaemia': [],
      'Give IV artesunate': [['Artesunate']]
    },
    AM049: {
      'LRINEC Score': [],
      'Pain out of proportion': []
    },
    // ---- TOXICOLOGY -------------------------------------------------------------------------
    TX001: {
      // High-dose insulin euglycaemia (the HIET button) and IV glucagon
      'HDI protocol': [['HIET']],
      'Glucagon dosing': [['GlucagonIV']]
    },
    TX002: {
      'Digoxin ECG effects': [],
      'Know the indications for digoxin-specific antibody fragments': [['Digibind']]
    },
    TX003: {
      'Iron toxicity stages': [],
      'Opaque pills on X-ray': []
    },
    TX004: {
      // AAGBI LAST: 100% oxygen / airway, lipid emulsion
      'LAST protocol': [['Oxygen', 'Bagging', 'RSI'], ['Lipid']],
      'Lipid dosing': [['Lipid']]
    },
    TX005: {
      'Osmolar gap': [],
      'Give fomepizole and arrange haemodialysis': [['Fomepizole']]
    },
    // ---- MORE ADULT TRAUMA ------------------------------------------------------------------
    AT009: {
      'Tourniquet application': [['Tourniquet']],
      'Amputated part care': []
    },
    AT010: {
      'Recognise compartment syndrome clinically (pain out of proportion)': [],
      'Pain on passive stretch': []
    },
    AT011: {
      'AC vs DC injury': [],
      'Fluid targets in burns': [FLUIDS_ANY]
    },
    AT012: {
      'Suspension syncope': [],
      'Rescue death': []
    },
    AT013: {
      'Occlusive dressing logic': [['ChestSeal']],
      'Drain insertion': [CHEST_DRAIN]
    },
    // ---- MORE PAEDIATRIC --------------------------------------------------------------------
    PA011: {
      'CRASH and Burn criteria': [],
      'Aspirin in paeds': [['Aspirin']]
    },
    PA012: {
      'Acute Chest recognition': [],
      'Analgesia ladder': [OPIOID]
    },
    PA013: {
      // Complete obstruction progressing to arrest: laryngoscopy and Magill forceps
      'Choking algorithm': [['Magills']],
      'Unilateral wheeze': []
    },
    PA014: {
      'Time to theatre (<6hrs)': [['Surgery']],
      'Do not wait for Ultrasound': []
    },
    PA015: {
      "Kocher's Criteria": [],
      'Transient synovitis diff dx': []
    },
    // ---- MORE OBSTETRICS / ELDERLY / ADULT MEDICAL ------------------------------------------
    OB006: {
      '4 Ts of PPH': [],
      'Bimanual compression': [],
      'Give uterotonics and tranexamic acid': [['Oxytocin', 'Ergometrine', 'Carboprost'], ['TXA']]
    },
    OB007: {
      'Ultrasound utility': [],
      'Torsion risk factors': []
    },
    OB008: {
      'PPCM diagnosis': [],
      'Fluid management in failure': [['Furosemide']]
    },
    EL006: {
      'Pain out of proportion': [],
      'Lactate significance': []
    },
    EL007: {
      // BSR: high-dose glucocorticoid now (no prednisolone/methylprednisolone button; either steroid here)
      'GCA symptoms': [],
      'Steroid urgency': [['Hydrocortisone', 'Dexamethasone']]
    },
    AM050: {
      'Glasgow Score for Pancreatitis': [],
      'Fluid sequestration': [FLUIDS_ANY]
    },
    AM051: {
      'Ammonia levels': [],
      'West Haven Criteria': []
    },
    AM052: {
      'SBP diagnosis (Neutrophils >250)': [['AsciticTap']],
      'Albumin indications': [['Albumin']]
    },
    AM053: {
      'Duke Criteria': [],
      'Embolic phenomena': []
    },
    AM054: {
      'Fixed output state': [],
      'Medications to avoid': []
    },
    AM055: {
      'Hypertrophic Cardiomyopathy': [],
      'Screening family': [],
      'Manage a shockable arrest': [['CPR'], ['Defib']]
    },
    AM056: {
      'FBI (Fast Broad Irregular)': [],
      'Contraindicated drugs': []
    },
    AM057: {
      // RCOphth: IV acetazolamide plus topical pressure-lowering drops
      'Fixed mid-dilated pupil': [],
      'IOP reduction': [['Acetazolamide'], ['TopicalEyeDrops']]
    },
    AM058: {
      'Cherry red spot': [],
      'Embolic source': []
    },
    AM059: {
      'Never examine throat': [],
      'Airway strategy': []
    },
    AM060: {
      'Quinsy vs Tonsillitis': [],
      'Drainage technique': []
    },
    AM061: {
      'PJP presentation': [],
      'Exercise desaturation': []
    },
    AM062: {
      'Electrolyte disturbances': [],
      'Rasburicase indications': [['Rasburicase']]
    },
    AM063: {
      'CK levels': [],
      'Myoglobinuria': []
    },
    AM064: {
      'Rate of BP reduction (Max 25% first hour)': [['Labetalol', 'LabetalolInfusion', 'GTNInfusion']]
    },
    AT014: {
      'Blast wave physics': [],
      'Blast lung management': [['Oxygen']]
    },
    AT015: {
      // Exsanguinating (BP 90): permissive hypotension, so no antihypertensive is credited
      'Widened mediastinum': [],
      'BP targets': []
    },
    AT016: {
      'CXR interpretation': [],
      'NGT path': []
    },
    AT017: {
      'Canthotomy technique': [['Canthotomy']],
      'Orbital compartment syndrome': []
    },
    AT018: {
      'Vascular check pre/post reduction': [],
      'Hard signs of ischaemia': []
    },
    AT019: {
      'Skin threat urgency': [['Reduction']],
      'Sedation reduction': [['Reduction'], ['Ketamine', 'Propofol', 'Midazolam']]
    },
    AT020: {
      'Urethral injury signs': [],
      'Retrograde urethrogram': []
    },
    AT021: {
      'Alkali vs Acid': [],
      'Morgan lens': [['Irrigation']]
    },
    AT022: {
      // Suction plus an airway that suits a mid-face fracture (no NPA)
      'Le Fort fractures': [],
      'Airway adjuncts': [['Suction'], ['OPA', 'RSI', 'FONA']]
    },
    AT023: {
      'Impaled object management': [['Surgery']]
    },
    PA016: {
      'VBG interpretation': [],
      'Olive mass': []
    },
    PA017: {
      'Bilious vomiting is red flag': [],
      'Upper GI Contrast': []
    },
    PA018: {
      'CAH pathophysiology': [],
      'Hyperkalaemia in neonate': []
    },
    PA019: {
      'Apnoea management': [['Bagging']],
      'Vaccination history': []
    },
    PA020: {
      'Koplik spots': [],
      'Isolation protocols': []
    },
    PA021: {
      'Ammonia measurement': [],
      'Sepsis mimic': []
    },
    PA022: {
      'Gartland classification': [],
      'Pulse check': []
    },
    PA023: {
      'Bilirubin nomogram': [],
      'Kernicterus signs': []
    },
    PA024: {
      'Lund and Browder': [],
      'Cooling limits': []
    },
    PA025: {
      'Simple vs Complex': [],
      'Meningitis exclusion': []
    },
    OB009: {
      'Do not pull cord': [],
      'Reinvert immediately': [['ObstetricManoeuvres']]
    },
    OB010: {
      'Concealed abruption': [],
      'Pain disproportionate to bleed': []
    },
    OB011: {
      'Painless bleed = Praevia': [],
      'Digital exam contraindication': []
    },
    OB012: {
      "Wernicke's prevention": [['Pabrinex']],
      'PUQE score': []
    },
    OB013: {
      'Breech manoeuvres': [['ObstetricManoeuvres']],
      'Hands off breech': []
    },
    TX006: {
      'Hyperglycaemia in CCB OD': [],
      'Insulin euglycaemia': [['HIET']]
    },
    TX007: {
      'Uncoupling oxidative phosphorylation': [],
      'pH trapping': [['SodiumBicarb']]
    },
    TX008: {
      'Serotonin syndrome features': [],
      'Cooling urgency': [['Cooling']]
    },
    TX009: {
      'Unopposed alpha stimulation': [],
      'Benzo utility': [['Midazolam', 'MidazolamIM', 'Lorazepam', 'LorazepamIM', 'DiazepamIV']]
    },
    TX010: {
      // Swelling beyond the wrist from a hand bite is an antivenom indication (TOXBASE)
      'UK Adder management': [['Splinting'], ['Antivenom']],
      'Antivenom indications': [['Antivenom']]
    },
    TX011: {
      'Non-cardiogenic pulmonary oedema': [],
      'C-spine in drowning': []
    },
    TX012: {
      'Heat stroke vs exhaustion': [],
      'Cooling methods': [['Cooling']]
    },
    PS001: {
      'NMS vs Serotonin Syndrome': [],
      'Lead pipe rigidity': []
    },
    PS002: {
      'Chronic vs Acute toxicity': [],
      'Dialysis indications': []
    },
    PS003: {
      'Benzodiazepine response': [['Lorazepam', 'LorazepamIM']],
      'Waxy flexibility': []
    },
    // ---- CARDIAC ARRESTS --------------------------------------------------------------------
    // Shockable: CPR and defibrillation. Adrenaline and amiodarone are due only after the third
    // shock, which a run with early ROSC never reaches, so they are left to the facilitator.
    CA_A01: {
      'ALS Algorithm': [CPR_ADULT, ['Defib']]
    },
    CA_A02: {
      'Shockable rhythms': [['Defib']]
    },
    CA_A03: {
      'Reversible causes': []
    },
    CA_A04: {
      'Confirmation of death': []
    },
    CA_A05: {
      // RCUK traumatic arrest, penetrating chest: resuscitative thoracotomy and blood
      'Traumatic cardiac arrest algorithm': [['Thoracotomy'], ['Blood']]
    },
    CA_P01: {
      'Paeds Defib Dosing': [['Defib']]
    },
    CA_P02: {
      'Manage a paediatric shockable arrest (4 J/kg)': [['CPR'], ['Defib']]
    },
    CA_P03: {
      'Recognise hypoxia as the cause of paediatric arrest': [VENTILATE]
    },
    CA_P04: {
      'SIDS management': []
    },
    CA_P05: {
      // APLS traumatic arrest: oxygenate/ventilate, volume (blood), decompress the chest
      'Paeds trauma arrest': [VENTILATE, ['Blood', 'Fluids'], TENSION_DECOMPRESSION]
    },
    CA_E01: {
      'ALS in elderly': [CPR_ADULT, ['Defib']]
    },
    CA_E02: {
      'ICD management': []
    },
    CA_E03: {
      'DNACPR decisions': []
    },
    CA_E04: {
      'Recognition of life extinct': []
    },
    CA_E05: {
      'Futility in elderly trauma arrest': []
    },
    // Maternal arrest: no button for manual uterine displacement; resuscitative hysterotomy by 5 min.
    CA_O01: {
      'Maternal Resus': [['CPR'], ['Defib'], ['Hysterotomy']]
    },
    CA_O02: {
      'Defib safety in pregnancy': [['Defib']]
    },
    CA_O03: {
      'AFE management': [['CPR'], ['AdrenalineIV'], ['Hysterotomy']]
    },
    CA_O04: {
      'Eclampsia arrest': [['CPR'], ['AdrenalineIV'], ['Hysterotomy']]
    },
    CA_O05: {
      'Trauma in pregnancy': [['Blood'], ['Hysterotomy']]
    },
    // ---- ADULT MEDICAL: CARDIOLOGY / VASCULAR ----------------------------------------------
    AM065: {
      'Differentiate NSTEMI from STEMI': [],
      'Understand why thrombolysis is not indicated': [],
      'Apply GRACE risk stratification': []
    },
    AM066: {
      'Recognise cardiogenic versus hypovolaemic shock': [],
      'Avoid harmful fluid loading': [],
      'Escalate for mechanical support': [],
      'Start a vasopressor': [['Noradrenaline', 'AdrenalineInfusion', 'Metaraminol']]
    },
    AM067: {
      'Identify adverse features in tachyarrhythmia': [],
      'Perform synchronised cardioversion safely': [['Cardioversion'], PROCEDURAL_SEDATION],
      'Understand sync versus unsynchronised shocks': []
    },
    AM068: {
      'Recognise the six Ps of acute limb ischaemia': [],
      'Understand Rutherford categories': [],
      'Appreciate the revascularisation time window': []
    },
    AM069: {
      // Stridor developing, SpO2 91%: oxygen and dexamethasone while stenting is arranged
      'Recognise SVC obstruction': [],
      'Manage the threatened airway': [['Oxygen'], ['Dexamethasone']],
      'Escalate an oncological emergency': []
    },
    // ---- GASTROINTESTINAL / SURGICAL -------------------------------------------------------
    AM070: {
      'Differentiate variceal from non-variceal bleeding': [],
      'Apply the Glasgow-Blatchford score': [],
      'Activate major haemorrhage appropriately': [['Blood']]
    },
    AM071: {
      'Resuscitate massive GI haemorrhage': [['Blood']],
      'Consider upper GI source in fresh PR bleeding': [],
      'Understand the role of CT angiography': []
    },
    AM072: {
      'Recognise peritonism': [],
      'Resuscitate the surgical abdomen': [['Fluids'], ABDOMINAL_ANTIBIOTIC],
      'Expedite theatre for perforation': [['Surgery']]
    },
    AM073: {
      // SpO2 95%: oxygen not needed; decompression is the source control
      'Recognise infected obstructed system as a urological emergency': [],
      'Understand source control principles': [],
      'Apply the sepsis six': [SEPSIS_ANTIBIOTIC, ['Fluids']]
    },
    // ---- ONCOLOGY / HAEMATOLOGY / IMMUNOLOGY -----------------------------------------------
    AM074: {
      // NICE CG151: piperacillin with tazobactam
      'Recognise neutropenic sepsis in any recent chemotherapy patient': [],
      'Deliver door-to-needle antibiotics within 60 minutes': [['Tazocin']],
      'Avoid delaying treatment for investigations': []
    },
    AM075: {
      'Elicit red flag back pain features': [],
      'Give high dose dexamethasone promptly': [['Dexamethasone']],
      'Arrange urgent whole spine MRI': []
    },
    AM076: {
      'Recognise acute chest syndrome': [],
      'Deliver timely opiate analgesia in sickle crisis': [OPIOID],
      'Escalate for exchange transfusion': [['ExchangeTransfusion']]
    },
    AM077: {
      // Stop the transfusion (no button), keep the line open with saline; antihistamine/steroid are for allergic reactions
      'Distinguish haemolytic reaction from febrile or allergic reactions': [],
      'Follow immediate transfusion reaction steps': [['Fluids']],
      'Understand incident reporting duties': []
    },
    AM078: {
      // Bradykinin angio-oedema: antihistamine and steroid do not work and are never credited.
      // There is no icatibant / C1-esterase inhibitor button; the scorable care is the airway.
      'Distinguish bradykinin angio-oedema from anaphylaxis': [],
      'Recognise limits of adrenaline in this condition': [],
      'Plan a difficult airway with a surgical backup': [['RSI', 'FONA']]
    },
    AM079: {
      'Manage anaphylaxis away from the resus room': [['AdrenalineIM']],
      'Prioritise IM adrenaline and fluids': [['AdrenalineIM'], ['Fluids']],
      'Arrange tryptase sampling and allergy follow-up': []
    },
    // ---- NEUROLOGY / ENDOCRINE / ENT --------------------------------------------------------
    AM080: {
      // Reduced consciousness: IV glucose (IM glucagon without access), not oral
      'Always check glucose in reduced consciousness': [['CheckGlucose']],
      'Choose the right route for glucose replacement': [['Dextrose', 'Glucagon']],
      'Plan safe discharge after sulfonylurea or long-acting insulin': []
    },
    AM081: {
      'Distinguish encephalitis from meningitis': [],
      'Treat empirically before confirmatory tests': [['Aciclovir']],
      'Sequence CT and lumbar puncture safely': []
    },
    AM082: {
      'Risk stratify TIA': [],
      'Start secondary prevention immediately': [['Aspirin']],
      'Recognise indications for admission versus clinic': []
    },
    AM083: {
      'Escalate epistaxis management stepwise': [],
      'Recognise the airway risk of posterior bleeding': [],
      'Manage bleeding on direct oral anticoagulants': [['TXA']]
    },
    AM084: {
      // Symptomatic: needle aspiration (the 'Needle' button) or an ambulatory/Seldinger drain
      'Differentiate primary and secondary pneumothorax': [],
      'Apply symptom-based BTS management': [['Needle', 'SeldingerDrain']],
      'Recognise when a pneumothorax is under tension': []
    },
    // ---- ENVIRONMENTAL / ASPHYXIAL ----------------------------------------------------------
    AM085: {
      'Apply the drowning-modified resuscitation sequence': [],
      'Prioritise oxygenation over circulation': [['Oxygen', 'CPAP', 'NIV', 'Bagging', 'RSI']],
      'Manage associated hypothermia': [['Warming']]
    },
    AM086: {
      'Anticipate delayed airway obstruction after strangulation': [],
      'Screen for vascular and cervical spine injury': [],
      'Integrate psychiatric risk assessment into physical care': []
    },
    AM087: {
      'Recognise cyanide toxicity in fire victims': [],
      'Interpret a raised lactate with normal SpO2': [],
      'Treat empirically without waiting for levels': [['Hydroxocobalamin']]
    },
    AM088: {
      'Recognise neurological decompression illness': [],
      'Understand the role of 100% oxygen': [['Oxygen']],
      'Arrange safe transfer for recompression': [['Hyperbaric']]
    },
    // ---- GERIATRIC MEDICAL ------------------------------------------------------------------
    EL008: {
      'Recognise aspiration risk in frail patients': [],
      'Balance escalation against frailty': [],
      'Communicate treatment goals with relatives': []
    },
    EL009: {
      'Recognise closed loop obstruction risk': [],
      'Correct large third space fluid deficits': [FLUIDS_ANY],
      'Expedite imaging and surgical review': []
    },
    EL010: {
      'Recognise posterior circulation stroke presentations': [],
      'Understand limitations of stroke scales': [],
      'Anticipate cerebellar swelling and hydrocephalus': []
    },
    EL011: {
      'Make and document treatment escalation decisions': [],
      'Communicate ceilings of care compassionately': [],
      'Deliver active symptom control alongside limits': [['Analgesia', 'Fentanyl', 'MorphineIM', 'MorphineOral', 'Midazolam', 'MidazolamIM', 'Paracetamol', 'ParacetamolOral', 'Antiemetic', 'Cyclizine', 'Metoclopramide']]
    },
    EL012: {
      // Transfuse slowly with diuretic cover (TACO prevention)
      'Recognise anaemia causing demand ischaemia': [],
      'Transfuse safely in chronic anaemia': [['Blood']],
      'Prevent transfusion associated circulatory overload': [['Furosemide']]
    },
    EL013: {
      // K+ 6.4 with tented T waves: calcium and insulin/dextrose
      'Identify post-renal AKI': [],
      'Manage hyperkalaemia urgently': HYPERKALAEMIA,
      'Anticipate post-obstructive diuresis and decompression haematuria': []
    },
    // ---- PAEDIATRIC MEDICAL -----------------------------------------------------------------
    PA026: {
      // BTS/SIGN: oxygen, burst nebs, steroid, then IV magnesium
      'Grade paediatric asthma severity': [],
      'Escalate treatment in the correct order': [['Oxygen'], NEBULISED_BRONCHODILATOR, ASTHMA_STEROID, ['MagSulph']],
      'Recognise the exhausted child and the silent chest': []
    },
    PA027: {
      'Distinguish tracheitis from croup and epiglottitis': [],
      'Avoid distressing the child with a critical airway': [],
      'Mobilise the difficult paediatric airway team': []
    },
    PA028: {
      'Assess paediatric dehydration clinically': [],
      'Use weight-based fluid resuscitation': [['Fluids']],
      'Correct sodium abnormalities safely': []
    },
    PA029: {
      // NICE NG195 early-onset sepsis: benzylpenicillin with gentamicin
      'Recognise subtle signs of neonatal sepsis': [],
      'Apply neonatal weight-based dosing': [['Benzylpenicillin'], ['Gentamicin']],
      'Escalate to the neonatal team early': []
    },
    PA030: {
      'Apply NICE traffic light and febrile infant pathways': [],
      'Justify a full septic screen under three months': [],
      'Obtain reliable urine samples in infants': []
    },
    PA031: {
      'Apply BRUE risk stratification': [],
      'Recognise mimics including NAI and pertussis': [],
      'Counsel anxious parents appropriately': []
    },
    PA032: {
      'Recognise shunt malfunction': [],
      'Identify the Cushing reflex': [],
      'Institute neuroprotective measures': [['HypertonicSaline']]
    },
    PA033: {
      'Treat paediatric febrile neutropenia within the golden hour': [['Tazocin']],
      'Sample central and peripheral cultures': [],
      'Recognise rapid decompensation in immunocompromised children': []
    },
    PA034: {
      'Recognise perforated appendicitis in children': [],
      'Provide adequate paediatric analgesia': [OPIOID],
      'Resuscitate before theatre': [['Fluids'], ABDOMINAL_ANTIBIOTIC]
    },
    PA035: {
      'Distinguish cardiac syncope from seizure': [],
      'Calculate and interpret QTc in children': [],
      'Arrange family screening for inherited arrhythmia': []
    },
    PA036: {
      // NLS 2021: thermal care and lung aeration; compressions only if HR < 60 after ventilation
      'Follow the Newborn Life Support algorithm': [['Warming'], ['Bagging']],
      'Prioritise lung aeration over compressions': [['Bagging']],
      'Prevent neonatal heat loss': [['Warming']]
    },
    PA037: {
      'Use correct paediatric adrenaline doses': [['AdrenalineIM']],
      'Recognise and document iatrogenic drug reactions': [],
      'Plan observation for biphasic reactions': []
    },
    // ---- ADULT TRAUMA -----------------------------------------------------------------------
    AT024: {
      // No button for manual uterine displacement / tilt
      'Resuscitate the mother to save the fetus': [['Oxygen'], ['Blood']],
      'Relieve aortocaval compression': [],
      'Recognise concealed placental abruption after trauma': []
    },
    AT025: {
      'Classify transient versus non-responders': [],
      'Use FAST appropriately': [],
      'Decide between angioembolisation and laparotomy': []
    },
    AT026: {
      'Manage eviscerated bowel correctly': [['ClingFilm']],
      'Identify absolute indications for laparotomy': [],
      'Avoid imaging delays in penetrating trauma': []
    },
    AT027: {
      'Use tourniquets correctly and document timing': [['Tourniquet']],
      'Resuscitate catastrophic external haemorrhage': [['Tourniquet'], ['Blood'], ['TXA']],
      'Consider forensic and police liaison duties': []
    },
    AT028: {
      'Identify inhalation injury features': [],
      'Intubate early rather than late': [['RSI']],
      'Calculate burns fluid resuscitation': [FLUIDS_ANY]
    },
    AT029: {
      'Recognise incomplete cord syndromes': [],
      'Understand why CT alone may miss cord injury': [],
      'Maintain spinal cord perfusion pressure': [['Fluids', 'Metaraminol', 'Noradrenaline']]
    },
    AT030: {
      'Recognise open globe injury': [],
      'Avoid manoeuvres that raise intraocular pressure': [['Antiemetic', 'Cyclizine', 'Metoclopramide']],
      'Arrange emergency ophthalmic referral': []
    },
    AT031: {
      'Apply reverse triage in lightning strike': [],
      'Recognise keraunoparalysis as transient': [],
      'Monitor for arrhythmia and rhabdomyolysis': []
    },
    AT032: {
      'Recognise the severity of injection injuries': [],
      'Avoid falsely reassuring discharge': [],
      'Refer urgently to hand surgery': [['Surgery']]
    },
    // ---- PAEDIATRIC TRAUMA ------------------------------------------------------------------
    PT003: {
      'Apply paediatric trauma resuscitation by weight': [['Blood'], ['TXA']],
      'Recognise the Waddell triad': [],
      'Prevent hypothermia in injured children': [['Warming']]
    },
    PT004: {
      'Apply the paediatric drowning algorithm': [VENTILATE, ['CPR']],
      'Justify prolonged resuscitation in hypothermia': [],
      'Consider safeguarding in childhood drowning': []
    },
    PT005: {
      'Appreciate the limits of FAST in children': [],
      'Recognise the handlebar injury pattern': [],
      'Consider NAI where the mechanism does not fit': []
    },
    PT006: {
      'Resuscitate penetrating trauma in adolescents': [['Blood'], ['TXA']],
      'Preserve forensic evidence': [],
      'Fulfil safeguarding duties in youth violence': []
    },
    PT007: {
      'Estimate paediatric burn area accurately': [],
      'Calculate paediatric burns fluids including maintenance': [FLUIDS_ANY],
      'Anticipate airway compromise and hypothermia': []
    },
    // ---- GERIATRIC TRAUMA -------------------------------------------------------------------
    ET001: {
      'Recognise under-triage of silver trauma': [],
      'Interpret vitals in beta-blocked hypertensive patients': [],
      'Lower the threshold for whole body CT': []
    },
    ET002: {
      'Recognise rib fractures as a high mortality injury in the elderly': [],
      'Deliver regional analgesia in chest trauma': [['NerveBlock']],
      'Prevent secondary pneumonia': []
    },
    ET003: {
      'Apply NICE head injury imaging rules for anticoagulated patients': [],
      'Reverse warfarin rapidly and correctly': WARFARIN_REVERSAL,
      'Deliver neuroprotective care while awaiting transfer': []
    },
    // ---- OBSTETRICS & GYNAECOLOGY -----------------------------------------------------------
    OB014: {
      'Recognise severe features of pre-eclampsia': [],
      'Use magnesium for seizure prophylaxis': [MAGNESIUM_ECLAMPSIA],
      'Avoid fluid overload in pre-eclampsia': []
    },
    OB015: {
      'Recognise HELLP without marked hypertension': [],
      'Anticipate DIC and hepatic rupture': [],
      'Coordinate urgent multidisciplinary delivery': []
    },
    OB016: {
      'Recognise sepsis masked by maternal physiology': [],
      'Prioritise antibiotics and source control': [SEPSIS_ANTIBIOTIC, ['Delivery', 'Surgery']],
      'Use the maternal early warning score': []
    },
    OB017: {
      'Recognise and treat cervical shock': [],
      'Resuscitate early pregnancy haemorrhage': [['Fluids', 'Blood']],
      'Deliver compassionate care in pregnancy loss': []
    },
    OB018: {
      'Recognise severe OHSS': [],
      'Understand intravascular depletion with oedema': [],
      'Prevent thromboembolism in OHSS': [['Heparin']]
    },
    OB019: {
      'Recognise complicated PID': [],
      'Arrange source control for pelvic abscess': [['Surgery']],
      'Address sexual health and safeguarding sensitively': []
    },
    OB020: {
      'Conduct a normal delivery in the ED': [['Delivery']],
      'Prepare simultaneously for two patients': [],
      'Anticipate and prevent postpartum haemorrhage': [['Oxytocin']]
    },
    OB021: {
      'Recognise why standard PE rules fail in pregnancy': [],
      'Anticoagulate empirically when suspicion is high': [['Heparin']],
      'Counsel on imaging radiation risk': []
    },
    // ---- TOXICOLOGY -------------------------------------------------------------------------
    TX013: {
      // GCS 8, RR 8, ETCO2 7.5: open the airway and support ventilation
      'Manage sedative overdose supportively': [['Manoeuvres', 'OPA', 'NPA', 'i-gel', 'RSI'], VENTILATE],
      'Understand the hazards of flumazenil': [],
      'Screen for co-ingestants': []
    },
    TX014: {
      'Recognise the GHB coma and agitation cycle': [],
      'Avoid unnecessary intubation where recovery is rapid': [],
      'Consider drink spiking and sexual assault': []
    },
    TX015: {
      'Measure and interpret QTc after overdose': [],
      'Prevent and treat torsades de pointes': [['MagSulph']],
      'Determine safe monitoring duration': []
    },
    TX016: {
      'Recognise metformin associated lactic acidosis': [],
      'Understand sick day rules for metformin': [],
      'Escalate for extracorporeal removal': []
    },
    TX017: {
      // Glucose (octreotide has no button); glucagon is not credited in sulfonylurea toxicity
      'Recognise one-pill-can-kill toxins in children': [],
      'Treat recurrent sulfonylurea hypoglycaemia': [['Dextrose', 'GlucoseOral']],
      'Explore accidental ingestion and safeguarding': []
    },
    TX018: {
      'Manage caustic ingestion correctly': [],
      'Recognise contraindicated decontamination steps': [],
      'Anticipate airway oedema and later stricture': []
    },
    TX019: {
      // Glycogen-depleted: glucose, not glucagon
      'Recognise alcohol-induced hypoglycaemia in children': [['CheckGlucose'], ['Dextrose']],
      // GCS 9 and vomiting: nothing by mouth
      'Avoid anchoring on intoxication': [],
      'Fulfil safeguarding duties for intoxicated minors': []
    },
    TX020: {
      // PCC only if the bleed is major, which is the facilitator's call here
      'Grade bleeding severity to guide reversal': [],
      'Choose PCC over FFP for warfarin reversal': [],
      'Recognise common warfarin drug interactions': []
    },
    TX021: {
      'Manage acute agitation safely': [AGITATION_SEDATION],
      'Recognise risks of prolonged restraint': [],
      'Treat hyperthermia and rhabdomyolysis': [['Cooling'], FLUIDS_ANY]
    },
    TX022: {
      'Calculate and interpret the osmolar gap': [],
      'Treat toxic alcohol ingestion promptly': [['Fomepizole'], ['SodiumBicarb']],
      'Recognise visual loss as an indication for urgent dialysis': []
    },
    // ---- PSYCHIATRIC / MENTAL HEALTH --------------------------------------------------------
    PS004: {
      'Assess suicide risk in adolescents': [],
      'Apply Gillick competence and confidentiality limits': [],
      'Arrange mandatory CAMHS assessment': []
    },
    PS005: {
      'Apply MEED risk criteria': [],
      'Recognise and prevent refeeding syndrome': [['Pabrinex']],
      'Balance capacity, consent and compulsory treatment': []
    },
    PS006: {
      'Recognise acute behavioural disturbance as a medical emergency': [],
      'Sedate safely and monitor afterwards': [['Midazolam', 'MidazolamIM', 'Ketamine', 'KetamineIM', 'Lorazepam', 'LorazepamIM']],
      'Avoid prone restraint asphyxia': []
    },
    PS007: {
      'Exclude organic causes of new psychosis': [],
      'Take a structured collateral history': [],
      'Refer to early intervention services': []
    },
    PS008: {
      'Perform a structured suicide risk assessment': [],
      'Apply capacity and Mental Health Act frameworks': [],
      'Arrange safe observation in the ED': []
    },
    PS009: {
      'Distinguish delirium from dementia': [],
      'Systematically search for precipitants': [],
      'Use non-pharmacological management first': []
    },
    PS010: {
      'Understand the scope and limits of Section 136': [],
      'Perform and document a capacity assessment': [],
      'Distinguish the Mental Health Act from the Mental Capacity Act': []
    }
  };
})();

// Enriches a single raw scenario with equipment, guideline links, investigations and evolution
// trends. Exposed separately from processScenarios so that Builder/Custom scenarios — which are
// created at runtime and never pass through RAW_SCENARIOS — reach the live observations screen
// with the same fully populated shape as the premade library.
window.enrichScenario = function (s) {
  if (!s || _typeof(s) !== 'object') {
    console.warn('Skipping malformed scenario: expected an object.', s);
    return null;
  }
  var title = typeof s.title === 'string' ? s.title : '';
  // Restricted and hand-written scenarios may state just `rhythm` (a registry label) instead of an
  // `ecg` block; without this the patient started in sinus rhythm whatever was authored.
  // An unrecognised label is ignored (the heart-rate-derived sinus default applies) rather than
  // starting the monitor on a rhythm it cannot draw.
  var authoredRhythm = typeof s.rhythm === 'string' && s.rhythm.trim() && window.RHYTHMS && window.RHYTHMS.isKnown(s.rhythm.trim()) ? s.rhythm.trim() : null;
  var sourceEcg = s.ecg && _typeof(s.ecg) === 'object' ? s.ecg : authoredRhythm ? {
    type: authoredRhythm,
    findings: window.RHYTHMS.labelFor(authoredRhythm)
  } : null;
  var sourceChestXray = s.chestXray && _typeof(s.chestXray) === 'object' ? s.chestXray : null;
  var sourceEvolution = s.evolution && _typeof(s.evolution) === 'object' ? s.evolution : {};
  var _window = window,
    generateUrine = _window.generateUrine,
    generatePocus = _window.generatePocus,
    generateCT = _window.generateCT,
    generateVbg = _window.generateVbg; // Ensure these are available
  // Materialise the authored clinical VBG state once. This stable baseline is then updated by
  // improve/deteriorate triggers and used for repeat gases rather than being regenerated each reveal.
  var baseVbg = s.vbg || (s.vbgClinicalState && generateVbg ? generateVbg(s.vbgClinicalState) : null);
  // The gas glucose is the scenario's own capillary glucose when one is authored (a hypoglycaemia
  // or DKA scenario must not show a VBG glucose that disagrees with its BM). An authored VBG wins.
  var authoredObs = _objectSpread(_objectSpread({}, s.vitalsMod && _typeof(s.vitalsMod) === 'object' ? s.vitalsMod : {}), s.vitals && _typeof(s.vitals) === 'object' ? s.vitals : {});
  var authoredBm = authoredObs.bm === undefined || authoredObs.bm === null || authoredObs.bm === '' ? NaN : Number(authoredObs.bm);
  if (!s.vbg && Number.isFinite(authoredBm)) baseVbg = _objectSpread(_objectSpread({}, baseVbg || {
    pH: 7.4,
    Lac: 1.0,
    K: 4.0,
    Glu: 5.5,
    pCO2: 5.0,
    pO2: 12.0,
    BE: 0,
    HCO3: 24
  }), {}, {
    Glu: authoredBm
  });
  // No authored ECG: a sinus rhythm named from the authored heart rate (tachycardia/bradycardia),
  // using a representative age. generatePatientFromTemplate renames it for the actual patient.
  var representativeAge = function () {
    var a = s.patientAge === undefined || s.patientAge === null || s.patientAge === '' ? NaN : Number(s.patientAge);
    if (Number.isFinite(a)) return a;
    if (s.ageRange === 'Paediatric') {
      try {
        return typeof s.ageGenerator === 'function' ? s.ageGenerator() : 5;
      } catch (e) {
        return 5;
      }
    }
    return 40;
  }();
  var defaultEcg = function defaultEcg() {
    return window.sinusEcgForHr ? window.sinusEcgForHr(authoredObs.hr, representativeAge) : {
      type: 'Sinus Rhythm',
      findings: 'Normal sinus rhythm'
    };
  };

  // ECG rhythm name normalisation — maps shorthand/non-canonical names to the strings
  // that components.js precomputes waveforms for.
  var ECG_RHYTHM_NORM = {
    'Sinus Tachy': 'Sinus Tachycardia',
    'Sinus Brady': 'Sinus Bradycardia',
    '1st Deg Block': '1st Deg Heart Block',
    '3rd Deg Block': 'Complete Heart Block',
    // The registry now has a real STEMI morphology (coved ST elevation), so the
    // monitoring trace shows the ST changes instead of being downgraded to plain sinus tachy.
    // investigations.ecg keeps the ORIGINAL un-normalised type, so the 12-lead canvas is
    // unaffected.
    'NSR': 'Sinus Rhythm',
    'Normal Sinus': 'Sinus Rhythm'
  };
  // Normalisation is delegated to the shared rhythm registry, which knows every
  // alias. The small local table above only survives for the two SCENARIO-LEVEL decisions the
  // registry cannot make: STEMI is shown via the 12-lead canvas rather than a monitoring-trace
  // morphology, and a scenario titled "Pulseless VT" means pVT (pulseless, shockable), not
  // VT-with-a-pulse. Everything else resolves through RHYTHMS.canonical().
  var normEcgType = function normEcgType(t) {
    var mapped = ECG_RHYTHM_NORM[t] || t;
    if (/\bpulseless\b/i.test(title) && window.RHYTHMS && window.RHYTHMS.canonical(mapped) === 'VT') return 'pVT';
    return window.RHYTHMS && window.RHYTHMS.isKnown(mapped) ? window.RHYTHMS.canonical(mapped) : mapped;
  };
  {
    var _s$instructorBrief, _s$instructorBrief2;
    var kit = ['Monitoring', 'IV Access'];
    var links = [];
    if (s.acuity === 'Resus') kit = [].concat(_toConsumableArray(kit), ['Defibrillator', 'Airway Trolley', 'Drugs Bag', 'IO Drill', 'Ultrasound']);
    if (s.category === 'Trauma') kit = [].concat(_toConsumableArray(kit), ['Pelvic Binder', 'Splints', 'TXA', 'Blood Warmer']);
    if (s.ageRange === 'Paediatric') kit = [].concat(_toConsumableArray(kit), ['Broselow Tape', 'Paeds Drug Calc']);
    if (s.category === 'Obstetrics & Gynae') kit = [].concat(_toConsumableArray(kit), ['Obs Delivery Pack', 'Neonatal Resuscitaire']);
    if (s.ageRange === 'Paediatric') {
      links.push({
        label: 'RCUK Paeds Guidelines 2025',
        url: 'https://www.resus.org.uk/professional-library/2025-resuscitation-guidelines'
      });
      links.push({
        label: 'APLS Algorithms',
        url: 'https://www.resus.org.uk/sites/default/files/2025-07/RCUK%20Paediatric%20emergency%20algorithms%20and%20resources%20Jul%2025%20V3.1.pdf'
      });
    } else {
      links.push({
        label: 'RCUK Adult ALS 2025',
        url: 'https://www.resus.org.uk/professional-library/2025-resuscitation-guidelines/adult-advanced-life-support-guidelines'
      });
      // DAS only where the airway is part of the scenario (not, for example, SVT or STEMI)
      var airwayKeys = ['RSI', 'i-gel', 'FONA', 'VideoLaryngoscopy', 'Bougie', 'FailedIntubation', 'CICO'];
      if ((s.recommendedActions || []).concat(s.stabilisers || []).some(function (k) {
        return airwayKeys.includes(k);
      })) links.push({
        label: 'DAS Intubation 2025',
        url: 'https://das.uk.com/new-das-2025-intubation-guidelines/'
      });
    }
    if (s.category === 'Trauma') links.push({
      label: 'NICE Trauma (NG39)',
      url: 'https://www.nice.org.uk/guidance/ng39'
    });
    if (s.category === 'Toxicology') links.push({
      label: 'TOXBASE',
      url: 'https://www.toxbase.org/'
    });
    if (title.includes('Sepsis')) links.push({
      label: 'Sepsis Trust Tools',
      url: 'https://sepsistrust.org/professional-resources/clinical-tools/'
    });
    if (s.category === 'Obstetrics & Gynae') links.push({
      label: 'RCOG Guidelines',
      url: 'https://www.rcog.org.uk/guidance/browse-all-guidance/'
    });

    // --- FIX: Auto-Correct Clinical Keys ---
    var mapKeys = function mapKeys(list) {
      return Array.isArray(list) ? list.map(function (item) {
        if (item === 'Adrenaline') return s.acuity === 'Resus' && !title.includes('Anaphylaxis') ? 'AdrenalineIV' : 'AdrenalineIM';
        if (item === 'Magnesium') return 'MagSulph';
        if (item === 'Amio') return 'Amiodarone';
        if (item === 'Calcium') return 'Calcium';
        return item;
      }) : [];
    };
    var safeRecommended = mapKeys(s.recommendedActions || []);
    var safeStabilisers = mapKeys(s.stabilisers || []);

    // --- INTELLIGENT INVESTIGATIONS GENERATION ---
    // Only a urinary source gets a UTI dipstick ("Sepsis" alone also matched pneumonia,
    // meningococcal, neutropenic and neonatal sepsis).
    var baseUrine = "normal";
    if (/\bUTI\b|Pyelo|Urosepsis|Infected Kidney/i.test(title)) baseUrine = "uti";
    if (title.includes("DKA")) baseUrine = "dka";
    // HHS: heavy glycosuria with little or no ketonuria — that distinction is the teaching point.
    if (title.includes("HHS")) baseUrine = "hhs";
    if (title.includes("Rhabdo")) baseUrine = "rhabdo";
    // Pregnant patients outside the O&G category (trauma in pregnancy, obstetric arrests) too.
    if (s.category === 'Obstetrics & Gynae' || /Ectopic|Pregnan|Obstetric/i.test(title)) baseUrine = "pregnancy";
    // Gynaecological diagnoses that are not pregnancies.
    if (/Ovarian Torsion|Tubo-ovarian/i.test(title)) baseUrine = "normal";
    var basePocus = "normal";
    if (title.includes("Tamponade")) basePocus = "tamponade";
    // A stab wound means a pneumothorax only when it is in the chest (not the abdomen or flank).
    if (title.includes("Pneumothorax") || /\bStab/i.test(title) && /Chest|Thora/i.test(title)) basePocus = "pneumothorax";
    if (/Pulmonary Oedema|Heart Failure/i.test(title)) basePocus = "pulmonary_oedema";
    if (title.includes("AAA")) basePocus = "ruptured_aaa";
    if (title.includes("Ectopic")) basePocus = "ectopic";
    if (title.includes("Embolism")) basePocus = "pe";
    var baseCT = "normal";
    if (title.includes("Subarachnoid")) baseCT = "sah";
    // "Heat Stroke" is a hyperthermic emergency, not a cerebrovascular one — the bare substring match
    // gave it an intracerebral haemorrhage CT report, a clinically wrong teaching artefact.
    if (/\bstroke\b/i.test(title) && !/\bheat\b/i.test(title)) {
      baseCT = /\bisch/i.test(title) ? "stroke_isch" : "stroke_haem";
    }
    if (title.includes("Subdural")) baseCT = "subdural";
    if (title.includes("Extradural") || title.includes("Head") && s.category === 'Trauma') baseCT = "extradural";
    // A CTPA with thrombus is a PULMONARY embolism finding only: amniotic fluid embolism is a
    // clinical diagnosis in a peri-arrest patient, not a filling defect.
    if (/Pulmonary Embolism/i.test(title)) baseCT = "pe";
    if (/Aortic Dissection/i.test(title)) baseCT = "dissection";
    if (title.includes("Pancreatitis")) baseCT = "pancreatitis";
    // "Ischaemia" used to map here too, which gave NSTEMI, acute limb ischaemia and mesenteric
    // ischaemia a CT report of a perforated duodenum. Those scenarios now have their own results.
    if (title.includes("Perforation")) baseCT = "perf";

    // Override existing or generate new
    var fallbackEcg = sourceEcg ? null : defaultEcg();
    var investigations = {
      urine: s.urine || (generateUrine ? generateUrine(baseUrine) : {
        findings: "Urinalysis: Normal. No leucocytes, nitrites or blood."
      }),
      pocus: s.pocus || (generatePocus ? generatePocus(basePocus) : {
        findings: "POCUS: No free fluid. Normal lung sliding."
      }),
      ct: s.ct || (generateCT ? {
        findings: generateCT(baseCT)
      } : {
        findings: "CT Head: No acute intracranial abnormality."
      }),
      ecg: sourceEcg || _objectSpread({}, fallbackEcg),
      chestXray: sourceChestXray || {
        findings: "CXR: Lung fields clear. No cardiomegaly."
      },
      vbg: baseVbg || {
        pH: 7.4,
        Lac: 1.0,
        K: 4.0,
        Glu: 5.5,
        pCO2: 5.0,
        pO2: 12.0,
        BE: 0,
        HCO3: 24
      }
    };
    // Results a restricted/custom scenario authors itself (`investigations: { ecg, cxr, ct, … }`)
    // win over the generated ones. `cxr` is accepted for `chestXray`; the VBG is resolved above.
    if (s.investigations && _typeof(s.investigations) === 'object' && !Array.isArray(s.investigations)) {
      Object.keys(s.investigations).forEach(function (k) {
        var v = s.investigations[k];
        if (v === undefined || v === null || k === 'vbg') return;
        var key = k === 'cxr' ? 'chestXray' : k;
        var authored = typeof v === 'string' ? {
          findings: v
        } : v;
        if (key === 'ecg') {
          // Keep the rhythm type; an authored report is no longer a provisional default.
          var merged = _objectSpread(_objectSpread({}, investigations.ecg || {}), authored);
          delete merged.derivedFromHr;
          investigations.ecg = merged;
        } else investigations[key] = authored;
      });
    }
    // Real images and specific reports for this scenario (data/investigations.js).
    var INV = window.INVESTIGATIONS;
    if (INV) investigations = INV.applyScenarioResults(s.id, investigations);
    var mappedTopLevel = {};
    if (INV && INV.SCENARIO_RESULTS[s.id]) {
      ['X-ray', 'CT', 'POCUS'].forEach(function (type) {
        if (INV.SCENARIO_RESULTS[s.id][type]) mappedTopLevel[INV.KEY[type]] = investigations[INV.KEY[type]];
      });
    }
    // Resolve ONE authoritative VBG baseline and use it for BOTH the investigations block
    // and the top-level scenario.vbg. They can no longer disagree, and scenario.vbg is never
    // null, so nothing downstream can substitute generateVbg('normal') for authored values.
    var resolvedVbg = investigations.vbg;

    // --- Evolution Logic (Trends) ---
    // Built from the AUTHORED evolution only. Spreading the whole scenario in here put its starting
    // `vitals` into evolution.improved/deteriorated.vitals, so for a Builder, custom or restricted
    // scenario (which author `vitals`) Improve and Deteriorate trended straight back to the
    // starting obs. With no authored targets the engine uses its relative improve/worsen.
    var pickEvolution = function pickEvolution(e) {
      return e && _typeof(e) === 'object' && !Array.isArray(e) ? _objectSpread({}, e) : {};
    };
    var improved = pickEvolution(sourceEvolution.improved);
    var deteriorated = pickEvolution(sourceEvolution.deteriorated);

    // 1. Dynamic Chest X-ray
    if (sourceChestXray) {
      var newCXR = typeof sourceChestXray.findings === 'string' ? sourceChestXray.findings : '';
      if (newCXR.includes("Pneumothorax") || title.includes("Pneumothorax") || /\bStab/i.test(title) && /Chest|Thora/i.test(title)) {
        newCXR = "Intercostal drain seen in good position. Lung re-expanded. No residual pneumothorax.";
      } else if (newCXR.includes("tube") || title.includes("Intubation")) {
        newCXR = "ETT tip in good position above carina. Lung fields clear.";
      } else if (newCXR.includes("Normal")) {
        newCXR = "Remains Normal.";
      } else {
        newCXR = "Findings unchanged (radiological lag).";
      }
      improved.chestXray = {
        findings: newCXR
      };
      deteriorated.chestXray = {
        findings: "".concat(newCXR, " Worsening appearance.").trim()
      };
    }

    // 2. Dynamic ECG
    if (sourceEcg) {
      var newECG = sourceEcg.findings || "Normal";
      var newType = sourceEcg.type;
      if (sourceEcg.type === "STEMI") {
        newECG = "ST segments resolving. Q waves developing.";
        newType = "Sinus Rhythm (Post-MI)";
      } else if (["VT", "VF", "SVT", "AF"].includes(sourceEcg.type)) {
        newECG = "Reverted to Sinus Rhythm.";
        newType = "Sinus Rhythm";
      } else if (title.includes("Hyperkalaemia")) {
        newECG = "T waves normalising. QRS narrowing.";
      }
      improved.ecg = {
        type: newType,
        findings: newECG
      };
      deteriorated.ecg = {
        type: sourceEcg.type,
        findings: "Worsening changes / arrhythmia persists."
      };
    }

    // Dynamic VBG is calculated at investigation reveal from vbgClinicalState/current state.

    // Normalise the top-level ecg.type so state.rhythm starts with a canonical value.
    // The original type is preserved inside investigations.ecg for 12-lead ST-elevation logic.
    var normalisedEcg = sourceEcg ? _objectSpread(_objectSpread({}, sourceEcg), {}, {
      type: normEcgType(sourceEcg.type)
    }) : fallbackEcg;
    return _objectSpread(_objectSpread(_objectSpread({}, s), {}, {
      ecg: normalisedEcg,
      // Top-level learningObjectives (the restricted-scenario shape) and the brief's own, merged.
      learningObjectives: _toConsumableArray(new Set([].concat(_toConsumableArray(Array.isArray(s.learningObjectives) ? s.learningObjectives : []), _toConsumableArray(Array.isArray((_s$instructorBrief = s.instructorBrief) === null || _s$instructorBrief === void 0 ? void 0 : _s$instructorBrief.learningObjectives) ? s.instructorBrief.learningObjectives : [])))),
      recommendedActions: safeRecommended,
      stabilisers: safeStabilisers,
      equipment: ((_s$instructorBrief2 = s.instructorBrief) === null || _s$instructorBrief2 === void 0 ? void 0 : _s$instructorBrief2.equipment) || kit,
      learningLinks: s.learningLinks || links,
      vbg: resolvedVbg
    }, mappedTopLevel), {}, {
      investigations: investigations,
      // ATTACH GENERATED INVESTIGATIONS (ecg preserved with original type)
      evolution: {
        improved: improved,
        deteriorated: deteriorated
      }
    });
  }
};
window.processScenarios = function () {
  return (window.RAW_SCENARIOS || []).reduce(function (processed, scenario, index) {
    try {
      var enriched = window.enrichScenario(scenario);
      if (enriched) processed.push(enriched);else console.warn("Skipping malformed scenario at index ".concat(index, "."));
    } catch (error) {
      console.warn("Skipping malformed scenario at index ".concat(index, ":"), error);
    }
    return processed;
  }, []);
};
window.ALL_SCENARIOS = function () {
  try {
    return window.processScenarios();
  } catch (error) {
    console.warn('Scenario processing failed; starting with no premade scenarios.', error);
    return [];
  }
}();